var _defs, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFondoHomeD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1420.3 516.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke-width: 80px;\n      }\n\n      .st0, .st1, .st2, .st3, .st4, .st5, .st6, .st7, .st8, .st9, .st10 {\n        stroke-linejoin: round;\n      }\n\n      .st0, .st1, .st2, .st3, .st4, .st5, .st7, .st9 {\n        stroke-linecap: round;\n      }\n\n      .st0, .st11, .st3, .st12, .st5, .st7, .st9, .st13 {\n        fill: none;\n      }\n\n      .st0, .st4, .st5, .st6, .st8, .st9, .st10 {\n        stroke: #fff;\n      }\n\n      .st14 {\n        fill: #373a3a;\n      }\n\n      .st15, .st6 {\n        fill: #399;\n      }\n\n      .st1, .st2, .st16, .st3, .st17, .st12, .st18, .st13, .st19 {\n        stroke: #0f1320;\n      }\n\n      .st1, .st16, .st20 {\n        fill: #fff;\n      }\n\n      .st2, .st17, .st4, .st12, .st5, .st6, .st8, .st10 {\n        stroke-width: 1.5px;\n      }\n\n      .st21, .st18, .st8 {\n        fill: #fbb93e;\n      }\n\n      .st3 {\n        stroke-width: .5px;\n      }\n\n      .st17 {\n        fill: #d7dce0;\n      }\n\n      .st22 {\n        fill: #5f646b;\n      }\n\n      .st23 {\n        isolation: isolate;\n        opacity: .8;\n      }\n\n      .st7 {\n        stroke: #000;\n        stroke-width: 76px;\n      }\n\n      .st9 {\n        stroke-dasharray: 40 100;\n        stroke-width: 3px;\n      }\n\n      .st24 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    x: 2.5,
    y: 10.2,
    width: 1412,
    height: 501,
    rx: 24.4,
    ry: 24.4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -22.1,
    y: -11.6,
    width: 1578.1,
    height: 540.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M570.2,249.1L146.3,6.2-209.8,206.1l352.6,205M570.2,249.1l466.9,270.6M570.2,249.1l309.3-176.6M570.2,249.1l-349.5,207.2M1037.1,519.7l-348,202.5L220.7,456.4M1037.1,519.7l307.5-175M879.5,72.6l309.3-176.6,463.3,273.7-307.5,175M879.5,72.6l465.1,272.1M220.7,456.4l-77.9-45.3M142.8,411.1l-274.7,156.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M570.2,249.1L146.3,6.2-209.8,206.1l352.6,205M570.2,249.1l466.9,270.6M570.2,249.1l309.3-176.6M570.2,249.1l-349.5,207.2M1037.1,519.7l-348,202.5L220.7,456.4M1037.1,519.7l307.5-175M879.5,72.6l309.3-176.6,463.3,273.7-307.5,175M879.5,72.6l465.1,272.1M220.7,456.4l-77.9-45.3M142.8,411.1l-274.7,156.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M570.2,249.1L146.3,6.2-209.8,206.1l352.6,205M570.2,249.1l466.9,270.6M570.2,249.1l309.3-176.6M570.2,249.1l-349.5,207.2M1037.1,519.7l-348,204L220.7,456.3M1037.1,519.7l307.5-175M879.5,72.6l309.3-176.6,463.3,273.7-307.5,175M879.5,72.6l465.1,272.1M220.7,456.4l-77.9-45.3M142.8,411.1l-274.7,156.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-71.4,310.9h0s-.3-.2-.4-.3c-2.3-1.3-4.1-.2-4.1,2.4h0l-23.6-13.5h0v-.5c-.2-2.5-1.9-5.2-3.9-6.5-.5-.3-.9-.6-2.8.2-.9.3-1.4,1.2-1.4,2.1h0l-4.1-2.4v-12c0-1.9.9-3.2,2.2-4,3.4-2,10-.9,14.8,1.9,9.2,5.3,16,13,21.1,23.3,1.1,2.1,2.6,4,4.2,5.2l3.1,2.3c2.1,1.5,3.7,4.5,3.7,7v5.2l-5.1-3v-.3c0-.5,0-1-.2-1.5-.5-2.1-1.8-4.2-3.5-5.4h0v-.2h0ZM-82.2,298.1c.9.6,2-.4,1.5-1.3-7.2-12.4-17.6-17.8-20.7-18.1-1.1,0-2.1.2-2.8.6-1,.6-1.1,1.9-.2,2.7,3.7,3.3,5.9,4.7,22.3,16.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-73.6,265.5c9.4,5.4,16.3,13.2,21.5,23.7,1.1,2.2,2.6,4.1,4.3,5.3l3.2,2.3c2.1,1.5,3.8,4.6,3.8,7.1v4.9l-7.2,4.2h0l-14,8.1v-4.9c0-2.5-1.6-5.5-3.8-7.1l-3.2-2.3c-1.7-1.2-3.2-3.1-4.3-5.3-5.2-10.5-12.2-18.3-21.5-23.7-4.8-2.8-11.6-3.9-15.1-1.9l21.2-12.2c2.5-1.5,9.9-1.1,15.1,1.9h0ZM-71.9,298.1c.3.7,1.2,1,1.8.6,4.6-2.7,11.6-6.8,14.2-8.3.6-.3.8-1.1.5-1.7-1.4-2.6-5.1-9.3-8.7-12.7-.4-.4-1-.5-1.5-.2-3.3,1.7-11.4,6.3-14.7,8.1-.7.4-.9,1.3-.4,1.9,2,2.4,6.7,8.1,8.7,12.3h0ZM-58.3,316.3l14.4-8.3c.3-.2.6-.5.9-1,.2-.4.4-.9.4-1.3,0-.9-.5-1.3-1.2-.9l-14.4,8.3c-.3.2-.6.5-.9,1-.2.4-.4.9-.4,1.3,0,.9.5,1.3,1.2.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-105.9,293.7h0c.7-.4,1.6-.3,2.7.3,1.7,1,3.1,3,3.6,5v.5h0v1.3c0,1.2-.4,2.1-1.1,2.5h0c-.7.4-1.7.4-2.8-.2-2.1-1.2-3.9-4.3-3.9-6.8s.4-2.1,1.1-2.5h.4ZM-102,299.1c0-.8-.5-1.7-1.2-2.1s-1.2,0-1.2.7.5,1.7,1.2,2.1,1.2,0,1.2-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M-103.5,292.3l-2.4,1.4c.7-.4,1.6-.3,2.7.3,1.7,1,3.1,3,3.6,5-.2-2.5-1.9-5.4-4-6.7h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104.3,279.3c-1,.6-1.1,1.9-.2,2.7,3.7,3.3,5.9,4.7,22.3,16.1.9.6,2-.4,1.5-1.3-7.2-12.4-17.6-17.8-20.7-18.1-1.1,0-2.1.2-2.8.6h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-104.4,297.7c0,.8.5,1.7,1.2,2.1s1.2,0,1.2-.7-.5-1.7-1.2-2.1-1.2,0-1.2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M-100.4,303.2l2.7-1.5c.3-.2.5-.4.7-.7l-2.4-1.4v1.2c0,1.2-.4,2.1-1.1,2.5h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-80.3,283.9c-.7.4-.9,1.3-.4,1.9,2,2.4,6.7,8.1,8.7,12.3.3.7,1.2,1,1.8.6,4.6-2.7,11.6-6.8,14.2-8.3.6-.3.8-1.1.5-1.7-1.4-2.6-5.1-9.3-8.7-12.7-.4-.4-1-.5-1.5-.2-3.3,1.7-11.4,6.3-14.7,8.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-73.8,312.2h0c.7-.4,1.7-.3,2.7.3,1.3.8,2.5,2.2,3.2,3.8,0,.5.2,1,.2,1.5h0l.4.3v1.2c0,1.2-.4,2.1-1.1,2.5h0c-.7.4-1.7.4-2.8-.2-2.1-1.2-3.9-4.3-3.9-6.7s.4-2.1,1.1-2.5h0v-.2h.2ZM-69.9,317.7c0-.8-.5-1.7-1.2-2.1s-1.2,0-1.2.7.5,1.7,1.2,2.1,1.2,0,1.2-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M-71.4,310.8l-2.4,1.4c.7-.4,1.7-.3,2.7.3,1.3.8,2.5,2.2,3.2,3.8-.5-2.1-1.9-4.3-3.6-5.5q-.2-.1,0,0h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-72.3,316.3c0,.8.5,1.7,1.2,2.1s1.2,0,1.2-.7-.5-1.7-1.2-2.1-1.2,0-1.2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M-68.3,321.7l2.7-1.6c.3-.2.5-.4.7-.7l-2.4-1.4v1.2c0,1.2-.4,2.1-1.1,2.5h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-59.1,314.1c-.2.4-.4.9-.4,1.3,0,.9.5,1.3,1.2.9l14.4-8.3c.3-.2.6-.5.9-1,.2-.4.4-.9.4-1.3,0-.9-.5-1.3-1.2-.9l-14.4,8.3c-.3.2-.6.5-.9,1h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-100.4,303.2c.7-.4,1.1-1.3,1.1-2.5v-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-105.9,293.7c-.7.4-1.1,1.3-1.1,2.5,0,2.5,1.7,5.5,3.9,6.8,1.1.6,2.1.7,2.8.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-99.5,299h0c-.6-2-2-4.1-3.6-5-1.1-.6-2-.7-2.7-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-102,299.1c0-.8-.5-1.7-1.2-2.1s-1.2,0-1.2.7.5,1.7,1.2,2.1,1.2,0,1.2-.7Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "-105.9 293.7 -103.5 292.3 -103.5 292.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-97,300.9h0c-.2.3-.4.5-.7.7l-2.8,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-68.3,321.7c.7-.4,1.1-1.3,1.1-2.5v-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-73.8,312.2c-.7.4-1.1,1.3-1.1,2.5,0,2.5,1.7,5.5,3.9,6.7,1.1.6,2.1.7,2.8.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-67.8,316.3h0c-.7-1.6-1.9-3-3.2-3.8-1.1-.6-2-.7-2.7-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-69.9,317.7c0-.8-.5-1.7-1.2-2.1s-1.2,0-1.2.7.5,1.7,1.2,2.1,1.2,0,1.2-.7Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: -73.8,
    y1: 312.2,
    x2: -71.4,
    y2: 310.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-64.9,319.4c-.2.3-.4.5-.7.7l-2.8,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-109.9,275.8c-1.4.8-2.3,2.1-2.3,4v12.2l4.3,2.5h0c0-2.7,1.9-3.8,4.2-2.5h.2c2.1,1.3,3.8,4.2,4,6.7v.5h0l23.5,13.6h0c0-2.7,1.9-3.8,4.2-2.5,0,0,.3.2.4.3h0c1.7,1.2,3.1,3.4,3.6,5.5,0,.5.2,1,.2,1.5h0l5.6,3.3v-4.9c0-2.5-1.6-5.5-3.8-7.1l-3.2-2.3c-1.7-1.2-3.2-3.1-4.3-5.3-5.2-10.5-12.2-18.3-21.5-23.7-4.8-2.8-11.6-3.9-15.1-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-82.2,298.1c-16.4-11.4-18.6-12.8-22.3-16.1-.8-.8-.7-2.1.2-2.7.7-.4,1.6-.7,2.8-.6,3.1.2,13.5,5.6,20.7,18.1.5,1-.6,2-1.5,1.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-80.6,285.8c2,2.4,6.7,8.1,8.7,12.3.3.7,1.2,1,1.8.6,4.6-2.7,11.6-6.8,14.2-8.3.6-.3.8-1.1.5-1.7-1.4-2.6-5.1-9.3-8.7-12.7-.4-.4-1-.5-1.5-.2-3.3,1.7-11.4,6.3-14.7,8.1-.7.4-.9,1.3-.4,1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-43.9,308l-14.4,8.3c-.7.4-1.2,0-1.2-.9s0-.9.4-1.3c.2-.4.5-.8.9-1l14.4-8.3c.7-.4,1.2,0,1.2.9s0,.9-.4,1.3c-.2.4-.5.8-.9,1h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: -48.1,
    y1: 313,
    x2: -62.1,
    y2: 321.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-109.9,275.8l21.2-12.2c2.5-1.5,9.9-1.1,15.1,1.9,9.4,5.4,16.3,13.2,21.5,23.7,1.1,2.2,2.6,4.1,4.3,5.3l3.2,2.3c2.1,1.5,3.8,4.6,3.8,7.1v4.9l-7.2,4.2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "947.2 -204.2 1025.1 -159.2 1025.1 -101.2 947.2 -146.2 947.2 -204.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1025.5 -159.4 1103 -204.2 1103 -145.8 1025.5 -101 1025.5 -159.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M987.7-227.3l76.9-44.5,38.3,67.5-21.9,13.5,15.9,9.7-25.6,15.4-16.9-10.3-29,16.9-37.6-68.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M947.2-204.7l40.5-22.5,37.4,68.2-77.9-45.6h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "953.5 -181.7 967.2 -173.7 967.2 -151.3 953.5 -159.2 953.5 -181.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "956.1 -179.6 966.7 -173.5 966.7 -155 956.1 -161.1 956.1 -179.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M956.3-161l-2.9,1.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "953.5 -181.7 967.2 -173.7 967.2 -151.3 953.5 -159.2 953.5 -181.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "977.1 -169.4 990.8 -161.4 990.8 -139 977.1 -146.9 977.1 -169.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "979.7 -167.3 990.3 -161.2 990.3 -142.7 979.7 -148.8 979.7 -167.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M979.8-148.7l-2.9,1.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "977.1 -169.4 990.8 -161.4 990.8 -139 977.1 -146.9 977.1 -169.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "1001.7 -156 1015.4 -148.1 1015.4 -125.7 1001.7 -133.6 1001.7 -156"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "1004.3 -154 1014.9 -147.9 1014.9 -129.4 1004.3 -135.5 1004.3 -154"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1004.4-135.4l-2.9,1.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "1001.7 -156 1015.4 -148.1 1015.4 -125.7 1001.7 -133.6 1001.7 -156"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1054.8 -175.3 1071.3 -165.8 1071.3 -107.8 1054.8 -117.3 1054.8 -175.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1071.6 -166 1096.9 -180.6 1096.9 -122.2 1071.6 -107.7 1071.6 -166"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1041.4-187.1l17.2-44.4,17.1,23.6-34.3,20.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1022-221.1l18.4,34.8,17.9-46.1-36.4,11.3h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1056.9 -206.8 1064 -210.9 1064 -200.1 1056.9 -196 1056.9 -206.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "1076.8 -149.1 1092.8 -158.3 1092.8 -120.6 1076.8 -111.4 1076.8 -149.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "1076.8 -148.7 1090.3 -156.5 1090.3 -119.7 1076.8 -111.9 1076.8 -148.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "1079.4 -130.3 1080.5 -130.9 1080.5 -125.6 1079.4 -125 1079.4 -130.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1072.9-193.5c-1.2-.6-2.3-.9-3.3-.9s-1.3,0-1.8.4c-1.3.7-2.1,2.2-2.1,4.2,0,4.3,3.4,9.6,7.5,11.7,1.9,1,3.7,1.2,5.1.5,1.3-.7,2.1-2.2,2.1-4.2,0-4.3-3.4-9.6-7.5-11.7h0ZM1068.3-189.5v-.4c1.3-.7,3-.6,4.8.4,1.8.9,3.4,2.5,4.6,4.4v.4h-.2s-.2,0-.3-.2c-1.2-1.8-2.7-3.3-4.3-4.2-1.6-.8-3.1-1-4.1-.4h-.5ZM1069.4-187.7v-.4c1-.5,2.3-.4,3.7.3,1.3.7,2.6,1.9,3.5,3.3v.4h-.2s-.2,0-.3-.2c-.9-1.4-2-2.5-3.2-3.1s-2.2-.7-3-.3h-.5ZM1073.8-181.9h-.9c-.5-.3-.9-.9-.9-1.4s0-.6.4-.7.6,0,.9,0c.5.3.9.9.9,1.4s0,.6-.4.7h0ZM1075-183.7c-.6-.9-1.3-1.6-2.1-2-.7-.4-1.4-.4-1.9-.2h-.4v-.4c.7-.4,1.6-.3,2.6.2.9.5,1.7,1.3,2.4,2.2v.4h-.2s-.2,0-.3-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1072.9-183.6h-.2v.2c0,.3.3.8.6.9h.2v-.2c0-.3-.3-.8-.6-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1073.2-184.1c-.3-.2-.6-.2-.9,0s-.4.4-.4.7c0,.5.4,1.2.9,1.4h.9c.2,0,.4-.4.4-.7,0-.5-.4-1.2-.9-1.4h0ZM1073.4-182.4h-.2c-.3-.2-.6-.6-.6-.9s0-.2,0-.2h.2c.3.2.6.6.6.9s0,.2,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1075.5-183.6c.2,0,.2-.3,0-.4-.6-1-1.5-1.8-2.4-2.2-1-.5-1.9-.6-2.6-.2-.2,0-.2.3,0,.4,0,0,.3.2.4,0,.5-.3,1.2-.2,1.9.2.8.4,1.6,1.1,2.1,2,0,0,.2.2.3.2h.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1072.9-187.4c1.2.6,2.4,1.7,3.2,3.1,0,0,.2.2.3.2h.2c.2,0,.2-.3,0-.4-.9-1.4-2.2-2.6-3.5-3.3-1.4-.7-2.7-.8-3.7-.3-.2,0-.2.3,0,.4,0,0,.3.2.4,0,.8-.4,1.9-.3,3,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1072.9-189c1.6.9,3.2,2.3,4.3,4.2,0,0,.2.2.3.2h.2c.2,0,.2-.3,0-.4-1.2-1.9-2.8-3.5-4.6-4.4-1.8-.9-3.5-1.1-4.8-.4-.2,0-.2.3,0,.4,0,0,.3.2.4,0,1.1-.6,2.6-.4,4.1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1076.7-191.4c-1-1.1-2.2-2-3.4-2.6-2.2-1.1-4.2-1.3-5.8-.5-1.6.8-2.4,2.5-2.4,4.7,0,4.5,3.5,10,7.8,12.2.7.4,1.4.7,2.2.8h1.5c.8,0,1.5-.2,2.2-.5.9-.5,1.6-1.3,2-2.3,0-.2,0-.4.2-.6.2-.6.2-1.2.2-1.9,0-2.3-.9-4.9-2.5-7.2,0-.2-.2-.3-.3-.5-.2-.3-.5-.7-.8-1s-.5-.6-.8-.9h0v.2h0ZM1078.3-177.5c-1.3.7-3.2.5-5.1-.5-4.1-2.2-7.5-7.4-7.5-11.7s.7-3.5,2.1-4.2c.5-.3,1.2-.4,1.8-.4,1,0,2.1.3,3.3.9,4.1,2.2,7.5,7.4,7.5,11.7s-.7,3.5-2.1,4.2h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "817.1 -131.9 895 -87 895 -29 817.1 -74 817.1 -131.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "895.4 -87.2 972.9 -131.9 972.9 -73.5 895.4 -28.8 895.4 -87.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M857.5-155.1l77-44.5,38.3,67.5-21.9,13.5,15.9,9.7-25.6,15.4-16.9-10.3-29,16.9-37.6-68.1h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M817.1-132.5l40.5-22.6,37.4,68.2-77.9-45.6h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "823.4 -109.4 837.1 -101.5 837.1 -79 823.4 -87 823.4 -109.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "826 -107.4 836.6 -101.3 836.6 -82.8 826 -88.9 826 -107.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M826.1-88.8l-2.9,1.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "823.4 -109.4 837.1 -101.5 837.1 -79 823.4 -87 823.4 -109.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "846.9 -97.1 860.7 -89.2 860.7 -66.7 846.9 -74.7 846.9 -97.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "849.6 -95.1 860.2 -89 860.2 -70.5 849.6 -76.6 849.6 -95.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M849.7-76.5l-2.9,1.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "846.9 -97.1 860.7 -89.2 860.7 -66.7 846.9 -74.7 846.9 -97.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "871.5 -83.8 885.3 -75.9 885.3 -53.4 871.5 -61.4 871.5 -83.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "874.2 -81.7 884.8 -75.6 884.8 -57.1 874.2 -63.2 874.2 -81.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M874.3-63.1l-2.9,1.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "871.5 -83.8 885.3 -75.9 885.3 -53.4 871.5 -61.4 871.5 -83.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "924.7 -103.1 941.1 -93.6 941.1 -35.6 924.7 -45.1 924.7 -103.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "941.5 -93.8 966.8 -108.4 966.8 -50 941.5 -35.4 941.5 -93.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M911.3-114.8l17.2-44.4,17.1,23.6-34.3,20.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M891.9-148.9l18.4,34.8,17.9-46.1-36.4,11.3h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "926.8 -134.6 933.9 -138.7 933.9 -127.9 926.8 -123.8 926.8 -134.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "946.7 -76.9 962.7 -86.1 962.7 -48.4 946.7 -39.2 946.7 -76.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "946.7 -76.5 960.2 -84.3 960.2 -47.5 946.7 -39.7 946.7 -76.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "949.3 -58 950.4 -58.6 950.4 -53.4 949.3 -52.8 949.3 -58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M942.8-121.2c-1.2-.6-2.3-.9-3.3-.9s-1.3,0-1.8.4c-1.3.7-2.1,2.2-2.1,4.2,0,4.3,3.4,9.6,7.5,11.7,1.9,1,3.7,1.2,5.1.5,1.3-.7,2.1-2.2,2.1-4.2,0-4.3-3.4-9.6-7.5-11.7h0ZM938.2-117.2v-.4c1.3-.7,3-.6,4.8.4,1.8.9,3.4,2.5,4.6,4.4v.4h-.5c-1.2-1.8-2.7-3.3-4.3-4.2-1.6-.8-3.1-1-4.1-.4h-.4v-.2h0ZM939.3-115.5v-.4c1-.5,2.3-.4,3.7.3,1.3.7,2.6,1.9,3.5,3.3v.4h-.5c-.9-1.4-2-2.5-3.2-3.1s-2.2-.7-3-.3h-.4v-.2h0ZM943.7-109.7h-.9c-.5-.3-.9-.9-.9-1.4s0-.6.4-.7.6,0,.9,0c.5.3.9.9.9,1.4s0,.6-.4.7h0ZM944.9-111.5c-.6-.9-1.3-1.6-2.1-2-.7-.4-1.4-.4-1.9-.2h-.4v-.4c.7-.4,1.6-.3,2.6.2.9.5,1.7,1.3,2.4,2.2v.4h-.5v-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M942.8-111.4h-.2v.2c0,.3.3.8.6.9h.2v-.2c0-.3-.3-.8-.6-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M943.1-111.9c-.3-.2-.6-.2-.9,0-.2,0-.4.4-.4.7,0,.5.4,1.2.9,1.4h.9c.2,0,.4-.4.4-.7,0-.5-.4-1.2-.9-1.4h0ZM943.3-110.2h-.2c-.3-.2-.6-.6-.6-.9s0-.2,0-.2h.2c.3.2.6.6.6.9s0,.2,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M945.4-111.4c.2,0,.2-.3,0-.4-.6-1-1.5-1.8-2.4-2.2-1-.5-1.9-.6-2.6-.2-.2,0-.2.3,0,.4s.3.2.4,0c.5-.3,1.2-.2,1.9.2.8.4,1.6,1.1,2.1,2h.6v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M942.8-115.1c1.2.6,2.4,1.7,3.2,3.1h.5c.2,0,.2-.3,0-.4-.9-1.4-2.2-2.6-3.5-3.3-1.4-.7-2.7-.8-3.7-.3-.2,0-.2.3,0,.4,0,0,.3.2.4,0,.8-.4,1.9-.3,3,.3h0v.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M942.8-116.8c1.6.9,3.2,2.3,4.3,4.2h.5c.2,0,.2-.3,0-.4-1.2-1.9-2.8-3.5-4.6-4.4s-3.5-1.1-4.8-.4c-.2,0-.2.3,0,.4s.3.2.4,0c1.1-.6,2.6-.4,4.1.4h0v.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M946.6-119.1c-1-1.1-2.2-2-3.4-2.6-2.2-1.1-4.2-1.3-5.8-.5s-2.4,2.5-2.4,4.7c0,4.5,3.5,10,7.8,12.2.7.4,1.4.6,2.2.8h1.5c.8,0,1.5-.2,2.2-.5.9-.5,1.6-1.3,2-2.3,0-.2,0-.4.2-.6.2-.6.2-1.2.2-1.9,0-2.3-.9-4.9-2.5-7.2,0-.2-.2-.3-.3-.5-.2-.3-.5-.7-.8-1s-.5-.6-.8-.9h0v.2h-.1ZM948.2-105.3c-1.3.7-3.2.5-5.1-.5-4.1-2.1-7.5-7.4-7.5-11.7s.7-3.5,2.1-4.2c.5-.3,1.2-.4,1.8-.4,1,0,2.1.3,3.3.9,4.1,2.1,7.5,7.4,7.5,11.7s-.7,3.5-2.1,4.2h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "557.1 -85.1 662.7 -24.1 662.7 136.8 557.1 75.8 557.1 -85.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M625.5-30.2l9.7,5.6c1,.6,1.8,1.9,1.8,3.1V-5.5c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "624.4 -30.1 636.3 -23.2 636.3 -17 624.4 -23.9 624.4 -30.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M625.5-30.2l9.7,5.6c1,.6,1.8,1.9,1.8,3.1V-5.5c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M624.1-24.1l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M625.5-3.1l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1V-2.1c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "624.4 -3 636.3 3.9 636.3 10.1 624.4 3.2 624.4 -3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M625.5-3.1l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1V-2.1c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M624.1,3l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M585.5-51.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "584.4 -51.7 596.3 -44.8 596.3 -38.6 584.4 -45.5 584.4 -51.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M585.5-51.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M584.1-45.7l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M585.5-24.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1V0c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "584.4 -24.6 596.3 -17.7 596.3 -11.5 584.4 -18.4 584.4 -24.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M585.5-24.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1V0c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M584.1-18.6l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M625.5,41.5l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "624.4 41.7 636.3 48.5 636.3 54.7 624.4 47.9 624.4 41.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M625.5,41.5l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M624.1,47.7l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M625.5,68.6l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "624.4 68.8 636.3 75.6 636.3 81.8 624.4 75 624.4 68.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M625.5,68.6l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M624.1,74.8l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M585.5,19.9l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "584.4 20.1 596.3 26.9 596.3 33.1 584.4 26.3 584.4 20.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M585.5,19.9l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M584.1,26.1l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M585.5,47l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "584.4 47.2 596.3 54 596.3 60.2 584.4 53.4 584.4 47.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M585.5,47l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M584.1,53.2l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M864.3,20.5v-184l-104.8,60.1v23.4l-96.9,55.3.5,161.4,201.1-116.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M700.1-28.3l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "699 -26.2 710.9 -33 710.9 -26.8 699 -20 699 -26.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M700.1-28.3l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M698.7-19.8l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M700.1-1.3l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.1-2.4-1.4V2.9c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "699 .8 710.9 -6 710.9 .2 699 7 699 .8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M700.1-1.3l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.1-2.4-1.4V2.9c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M698.7,7.2l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M674.4-14l9.7-5.6c1.3-.8,2.4-.1,2.4,1.4V-2.2c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "673.3 -11.8 685.1 -18.7 685.1 -12.5 673.3 -5.7 673.3 -11.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M674.4-14l9.7-5.6c1.3-.8,2.4-.1,2.4,1.4V-2.2c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M672.9-5.5l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M674.4,13l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "673.3 15.1 685.1 8.3 685.1 14.5 673.3 21.3 673.3 15.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M674.4,13l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M672.9,21.5l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M700.1,43.1l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "699 45.3 710.9 38.4 710.9 44.6 699 51.4 699 45.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M700.1,43.1l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M698.7,51.6l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M700.1,70.1l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "699 72.3 710.9 65.4 710.9 71.6 699 78.4 699 72.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M700.1,70.1l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M698.7,78.6l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M674.4,57.4l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "673.3 59.6 685.1 52.7 685.1 58.9 673.3 65.7 673.3 59.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M674.4,57.4l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M672.9,65.9l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M674.4,84.4l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "673.3 86.6 685.1 79.7 685.1 85.9 673.3 92.7 673.3 86.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M674.4,84.4l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M672.9,92.9l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M748-56l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "747 -53.8 758.8 -60.7 758.8 -54.5 747 -47.7 747 -53.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M748-56l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M746.6-47.5l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M748-29l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "747 -26.8 758.8 -33.7 758.8 -27.5 747 -20.7 747 -26.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M748-29l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M746.6-20.5l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M722.3-41.7l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4.1-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "721.2 -39.5 733.1 -46.4 733.1 -40.2 721.2 -33.4 721.2 -39.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M722.3-41.7l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4.1-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M720.9-33.2l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M722.3-14.7l9.7-5.6c1.3-.8,2.4-.1,2.4,1.4V-2.9c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "721.2 -12.5 733.1 -19.4 733.1 -13.2 721.2 -6.4 721.2 -12.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M722.3-14.7l9.7-5.6c1.3-.8,2.4-.1,2.4,1.4V-2.9c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M720.9-6.2l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M748,15.4l9.7-5.6c1.3-.8,2.4-.1,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "747 17.6 758.8 10.7 758.8 16.9 747 23.8 747 17.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M748,15.4l9.7-5.6c1.3-.8,2.4-.1,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M746.6,24l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M748,42.4l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "747 44.6 758.8 37.7 758.8 43.9 747 50.8 747 44.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M748,42.4l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M746.6,50.9l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M722.3,29.7l9.7-5.6c1.3-.8,2.4-.1,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "721.2 31.9 733.1 25 733.1 31.2 721.2 38.1 721.2 31.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M722.3,29.7l9.7-5.6c1.3-.8,2.4-.1,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M720.9,38.3l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M722.3,56.7l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "721.2 58.9 733.1 52 733.1 58.2 721.2 65.1 721.2 58.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M722.3,56.7l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M720.9,65.3l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M796-83.7l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "794.9 -81.5 806.8 -88.4 806.8 -82.2 794.9 -75.4 794.9 -81.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M796-83.7l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M794.5-75.2l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M796-56.7l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "794.9 -54.5 806.8 -61.4 806.8 -55.2 794.9 -48.4 794.9 -54.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M796-56.7l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M794.5-48.2l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M770.2-69.4l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "769.2 -67.2 781 -74 781 -67.9 769.2 -61 769.2 -67.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M770.2-69.4l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M768.8-60.8l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M770.2-42.4l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4.1-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "769.2 -40.2 781 -47.1 781 -40.9 769.2 -34 769.2 -40.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M770.2-42.4l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4.1-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M768.8-33.8l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M796-12.2l9.7-5.6c1.3-.8,2.4-.1,2.4,1.4V-.4c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.1-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "794.9 -10.1 806.8 -16.9 806.8 -10.8 794.9 -3.9 794.9 -10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M796-12.2l9.7-5.6c1.3-.8,2.4-.1,2.4,1.4V-.4c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.1-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M794.5-3.7l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M796,14.7l9.7-5.6c1.3-.8,2.4-.1,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "794.9 16.9 806.8 10 806.8 16.2 794.9 23.1 794.9 16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M796,14.7l9.7-5.6c1.3-.8,2.4-.1,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M794.5,23.3l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M770.2,2.1l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.1-2.4-1.4V6.3c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "769.2 4.2 781 -2.6 781 3.5 769.2 10.4 769.2 4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M770.2,2.1l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.1-2.4-1.4V6.3c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M768.8,10.6l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M770.2,29l9.7-5.6c1.3-.8,2.4-.1,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "769.2 31.2 781 24.4 781 30.5 769.2 37.4 769.2 31.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M770.2,29l9.7-5.6c1.3-.8,2.4-.1,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M768.8,37.6l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M843.9-111.4l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "842.8 -109.2 854.7 -116 854.7 -109.9 842.8 -103 842.8 -109.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M843.9-111.4l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M842.5-102.8l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M843.9-84.4l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "842.8 -82.2 854.7 -89 854.7 -82.9 842.8 -76 842.8 -82.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M843.9-84.4l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M842.5-75.8l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M818.2-97l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "817.1 -94.9 828.9 -101.7 828.9 -95.6 817.1 -88.7 817.1 -94.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M818.2-97l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M816.7-88.5l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M818.2-70.1l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "817.1 -67.9 828.9 -74.7 828.9 -68.6 817.1 -61.7 817.1 -67.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M818.2-70.1l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M816.7-61.5l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M843.9-39.9l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4.1-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "842.8 -37.8 854.7 -44.6 854.7 -38.4 842.8 -31.6 842.8 -37.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M843.9-39.9l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v15.9c0,1.6-1.1,3.4-2.4,4.2l-9.7,5.6c-1.3.8-2.4.1-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M842.5-31.4l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M843.9-12.9l9.7-5.6c1.3-.8,2.4-.1,2.4,1.4V-1.1c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.1-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "842.8 -10.8 854.7 -17.6 854.7 -11.5 842.8 -4.6 842.8 -10.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M843.9-12.9l9.7-5.6c1.3-.8,2.4-.1,2.4,1.4V-1.1c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.1-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M842.5-4.4l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M818.2-25.6l9.7-5.6c1.3-.8,2.4-.1,2.4,1.4v15.9c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "817.1 -23.5 828.9 -30.3 828.9 -24.1 817.1 -17.3 817.1 -23.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M818.2-25.6l9.7-5.6c1.3-.8,2.4-.1,2.4,1.4v15.9c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4,0-2.4-1.4v-15.9c0-1.6,1.1-3.4,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M816.7-17.1l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M818.2,1.4l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.1-2.4-1.4V5.6c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "817.1 3.5 828.9 -3.3 828.9 2.9 817.1 9.7 817.1 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M818.2,1.4l9.7-5.6c1.3-.8,2.4,0,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.1-2.4-1.4V5.6c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M816.7,9.9l12.6-7.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "654.3 -141.2 759.8 -80.3 662.7 -24.2 557.2 -85.2 654.3 -141.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "759.2 -224.5 864.2 -163.9 759.4 -103.5 654.5 -164.1 759.2 -224.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M654.5-163.7l105.1,60.1v23.1l-105.1-60.6v-22.7h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "616.6 -98.9 668.2 -69.1 668.2 -55.8 616.6 -85.6 616.6 -98.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "668.8 -69.2 701.6 -88.2 701.6 -74.8 668.8 -55.9 668.8 -69.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M651.7-118.3l48.8,28.2c1,.6,1,1.5,0,2.1l-30.9,17.8c-1,.6-2.6.6-3.5,0l-48.8-28.2c-1-.6-1-1.5,0-2.1l30.9-17.8c1-.6,2.6-.6,3.5,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "718 -177.9 769.7 -148 769.7 -134.7 718 -164.5 718 -177.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "770.3 -148.1 803.1 -167.1 803.1 -153.8 770.3 -134.8 770.3 -148.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M753.2-197.2l48.8,28.2c1,.6,1,1.5,0,2.1l-30.9,17.8c-1,.6-2.6.6-3.6,0l-48.8-28.2c-1-.6-1-1.5,0-2.1l30.9-17.8c1-.6,2.6-.6,3.6,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1.1 -77 89.8 -25.8 89.8 234.6 1.1 183.3 1.1 -77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1.5,8.3l87.9,50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1.5,92.4l87.9,50.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "90.3 -25.8 249.2 -117.5 249.2 142.8 90.3 234.6 90.3 -25.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M91.1,58.8L248.4-32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M91.1,142.9L248.4,52.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M171.9-55.8l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M172.5-55.4l7.9-4.6c.9-.5,1.6,0,1.6.9h0c0,1.1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6,0-1.6-.9h0c0-1.1.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M171.9-26.1l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M172.5-25.7l7.9-4.6c.9-.5,1.6-.1,1.6.9h0c0,1.1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-.9h0c0-1.1.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M194.2-69.4l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M194.8-69l7.9-4.6c.9-.5,1.6,0,1.6.9h0c0,1.1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6,0-1.6-.9h0c0-1.1.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M194.2-39.7l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M194.8-39.2l7.9-4.6c.9-.5,1.6,0,1.6.9h0c0,1.1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6,0-1.6-.9h0c0-1.1.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M217-82.5l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M217.6-82l7.9-4.6c.9-.5,1.6,0,1.6.9h0c0,1.1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6,0-1.6-.9h0c0-1.1.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M217-52.8l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M217.6-52.3l7.9-4.6c.9-.5,1.6,0,1.6.9h0c0,1.1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6,0-1.6-.9h0c0-1.1.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M171.9,29.2l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M172.5,29.7l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M171.9,58.9l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M172.5,59.4l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M194.2,15.7l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M194.8,16.1l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M194.2,45.4l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M194.8,45.8l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M217,2.6l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1V5.7c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M217.6,3l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M217,32.3l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M217.6,32.8l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M171.9,114.3l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M172.5,114.8l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M171.9,144l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M172.5,144.5l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M194.2,100.7l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M194.8,101.2l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M194.2,130.5l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M194.8,130.9l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M217,87.6l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M217.6,88.1l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M217,117.4l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M217.6,117.8l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M103.6-6.8l58.1-33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M103.6,9.6l58.1-33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M103.6,26L161.7-7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M103.6,78.3l58.1-33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M103.6,94.7l58.1-33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M103.6,111.1l58.1-33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M103.6,163.3l58.1-33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M103.6,179.7l58.1-33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M103.6,196.1l58.1-33.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "160.1 -169.2 248.9 -117.9 90.1 -26.2 1.4 -77.5 160.1 -169.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "51.3 -98.6 103 -68.8 103 -55.4 51.3 -85.2 51.3 -98.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "103.6 -68.8 136.4 -87.8 136.4 -74.5 103.6 -55.5 103.6 -68.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M86.5-117.9l48.8,28.2c1,.6,1,1.5,0,2.1l-30.9,17.8c-1,.6-2.6.6-3.5,0l-48.8-28.2c-1-.6-1-1.5,0-2.1l30.9-17.8c1-.6,2.6-.6,3.5,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "112.8 -134.5 164.5 -104.6 164.5 -91.3 112.8 -121.1 112.8 -134.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "165.1 -104.7 197.9 -123.7 197.9 -110.3 165.1 -91.4 165.1 -104.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M148-153.8l48.8,28.2c1,.6,1,1.5,0,2.1l-30.9,17.8c-1,.6-2.6.6-3.5,0l-48.8-28.2c-1-.6-1-1.5,0-2.1l30.9-17.8c1-.6,2.6-.6,3.5,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M91.1-126.7c-2.7-1.4-5.3-2.1-7.6-2.1s-3,.3-4.3,1c-3.1,1.6-4.9,5.1-4.9,9.9,0,10.1,7.9,22.3,17.5,27.4,4.5,2.4,8.8,2.8,11.9,1.1s4.9-5.1,4.9-9.9c0-10.1-7.9-22.3-17.5-27.4ZM80.4-117.4c-.2-.3,0-.8.3-.9,3-1.6,7-1.3,11.2.9,4.1,2.1,7.9,5.8,10.7,10.2.2.3,0,.8-.3.9h-.4c-.3,0-.5,0-.7-.4-2.7-4.3-6.3-7.7-10.1-9.7-3.7-1.9-7.1-2.2-9.7-.9s-.8,0-1-.2h0ZM83-113.3c-.2-.3,0-.8.3-.9,2.3-1.3,5.4-1,8.6.7,3.1,1.6,6,4.4,8.1,7.8.2.3,0,.8-.3.9h-.4c-.3,0-.5,0-.7-.4-2-3.2-4.7-5.8-7.5-7.2-2.7-1.4-5.2-1.6-7-.7-.4.2-.8,0-1-.2h0ZM93.1-99.8c-.3,0-.5.2-.9.2s-.8,0-1.2-.3c-1.2-.6-2.2-2.1-2.2-3.4s.3-1.3.9-1.6,1.3-.3,2,0c1.2.6,2.2,2.1,2.2,3.4s-.3,1.3-.9,1.6h0ZM96.1-103.9c-1.3-2.1-3.1-3.8-4.9-4.7-1.7-.9-3.3-1.1-4.4-.4-.4.2-.8,0-1-.2-.2-.3,0-.8.3-.9,1.6-.9,3.8-.7,6,.4,2.1,1.1,4,3,5.5,5.2.2.3,0,.8-.3.9h-.4c-.3,0-.5,0-.7-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M91.1-103.6h-.4v.4c0,.8.7,1.8,1.4,2.2h.5v-.4c0-.8-.7-1.8-1.4-2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M91.9-104.8c-.7-.4-1.5-.4-2,0-.6.3-.9.9-.9,1.6,0,1.3,1,2.8,2.2,3.4.4.2.8.3,1.2.3s.6,0,.9-.2c.6-.3.9-.9.9-1.6,0-1.3-1-2.8-2.2-3.4h0ZM92.4-101h-.5c-.7-.4-1.4-1.4-1.4-2.2s0-.4,0-.4h.4c.7.4,1.4,1.4,1.4,2.2s0,.4,0,.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M97.1-103.6c.4-.2.5-.6.3-.9-1.5-2.3-3.4-4.2-5.5-5.2-2.2-1.2-4.4-1.3-6-.4-.4.2-.5.6-.3.9s.7.4,1,.2c1.1-.6,2.7-.5,4.4.4,1.9,1,3.6,2.6,4.9,4.7,0,.2.4.4.7.4h.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M91.1-112.4c2.9,1.5,5.5,4.1,7.5,7.2,0,.2.4.4.7.4h.4c.4-.2.5-.6.3-.9-2.1-3.4-5-6.1-8.1-7.8-3.2-1.7-6.3-1.9-8.6-.7-.4.2-.5.6-.3.9s.7.4,1,.2c1.8-1,4.3-.8,7,.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M91.1-116.2c3.8,2,7.5,5.5,10.1,9.7,0,.2.4.4.7.4h.4c.4-.2.5-.6.3-.9-2.8-4.5-6.6-8.1-10.7-10.2-4.2-2.2-8.2-2.5-11.2-.9-.4.2-.5.6-.3.9s.7.4,1,.2c2.5-1.4,6-1.1,9.7.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M99.9-121.8c-2.4-2.5-5.2-4.6-8-6.1-5-2.6-9.8-3-13.4-1.1s-5.6,5.8-5.6,11.1c0,10.5,8.2,23.3,18.3,28.6,1.7.9,3.4,1.5,5,1.9.5,0,1,.2,1.5.3h1.8c1.8,0,3.5-.4,5-1.2,2.1-1.1,3.7-3,4.6-5.4.2-.4.3-.9.4-1.3.4-1.3.5-2.8.5-4.3,0-5.5-2.2-11.6-5.8-16.9-.3-.4-.5-.8-.8-1.2-.6-.8-1.1-1.5-1.8-2.3-.6-.7-1.2-1.4-1.9-2.1h.2ZM103.8-89.5c-3.1,1.6-7.4,1.2-11.9-1.1-9.6-5-17.5-17.3-17.5-27.4s1.7-8.2,4.9-9.9c1.3-.7,2.7-1,4.3-1,2.3,0,4.9.7,7.6,2.1,9.6,5,17.5,17.3,17.5,27.4s-1.7,8.2-4.9,9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M155.7-162.6c-2.7-1.4-5.3-2.1-7.6-2.1s-3,.3-4.3,1c-3.1,1.6-4.9,5.1-4.9,9.8,0,10.1,7.9,22.3,17.5,27.4,4.5,2.4,8.8,2.8,11.9,1.1s4.9-5.1,4.9-9.9c0-10.1-7.9-22.3-17.5-27.4h0ZM145-153.2c-.2-.3-.1-.8.3-.9,3-1.6,7-1.3,11.2.9,4.1,2.1,7.9,5.8,10.7,10.2.2.3,0,.8-.3.9h-.4c-.3,0-.5-.1-.7-.4-2.7-4.3-6.3-7.7-10.2-9.7-3.7-1.9-7.1-2.2-9.7-.9-.4.2-.8,0-1-.2h.1,0ZM147.6-149.2c-.2-.3-.1-.8.3-.9,2.3-1.3,5.4-1,8.6.7,3.1,1.6,6,4.4,8.1,7.8.2.3,0,.8-.3.9h-.4c-.3,0-.5-.1-.7-.4-2-3.2-4.7-5.8-7.5-7.2-2.7-1.4-5.2-1.7-7-.7-.4.2-.8,0-1-.2h-.1ZM157.7-135.6c-.3.1-.5.2-.9.2s-.8-.1-1.2-.3c-1.2-.6-2.2-2.1-2.2-3.4s.3-1.3.9-1.6,1.3-.3,2,.1c1.2.6,2.2,2.1,2.2,3.4s-.3,1.3-.9,1.6h.1,0ZM160.6-139.7c-1.3-2.1-3.1-3.8-4.9-4.7-1.7-.9-3.3-1.1-4.4-.4-.4.2-.8,0-1-.2-.2-.3-.1-.8.3-.9,1.6-.9,3.8-.7,6,.4,2.1,1.1,4,3,5.5,5.3.2.3,0,.8-.3.9-.1,0-.2.1-.4.1-.3,0-.5-.1-.7-.4h-.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M155.7-139.5c-.2-.1-.3-.1-.4-.1s0,0,0,0c0,0-.1.2-.1.4,0,.8.7,1.8,1.4,2.2.3.1.4.1.5.1s.1-.2.1-.4c0-.8-.7-1.8-1.4-2.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M156.5-140.7c-.7-.4-1.5-.4-2-.1-.6.3-.9.9-.9,1.6,0,1.3,1,2.8,2.2,3.4.4.2.8.3,1.2.3s.6,0,.9-.2c.6-.3.9-.9.9-1.6,0-1.3-1-2.8-2.2-3.4h-.1,0ZM157-136.8s-.2,0-.5-.1c-.7-.4-1.4-1.4-1.4-2.2s0-.4.1-.4h0s.2,0,.4.1c.7.4,1.4,1.4,1.4,2.2s0,.4-.1.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M161.7-139.5c.4-.2.5-.6.3-.9-1.5-2.3-3.4-4.2-5.5-5.2-2.2-1.2-4.4-1.3-6-.4-.4.2-.5.6-.3.9s.7.4,1,.2c1.1-.6,2.7-.5,4.4.5,1.9,1,3.6,2.6,4.9,4.7.1.2.4.4.7.4s.3,0,.4-.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M155.7-148.3c2.9,1.5,5.5,4.1,7.5,7.2.1.2.4.4.7.4h.4c.4-.2.5-.6.3-.9-2.1-3.4-5-6.2-8.1-7.8-3.2-1.7-6.3-1.9-8.6-.7-.4.2-.5.6-.3.9s.7.4,1,.2c1.8-1,4.3-.8,7,.7h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M155.7-152.1c3.8,2,7.5,5.5,10.2,9.7.1.2.4.4.7.4h.4c.4-.2.5-.6.3-.9-2.8-4.5-6.6-8.1-10.7-10.2-4.2-2.2-8.2-2.5-11.2-.9-.4.2-.5.6-.3.9s.7.4,1,.2c2.5-1.4,6-1.1,9.7.9h-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M164.5-157.7c-2.4-2.5-5.2-4.6-8-6.1-5-2.6-9.8-3-13.4-1.1s-5.6,5.8-5.6,11.1c0,10.5,8.2,23.3,18.3,28.6,1.7.9,3.4,1.5,5,1.9.5,0,1,.2,1.5.3h1.8c1.8,0,3.5-.4,5-1.2,2.1-1.1,3.7-3,4.6-5.4.2-.4.3-.9.4-1.3.4-1.3.5-2.8.5-4.3,0-5.5-2.2-11.6-5.8-16.9-.3-.4-.5-.8-.8-1.2-.6-.8-1.1-1.5-1.8-2.3-.6-.7-1.2-1.4-1.9-2.1h.2ZM168.3-125.4c-3.1,1.6-7.4,1.2-11.9-1.1-9.6-5-17.5-17.3-17.5-27.4s1.7-8.2,4.9-9.8c1.3-.7,2.7-1,4.3-1,2.3,0,4.9.7,7.6,2.1,9.6,5,17.5,17.3,17.5,27.4s-1.7,8.2-4.9,9.9h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "353.4 132.9 442.2 81.6 442.2 256.9 353.4 308.1 353.4 132.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M353.9,216.6l87.9-50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M370.6,139.1l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M371.1,139.6l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M370.6,168.8l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M371.1,169.3l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M392.9,125.5l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M393.4,126l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M392.9,155.3l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M393.4,155.7l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M415.7,112.4l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M416.2,112.9l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M415.7,142.2l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M416.2,142.6l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M370.6,222l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M371.1,222.5l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M370.6,251.7l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M371.1,252.2l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M392.9,208.5l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M393.4,208.9l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M392.9,238.2l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M393.4,238.6l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M415.7,195.4l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M416.2,195.8l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M415.7,225.1l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M416.2,225.6l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "264.2 81.6 353 132.9 353 308.1 264.2 256.9 264.2 81.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M264.7,165.9l87.9,50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M323.7,134.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "322.7 134.6 334.5 141.4 334.5 147.6 322.7 140.8 322.7 134.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M323.7,134.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M322.3,140.5l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M323.7,161.5l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "322.7 161.7 334.5 168.5 334.5 174.7 322.7 167.9 322.7 161.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M323.7,161.5l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M322.3,167.7l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M283.8,112.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "282.7 113 294.6 119.8 294.6 126 282.7 119.2 282.7 113"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M283.8,112.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M282.3,119l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M283.8,139.9l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "282.7 140.1 294.6 146.9 294.6 153.1 282.7 146.3 282.7 140.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M283.8,139.9l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M282.3,146.1l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M323.7,215.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "322.7 215.5 334.5 222.4 334.5 228.6 322.7 221.7 322.7 215.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M323.7,215.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M322.3,221.5l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M323.7,242.5l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "322.7 242.6 334.5 249.5 334.5 255.7 322.7 248.8 322.7 242.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M323.7,242.5l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M322.3,248.6l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M283.8,193.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "282.7 193.9 294.6 200.8 294.6 207 282.7 200.1 282.7 193.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M283.8,193.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M282.3,199.9l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M283.8,220.9l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "282.7 221.1 294.6 227.9 294.6 234.1 282.7 227.3 282.7 221.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M283.8,220.9l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M282.3,227l12.6,7.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "353.2 29.9 442 81.2 353.3 132.4 264.5 81.2 353.2 29.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "354.5 38.3 426.7 80 351.9 123.2 279.6 81.5 354.5 38.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M287.3,85.8l66.6-38.4,64.1,36.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "330.5 74 353.6 87.3 353.6 100.6 330.5 87.3 330.5 74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "354.1 87.3 377.1 74 377.1 87.3 354.1 100.6 354.1 87.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M355.6,60.7l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.5,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.5,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M351.2,37.6c-2.7-1.4-5.3-2.1-7.6-2.1s-3,.3-4.3,1c-3.1,1.6-4.9,5.1-4.9,9.9,0,10.1,7.8,22.3,17.5,27.4,4.5,2.4,8.8,2.8,11.9,1.1,3.1-1.6,4.9-5.1,4.9-9.9,0-10.1-7.8-22.3-17.5-27.4h0ZM340.5,46.9c-.2-.3,0-.8.3-1,3-1.6,7-1.3,11.2.9,4.1,2.1,7.9,5.8,10.7,10.2.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.4-2.7-4.3-6.3-7.7-10.2-9.7-3.7-1.9-7.1-2.2-9.7-.9s-.8,0-1-.2h.1ZM343.1,50.9c-.2-.3,0-.8.3-1,2.3-1.3,5.4-1,8.6.7,3.1,1.6,6,4.4,8.1,7.8.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.4-2-3.2-4.7-5.8-7.5-7.2-2.7-1.4-5.2-1.6-7-.7s-.8,0-1-.2c0,0-.1,0-.1,0ZM353.2,64.5c-.3,0-.5.2-.8.2s-.8,0-1.2-.3c-1.2-.6-2.2-2.1-2.2-3.4s.3-1.3.9-1.6,1.3-.3,2,0c1.2.6,2.2,2.1,2.2,3.4s-.3,1.3-.9,1.6h0ZM356.1,60.4c-1.3-2.1-3.1-3.8-4.9-4.7-1.7-.9-3.3-1.1-4.4-.5-.4.2-.8,0-1-.2-.2-.3,0-.8.3-1,1.6-.9,3.8-.7,6,.4,2.1,1.1,4,3,5.5,5.2.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.4h-.1v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M352,59.5c-.7-.4-1.5-.4-2,0-.6.3-.9.9-.9,1.6,0,1.3,1,2.8,2.2,3.4,1.2.6.8.3,1.2.3s.6,0,.8-.2c.6-.3.9-.9.9-1.6,0-1.3-1-2.8-2.2-3.4h0ZM352.4,63.3h-.5c-.7-.4-1.4-1.4-1.4-2.2s0-.4,0-.4h.4c.7.4,1.4,1.4,1.4,2.2s0,.4,0,.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M357.2,60.6c.4-.2.5-.6.3-1-1.5-2.3-3.4-4.2-5.5-5.2-2.2-1.2-4.4-1.3-6-.4-.4.2-.5.6-.3,1,.2.3.7.4,1,.2,1.1-.6,2.7-.5,4.4.5,1.9,1,3.6,2.6,4.9,4.7,0,.2.4.4.7.4h.5v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M351.2,51.8c2.8,1.5,5.5,4,7.5,7.2,0,.2.4.4.7.4h.4c.4-.2.5-.6.3-1-2.2-3.4-5-6.1-8.1-7.8-3.2-1.7-6.3-1.9-8.6-.7-.4.2-.5.6-.3,1,.2.3.7.4,1,.2,1.8-1,4.3-.8,7,.7,0,0,.1,0,.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M351.2,48c3.8,2,7.5,5.5,10.2,9.7,0,.2.4.4.7.4h.4c.4-.2.5-.6.3-1-2.8-4.5-6.7-8.1-10.7-10.2-4.2-2.2-8.2-2.5-11.2-.9-.4.2-.5.6-.3,1,.2.3.7.4,1,.2,2.5-1.4,6-1,9.7.9h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M360,42.5c-2.4-2.5-5.2-4.6-8-6.1-5-2.6-9.8-3-13.4-1.1s-5.6,5.8-5.6,11.1c0,10.5,8.2,23.3,18.3,28.6,1.7.9,3.4,1.5,5,1.9.5,0,1,.2,1.5.3h1.8c1.8,0,3.5-.4,5-1.2,2.2-1.1,3.7-3,4.7-5.4.2-.4.3-.9.4-1.3.3-1.3.5-2.8.5-4.3,0-5.5-2.2-11.6-5.8-16.9-.3-.4-.5-.8-.8-1.2-.6-.8-1.2-1.5-1.8-2.3-.6-.7-1.2-1.4-1.9-2.1h0ZM363.8,74.8c-3.1,1.6-7.3,1.2-11.9-1.1-9.7-5-17.5-17.3-17.5-27.4s1.7-8.2,4.9-9.9c1.3-.7,2.7-1,4.3-1,2.3,0,4.9.7,7.6,2.1,9.7,5,17.5,17.3,17.5,27.4s-1.7,8.2-4.9,9.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M351.2,60.7h-.4c-.1,0,0,0,0,0v.4c0,.8.7,1.8,1.4,2.2h.5v-.4c0-.8-.7-1.8-1.4-2.2h-.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "237.7 209.8 326.4 158.5 326.4 334.8 237.7 386.1 237.7 209.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "148.5 158.5 237.3 209.8 237.3 386.1 148.5 334.8 148.5 158.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M163.6,187.7l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M163.6,187.7l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M163.6,206.2l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M163.6,224.6l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M163.6,243.1l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M163.6,261.5l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M163.6,280l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M163.6,298.4l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M163.6,316.9l58.1,33.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "237.4 106.9 326.1 158.2 237.4 209.4 148.7 158.2 237.4 106.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "189.8 133.9 236.7 161 236.7 188.2 189.8 161 189.8 133.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "237.7 161 284.6 133.9 284.6 161 237.7 188.2 237.7 161"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M239,106.8l44.5,25.7c1,.6,1,1.5,0,2l-44.5,25.7c-1,.6-2.6.6-3.5,0l-44.5-25.7c-1-.6-1-1.5,0-2l44.5-25.7c1-.6,2.6-.6,3.5,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "208.4 116.9 236.9 133.3 236.9 149.7 208.4 133.3 208.4 116.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "237.5 133.3 266 116.9 266 133.3 237.5 149.7 237.5 133.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M239,100.8l25.6,14.8c1,.6,1,1.5,0,2l-25.6,14.8c-1,.6-2.6.6-3.5,0l-25.6-14.8c-1-.6-1-1.5,0-2l25.6-14.8c1-.6,2.6-.6,3.5,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1127.5 -19.1 1216.3 -70.3 1216.3 106 1127.5 157.2 1127.5 -19.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1038.3 -70.3 1127.1 -19.1 1127.1 157.2 1038.3 106 1038.3 -70.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1053.4-41.1l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1053.4-41.1l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1053.4-22.7l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1053.4-4.2l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1053.4,14.2l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1053.4,32.7l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1053.4,51.1l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1053.4,69.6l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1053.4,88l58.1,33.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1127.2 -121.9 1215.9 -70.7 1127.2 -19.5 1038.5 -70.7 1127.2 -121.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1079.6 -94.9 1126.5 -67.8 1126.5 -40.7 1079.6 -67.8 1079.6 -94.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1127.5 -67.8 1174.5 -94.9 1174.5 -67.8 1127.5 -40.7 1127.5 -67.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1128.9-122.1l44.5,25.7c1,.6,1,1.5,0,2.1l-44.5,25.7c-1,.6-2.6.6-3.6,0l-44.5-25.7c-1-.6-1-1.5,0-2.1l44.5-25.7c1-.6,2.6-.6,3.6,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1098.3 -112 1126.7 -95.6 1126.7 -79.1 1098.3 -95.6 1098.3 -112"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1127.3 -95.6 1155.8 -112 1155.8 -95.6 1127.3 -79.1 1127.3 -95.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1128.8-128.1l25.6,14.8c1,.6,1,1.5,0,2.1l-25.6,14.8c-1,.6-2.6.6-3.6,0l-25.6-14.8c-1-.6-1-1.5,0-2.1l25.6-14.8c1-.6,2.6-.6,3.6,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1238.2 43.5 1327 -7.8 1327 168.5 1238.2 219.8 1238.2 43.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1149 -7.8 1237.8 43.5 1237.8 219.8 1149 168.5 1149 -7.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1164.1,21.4l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1164.1,21.4l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1164.1,39.9l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1164.1,58.4l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1164.1,76.8l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1164.1,95.3l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1164.1,113.7l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1164.1,132.2l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1164.1,150.6l58.1,33.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1237.9 -59.4 1326.7 -8.1 1237.9 43.1 1149.2 -8.1 1237.9 -59.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1190.3 -32.3 1237.2 -5.2 1237.2 21.9 1190.3 -5.2 1190.3 -32.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1238.2 -5.2 1285.2 -32.3 1285.2 -5.2 1238.2 21.9 1238.2 -5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1239.6-59.5l44.5,25.7c1,.6,1,1.5,0,2.1l-44.5,25.7c-1,.6-2.6.6-3.6,0l-44.5-25.7c-1-.6-1-1.5,0-2.1l44.5-25.7c1-.6,2.6-.6,3.6,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1209 -49.4 1237.4 -33 1237.4 -16.6 1209 -33 1209 -49.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1238 -33 1266.5 -49.4 1266.5 -33 1238 -16.6 1238 -33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1239.5-65.5l25.6,14.8c1,.6,1,1.5,0,2.1l-25.6,14.8c-1,.6-2.6.6-3.6,0l-25.6-14.8c-1-.6-1-1.5,0-2.1l25.6-14.8c1-.6,2.6-.6,3.6,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1350.5 110.9 1439.3 59.6 1439.3 235.9 1350.5 287.2 1350.5 110.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1261.3 59.6 1350.1 110.9 1350.1 287.2 1261.3 235.9 1261.3 59.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1276.4,88.8l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1276.4,88.8l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1276.4,107.3l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1276.4,125.7l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1276.4,144.2l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1276.4,162.6l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1276.4,181.1l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1276.4,199.5l58.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1276.4,218l58.1,33.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1350.3 8 1439 59.2 1350.2 110.5 1261.5 59.3 1350.3 8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1302.6 35 1349.5 62.1 1349.5 89.2 1302.6 62.1 1302.6 35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1350.5 62.1 1397.5 35 1397.5 62.1 1350.5 89.2 1350.5 62.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1351.9,7.9l44.5,25.7c1,.6,1,1.5,0,2l-44.5,25.7c-1,.6-2.6.6-3.6,0l-44.5-25.7c-1-.6-1-1.5,0-2l44.5-25.7c1-.6,2.6-.6,3.6,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1321.3 18 1349.7 34.4 1349.7 50.8 1321.3 34.4 1321.3 18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1350.4 34.4 1378.8 18 1378.8 34.4 1350.4 50.8 1350.4 34.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1351.9,1.9l25.6,14.8c1,.6,1,1.5,0,2l-25.6,14.8c-1,.6-2.6.6-3.6,0l-25.6-14.8c-1-.6-1-1.5,0-2l25.6-14.8c1-.6,2.6-.6,3.6,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "575.5 175.5 664.3 124.2 664.3 384.6 575.5 435.8 575.5 175.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M576,260.3l87.9-50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M576,344.3l87.9-50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M592.7,183.7l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M593.2,184.1l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M592.7,213.4l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M593.2,213.9l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M615,170.1l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M615.5,170.6l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M615,199.8l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M615.5,200.3l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M637.8,157l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M638.3,157.5l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M637.8,186.8l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M638.3,187.2l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M592.7,266.8l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M593.2,267.3l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M592.7,296.5l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M593.2,297l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M615,253.2l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M615.5,253.7l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M615,283l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M615.5,283.4l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M637.8,240.2l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M638.3,240.6l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M637.8,269.9l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M638.3,270.3l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M592.7,349.7l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M593.2,350.2l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M592.7,379.4l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M593.2,379.9l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M615,336.2l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M615.5,336.6l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M615,365.9l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M615.5,366.4l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M637.8,323.1l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M638.3,323.5l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M637.8,352.8l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M638.3,353.3l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "486.4 124.2 575.1 175.5 575.1 435.8 486.4 384.6 486.4 124.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M486.8,209.5l87.9,50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M486.8,293.6l87.9,50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M543.5,174.6l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "542.4 174.8 554.3 181.7 554.3 188.1 542.4 181.3 542.4 174.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M543.5,174.6l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M542.1,181l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M543.5,202.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "542.4 203 554.3 209.9 554.3 216.3 542.4 209.4 542.4 203"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M543.5,202.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M542.1,209.3l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M503.5,153.1l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "502.4 153.3 514.3 160.1 514.3 166.6 502.4 159.7 502.4 153.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M503.5,153.1l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M502.1,159.5l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M503.5,181.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "502.4 181.5 514.3 188.3 514.3 194.8 502.4 187.9 502.4 181.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M503.5,181.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M502.1,187.7l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M543.5,257.6l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "542.4 257.8 554.3 264.7 554.3 271.1 542.4 264.3 542.4 257.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M543.5,257.6l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M542.1,264.1l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M543.5,285.9l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "542.4 286 554.3 292.9 554.3 299.3 542.4 292.5 542.4 286"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M543.5,285.9l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M542.1,292.3l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M503.5,236.1l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "502.4 236.3 514.3 243.2 514.3 249.6 502.4 242.8 502.4 236.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M503.5,236.1l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M502.1,242.6l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M503.5,264.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "502.4 264.5 514.3 271.4 514.3 277.8 502.4 271 502.4 264.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M503.5,264.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M502.1,270.8l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M543.5,340.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "542.4 340.9 554.3 347.7 554.3 354.2 542.4 347.3 542.4 340.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M543.5,340.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M542.1,347.1l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M543.5,368.9l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "542.4 369.1 554.3 375.9 554.3 382.4 542.4 375.5 542.4 369.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M543.5,368.9l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M542.1,375.3l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M503.5,319.2l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "502.4 319.3 514.3 326.2 514.3 332.6 502.4 325.8 502.4 319.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M503.5,319.2l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M502.1,325.6l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M503.5,347.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "502.4 347.5 514.3 354.4 514.3 360.8 502.4 354 502.4 347.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M503.5,347.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M502.1,353.8l12.6,7.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "575.3 72.6 664.2 123.9 575.4 175.2 486.6 123.9 575.3 72.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "499.3 107.8 522.4 121.1 522.4 134.4 499.3 121.1 499.3 107.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "522.9 121.1 546 107.8 546 121.1 522.9 134.4 522.9 121.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M524.5,94.5l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.5,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.5,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "554.6 140.6 577.7 153.9 577.7 167.2 554.6 153.9 554.6 140.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "578.2 153.9 601.3 140.6 601.3 153.9 578.2 167.2 578.2 153.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M579.8,127.3l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.5,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.5,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "547.5 80.1 570.6 93.4 570.6 106.7 547.5 93.4 547.5 80.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "571.1 93.4 594.1 80.1 594.1 93.4 571.1 106.7 571.1 93.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M572.6,66.8l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.5,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.5,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "547.5 80.1 570.6 93.4 570.6 106.7 547.5 93.4 547.5 80.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "571.1 93.4 594.1 80.1 594.1 93.4 571.1 106.7 571.1 93.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M572.6,66.8l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.5,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.5,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "602.8 112.9 625.9 126.2 625.9 139.5 602.8 126.2 602.8 112.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "626.4 126.2 649.5 112.9 649.5 126.2 626.4 139.5 626.4 126.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M628,99.6l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.5,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.4,103.1c-2.7-1.4-5.3-2.1-7.6-2.1s-3,.3-4.3,1c-3.1,1.6-4.9,5.1-4.9,9.9,0,10.1,7.8,22.3,17.5,27.4,4.5,2.4,8.8,2.8,11.9,1.1,3.1-1.6,4.9-5.1,4.9-9.9,0-10.1-7.8-22.3-17.5-27.4h0ZM566.7,112.5c-.2-.3,0-.8.3-1,3-1.6,7-1.3,11.2.9,4.1,2.1,7.9,5.8,10.7,10.2.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.4-2.7-4.3-6.3-7.7-10.2-9.7-3.7-1.9-7.1-2.2-9.7-.9s-.8,0-1-.2h.1ZM569.3,116.5c-.2-.3,0-.8.3-1,2.3-1.3,5.4-1,8.6.7,3.1,1.6,6,4.4,8.1,7.8.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.4-2-3.2-4.7-5.8-7.5-7.2-2.7-1.4-5.2-1.6-7-.7s-.8,0-1-.2h0ZM579.4,130.1c-.3.1-.5.2-.8.2s-.8-.1-1.2-.3c-1.2-.6-2.2-2.1-2.2-3.4s.3-1.3.9-1.6,1.3-.3,2,0c1.2.6,2.2,2.1,2.2,3.4s-.3,1.3-.9,1.6h0ZM582.4,126c-1.3-2.1-3.1-3.8-4.9-4.7-1.7-.9-3.3-1.1-4.4-.5-.4.2-.8,0-1-.2-.2-.3,0-.8.3-1,1.6-.9,3.8-.7,6,.4,2.1,1.1,4,3,5.5,5.2.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.4h0v.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M577.4,126.2h-.4c0,0,0,0,0,0v.4c0,.8.7,1.8,1.4,2.2.3.1.4.1.5.1v-.4c0-.8-.7-1.8-1.4-2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M578.2,125c-.7-.4-1.5-.4-2,0-.6.3-.9.9-.9,1.6,0,1.3,1,2.8,2.2,3.4s.8.3,1.2.3.6,0,.8-.2c.6-.3.9-.9.9-1.6,0-1.3-1-2.8-2.2-3.4h0ZM578.7,128.9s-.2,0-.5-.1c-.7-.4-1.4-1.4-1.4-2.2s0-.4,0-.4h.4c.7.4,1.4,1.4,1.4,2.2s0,.4,0,.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M583.4,126.2c.4-.2.5-.6.3-1-1.5-2.3-3.4-4.2-5.5-5.2-2.2-1.2-4.4-1.3-6-.4-.4.2-.5.6-.3,1,.2.3.7.4,1,.2,1.1-.6,2.7-.5,4.4.5,1.9,1,3.6,2.6,4.9,4.7,0,.2.4.4.7.4h.4v-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M577.4,117.4c2.8,1.5,5.5,4,7.5,7.2,0,.2.4.4.7.4h.4c.4-.2.5-.6.3-1-2.2-3.4-5-6.1-8.1-7.8-3.2-1.7-6.3-1.9-8.6-.7-.4.2-.5.6-.3,1,.2.3.7.4,1,.2,1.8-1,4.3-.8,7,.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M577.4,113.6c3.8,2,7.5,5.5,10.2,9.7,0,.2.4.4.7.4h.4c.4-.2.5-.6.3-1-2.8-4.5-6.7-8.1-10.7-10.2-4.2-2.2-8.2-2.5-11.2-.9-.4.2-.5.6-.3,1,.2.3.7.4,1,.2,2.5-1.4,6-1,9.7.9h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M586.2,108.1c-2.4-2.5-5.2-4.6-8-6.1-5-2.6-9.8-3-13.4-1.1-3.6,1.9-5.6,5.8-5.6,11.1,0,10.5,8.2,23.3,18.3,28.6,1.7.9,3.4,1.5,5,1.9.5.1,1,.2,1.5.3.6,0,1.2.1,1.8.1,1.8,0,3.5-.4,5-1.2,2.2-1.1,3.7-3,4.7-5.4.2-.4.3-.9.4-1.3.3-1.3.5-2.8.5-4.3,0-5.5-2.2-11.6-5.8-16.9-.3-.4-.5-.8-.8-1.2-.6-.8-1.2-1.5-1.8-2.3-.6-.7-1.2-1.4-1.9-2.1h0ZM590.1,140.4c-3.1,1.6-7.3,1.2-11.9-1.1-9.7-5-17.5-17.3-17.5-27.4s1.7-8.2,4.9-9.9c1.3-.7,2.7-1,4.3-1,2.3,0,4.9.7,7.6,2.1,9.7,5,17.5,17.3,17.5,27.4s-1.7,8.2-4.9,9.9h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "338.5 218.5 434.9 274.1 434.9 511.9 338.5 456.2 338.5 218.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M406.6,286.2v66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M383.5,272.9v66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M360.4,259.6v66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M406.6,375.9v66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M383.5,362.6v66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M360.4,349.2v66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "435.9 273.9 533.3 217.7 533.3 455.7 435.9 511.9 435.9 273.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M511.3,256v67.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M488.3,269.3v67.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M465.2,282.7v67.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M511.3,347.2v67.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M488.3,360.6v67.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M465.2,373.9v67.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "435.7 161.8 532.8 217.8 435.7 273.9 338.7 217.9 435.7 161.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "382.6 173.3 435.5 203.9 435.5 256.7 382.6 226.1 382.6 173.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "436.2 203.9 489.2 173.4 489.2 226.2 436.2 256.7 436.2 203.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M437.8,142.8l50.3,29c1,.6,1,1.5,0,2l-50.6,29.2c-1,.6-2.6.6-3.5,0l-50.3-29c-1-.6-1-1.5,0-2l50.6-29.2c1-.6,2.6-.6,3.5,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "401.9 150.8 435.1 169.9 435.1 189 401.9 169.9 401.9 150.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "435.8 169.9 468.9 150.8 468.9 169.9 435.8 189 435.8 169.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M437.3,131.3l30.8,17.8c1,.6,1,1.5,0,2l-30.9,17.9c-1,.6-2.6.6-3.5,0l-30.8-17.8c-1-.6-1-1.5,0-2l30.9-17.9c1-.6,2.6-.6,3.5,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-186.5 196.1 -97.7 144.8 -97.7 405.2 -186.5 456.5 -186.5 196.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-186,280.9l87.9-50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-186,365l87.9-50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-169.3,204.3l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-168.8,204.8l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-169.3,234l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-168.8,234.5l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-147,190.7l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-146.5,191.2l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-147,220.5l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-146.5,220.9l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-124.2,177.6l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-123.7,178.1l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-124.2,207.4l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-123.7,207.8l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-169.3,287.4l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-168.8,287.9l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-169.3,317.2l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-168.8,317.6l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-147,273.9l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-146.5,274.3l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-147,303.6l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-146.5,304.1l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-124.2,260.8l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-123.7,261.2l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-124.2,290.5l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-123.7,291l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-169.3,370.4l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-168.8,370.8l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-169.3,400.1l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-168.8,400.5l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-147,356.8l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-146.5,357.2l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-147,386.5l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-146.5,387l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-124.2,343.7l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-123.7,344.2l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-124.2,373.4l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-123.7,373.9l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-275.6 144.8 -186.9 196.1 -186.9 456.5 -275.6 405.2 -275.6 144.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-275.2,230.2l87.9,50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-275.2,314.2l87.9,50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-218.5,195.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-219.6 195.4 -207.7 202.3 -207.7 208.7 -219.6 201.9 -219.6 195.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-218.5,195.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-219.9,201.7l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-218.5,223.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-219.6 223.6 -207.7 230.5 -207.7 236.9 -219.6 230.1 -219.6 223.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-218.5,223.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-219.9,229.9l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-258.5,173.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-259.6 173.9 -247.7 180.8 -247.7 187.2 -259.6 180.4 -259.6 173.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-258.5,173.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-259.9,180.2l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-258.5,201.9l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-259.6 202.1 -247.7 209 -247.7 215.4 -259.6 208.6 -259.6 202.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-258.5,201.9l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-259.9,208.4l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-218.5,278.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-219.6 278.5 -207.7 285.3 -207.7 291.8 -219.6 284.9 -219.6 278.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-218.5,278.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-219.9,284.7l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-218.5,306.5l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-219.6 306.7 -207.7 313.5 -207.7 320 -219.6 313.1 -219.6 306.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-218.5,306.5l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-219.9,312.9l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-258.5,256.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-259.6 256.9 -247.7 263.8 -247.7 270.2 -259.6 263.4 -259.6 256.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-258.5,256.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-259.9,263.2l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-258.5,284.9l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-259.6 285.1 -247.7 292 -247.7 298.4 -259.6 291.6 -259.6 285.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-258.5,284.9l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-259.9,291.4l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-218.5,361.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-219.6 361.5 -207.7 368.3 -207.7 374.8 -219.6 367.9 -219.6 361.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-218.5,361.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-219.9,367.7l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-218.5,389.5l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-219.6 389.7 -207.7 396.5 -207.7 403 -219.6 396.1 -219.6 389.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-218.5,389.5l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-219.9,395.9l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-258.5,339.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-259.6 340 -247.7 346.8 -247.7 353.3 -259.6 346.4 -259.6 340"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-258.5,339.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-259.9,346.2l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-258.5,368l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-259.6 368.2 -247.7 375 -247.7 381.5 -259.6 374.6 -259.6 368.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-258.5,368l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-259.9,374.4l12.6,7.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-186.7 93.3 -97.8 144.6 -186.6 195.8 -275.4 144.5 -186.7 93.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-262.7 128.4 -239.6 141.7 -239.6 155 -262.7 141.7 -262.7 128.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-239.1 141.7 -216.1 128.4 -216.1 141.7 -239.1 155 -239.1 141.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-237.6,115.1l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.5,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.5,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-207.4 161.2 -184.3 174.5 -184.3 187.8 -207.4 174.5 -207.4 161.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-183.8 174.5 -160.7 161.2 -160.7 174.5 -183.8 187.8 -183.8 174.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-182.2,147.9l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.6,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.6,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-214.5 100.7 -191.5 114 -191.5 127.4 -214.5 114 -214.5 100.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-191 114 -167.9 100.7 -167.9 114 -191 127.4 -191 114"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-189.4,87.4l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.6,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.6,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-214.5 100.7 -191.5 114 -191.5 127.4 -214.5 114 -214.5 100.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-191 114 -167.9 100.7 -167.9 114 -191 127.4 -191 114"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-189.4,87.4l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.6,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.6,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-159.2 133.5 -136.1 146.8 -136.1 160.2 -159.2 146.8 -159.2 133.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-135.6 146.8 -112.5 133.5 -112.5 146.8 -135.6 160.2 -135.6 146.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-134,120.2l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.6,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-184.6,123.8c-2.7-1.4-5.3-2.1-7.6-2.1s-3,.3-4.3,1c-3.1,1.6-4.9,5.1-4.9,9.9,0,10.1,7.8,22.3,17.5,27.4,4.5,2.4,8.8,2.8,11.9,1.1,3.1-1.6,4.9-5.1,4.9-9.9,0-10.1-7.8-22.3-17.5-27.4h0ZM-195.3,133.1c-.2-.3,0-.8.3-1,3-1.6,7-1.3,11.2.9,4.1,2.1,7.9,5.8,10.7,10.2.2.3,0,.8-.3,1h-.4c-.3,0-.5-.1-.7-.4-2.7-4.3-6.3-7.7-10.2-9.7-3.7-1.9-7.1-2.2-9.7-.9-.4.2-.8,0-1.1-.2h.2ZM-192.7,137.1c-.2-.3,0-.8.3-1,2.3-1.3,5.4-1,8.6.7,3.1,1.6,6,4.4,8.1,7.8.2.3,0,.8-.3,1h-.4c-.3,0-.5-.1-.7-.4-2-3.2-4.7-5.8-7.6-7.2-2.7-1.4-5.2-1.6-7-.7-.4.2-.8,0-1.1-.2h0ZM-182.6,150.7c-.3.1-.5.2-.8.2s-.8-.1-1.2-.3c-1.2-.6-2.2-2.1-2.2-3.4s.3-1.3.9-1.6c.6-.3,1.3-.3,2,.1,1.2.6,2.2,2.1,2.2,3.4s-.3,1.3-.9,1.6h0ZM-179.7,146.6c-1.3-2.1-3.1-3.8-4.9-4.7-1.7-.9-3.3-1.1-4.4-.5-.4.2-.8,0-1.1-.2-.2-.3,0-.8.3-1,1.6-.9,3.8-.7,6,.4,2.1,1.1,4.1,3,5.5,5.2.2.3,0,.8-.3,1,0,0-.2.1-.4.1-.3,0-.5-.1-.7-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-184.6,146.9c-.2-.1-.3-.1-.4-.1s0,0,0,0v.4c0,.8.7,1.8,1.4,2.2.3.1.4.1.5.1v-.4c0-.8-.7-1.8-1.4-2.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-183.8,145.7c-.7-.4-1.4-.4-2-.1s-.9.9-.9,1.6c0,1.3,1,2.8,2.2,3.4.4.2.8.3,1.2.3s.6,0,.8-.2c.6-.3.9-.9.9-1.6,0-1.3-1-2.8-2.2-3.4h0ZM-183.3,149.5s-.2,0-.5-.1c-.7-.4-1.4-1.4-1.4-2.2s0-.4,0-.4h0s.2,0,.4.1c.7.4,1.4,1.4,1.4,2.2s0,.4,0,.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-178.6,146.9c.4-.2.5-.6.3-1-1.4-2.3-3.4-4.2-5.5-5.2-2.2-1.2-4.4-1.3-6-.4-.4.2-.5.6-.3,1,.2.3.7.4,1.1.2,1.1-.6,2.7-.5,4.4.5,1.9,1,3.6,2.6,4.9,4.7,0,.2.4.4.7.4s.3,0,.4-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-184.6,138c2.8,1.5,5.5,4,7.6,7.2,0,.2.4.4.7.4h.4c.4-.2.5-.6.3-1-2.2-3.4-5-6.1-8.1-7.8-3.2-1.7-6.3-1.9-8.6-.7-.4.2-.5.6-.3,1,.2.3.7.4,1.1.2,1.8-1,4.3-.8,7,.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-184.6,134.2c3.8,2,7.4,5.5,10.2,9.7,0,.2.4.4.7.4h.4c.4-.2.5-.6.3-1-2.8-4.5-6.7-8.1-10.7-10.2-4.2-2.2-8.2-2.5-11.2-.9-.4.2-.5.6-.3,1,.2.3.7.4,1.1.2,2.5-1.4,5.9-1,9.7.9h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-175.8,128.7c-2.4-2.5-5.2-4.6-8-6.1-5-2.6-9.8-3-13.4-1.1s-5.6,5.8-5.6,11.1c0,10.5,8.2,23.3,18.3,28.6,1.7.9,3.4,1.5,5,1.9.5.1,1,.2,1.5.3.6,0,1.2.1,1.8.1,1.8,0,3.5-.4,5-1.2,2.2-1.1,3.7-3,4.7-5.4.2-.4.3-.9.4-1.3.3-1.3.5-2.8.5-4.3,0-5.5-2.2-11.6-5.8-16.9-.3-.4-.5-.8-.8-1.2-.6-.8-1.2-1.5-1.8-2.3-.6-.7-1.2-1.4-1.9-2.1h.1ZM-171.9,161c-3.1,1.6-7.3,1.2-11.9-1.1-9.7-5-17.5-17.3-17.5-27.4s1.7-8.2,4.9-9.9c1.3-.7,2.7-1,4.3-1,2.3,0,4.9.7,7.6,2.1,9.7,5,17.5,17.3,17.5,27.4s-1.7,8.2-4.9,9.9h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1440.9 206.4 1529.7 155.1 1529.7 415.5 1440.9 466.7 1440.9 206.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1441.3,291.2l87.9-50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1441.3,375.3l87.9-50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1458,214.6l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1458.6,215l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1458,244.3l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1458.6,244.8l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1480.4,201l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1480.9,201.5l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1480.4,230.8l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1480.9,231.2l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1503.1,187.9l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1503.7,188.4l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1503.1,217.7l8.9-5.2c1-.6,1.8-.1,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8.1-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1503.7,218.1l7.9-4.6c.9-.5,1.6-.1,1.6,1h0c0,1-.7,2.3-1.6,2.9l-7.9,4.6c-.9.5-1.6.1-1.6-1h0c0-1,.7-2.3,1.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1458,297.7l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1458.6,298.2l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1458,327.4l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1458.6,327.9l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1480.4,284.2l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1480.9,284.6l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1480.4,313.9l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1480.9,314.3l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1503.1,271.1l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1503.7,271.5l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1503.1,300.8l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1503.7,301.2l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1458,380.6l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1458.6,381.1l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1458,410.4l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1458.6,410.8l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1480.4,367.1l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1480.9,367.5l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1480.4,396.8l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1480.9,397.3l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1503.1,354l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1503.7,354.4l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1503.1,383.7l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1503.7,384.2l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1351.7 155.1 1440.5 206.4 1440.5 466.7 1351.7 415.5 1351.7 155.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1352.2,240.5l87.9,50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1352.2,324.5l87.9,50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1408.8,205.5l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1407.8 205.7 1419.6 212.6 1419.6 219 1407.8 212.2 1407.8 205.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1408.8,205.5l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1407.4,212l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1408.8,233.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1407.8 233.9 1419.6 240.8 1419.6 247.2 1407.8 240.4 1407.8 233.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1408.8,233.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1407.4,240.2l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1368.9,184l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1367.8 184.2 1379.7 191 1379.7 197.5 1367.8 190.6 1367.8 184.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1368.9,184l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1367.4,190.4l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1368.9,212.2l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1367.8 212.4 1379.7 219.2 1379.7 225.7 1367.8 218.8 1367.8 212.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1368.9,212.2l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.9c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.9c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1367.4,218.6l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1408.8,288.6l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1407.8 288.7 1419.6 295.6 1419.6 302 1407.8 295.2 1407.8 288.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1408.8,288.6l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1407.4,295l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1408.8,316.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1407.8 316.9 1419.6 323.8 1419.6 330.2 1407.8 323.4 1407.8 316.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1408.8,316.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1407.4,323.2l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1368.9,267l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1367.8 267.2 1379.7 274.1 1379.7 280.5 1367.8 273.7 1367.8 267.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1368.9,267l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1367.4,273.5l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1368.9,295.2l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1367.8 295.4 1379.7 302.3 1379.7 308.7 1367.8 301.9 1367.8 295.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1368.9,295.2l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1367.4,301.7l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1408.8,371.6l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1407.8 371.8 1419.6 378.6 1419.6 385.1 1407.8 378.2 1407.8 371.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1408.8,371.6l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1407.4,378l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1408.8,399.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1407.8 400 1419.6 406.8 1419.6 413.3 1407.8 406.4 1407.8 400"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1408.8,399.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1407.4,406.2l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1368.9,350.1l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1367.8 350.2 1379.7 357.1 1379.7 363.6 1367.8 356.7 1367.8 350.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1368.9,350.1l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1367.4,356.5l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1368.9,378.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1367.8 378.4 1379.7 385.3 1379.7 391.7 1367.8 384.9 1367.8 378.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1368.9,378.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16.8c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16.8c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1367.4,384.7l12.6,7.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1440.7 103.6 1529.5 154.9 1440.8 206.1 1351.9 154.8 1440.7 103.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1364.7 138.7 1387.7 152 1387.7 165.3 1364.7 152 1364.7 138.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1388.2 152 1411.3 138.7 1411.3 152 1388.2 165.3 1388.2 152"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1389.8,125.4l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.6,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.6,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1420 171.5 1443.1 184.8 1443.1 198.1 1420 184.8 1420 171.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1443.6 184.8 1466.7 171.5 1466.7 184.8 1443.6 198.1 1443.6 184.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1445.2,158.2l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.6,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.6,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1412.8 111 1435.9 124.3 1435.9 137.6 1412.8 124.3 1412.8 111"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1436.4 124.3 1459.5 111 1459.5 124.3 1436.4 137.6 1436.4 124.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1438,97.7l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.6,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.6,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1412.8 111 1435.9 124.3 1435.9 137.6 1412.8 124.3 1412.8 111"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1436.4 124.3 1459.5 111 1459.5 124.3 1436.4 137.6 1436.4 124.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1438,97.7l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.6,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.6,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1468.2 143.8 1491.3 157.1 1491.3 170.4 1468.2 157.1 1468.2 143.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1491.8 157.1 1514.8 143.8 1514.8 157.1 1491.8 170.4 1491.8 157.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1493.3,130.5l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.6,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.8,134c-2.7-1.4-5.3-2.1-7.6-2.1s-3,.3-4.3,1c-3.1,1.6-4.9,5.1-4.9,9.9,0,10.1,7.8,22.3,17.5,27.4,4.5,2.4,8.8,2.8,11.9,1.1,3.1-1.6,4.9-5.1,4.9-9.9,0-10.1-7.8-22.3-17.5-27.4ZM1432.1,143.4c-.2-.3,0-.8.3-1,3-1.6,7-1.3,11.2.9,4.1,2.1,7.9,5.8,10.7,10.2.2.3,0,.8-.3,1h-.4c-.3,0-.5-.1-.7-.4-2.7-4.3-6.3-7.7-10.2-9.7-3.7-1.9-7.1-2.2-9.7-.9-.4.2-.8,0-1.1-.2h.2ZM1434.7,147.4c-.2-.3,0-.8.3-1,2.3-1.3,5.4-1,8.6.7,3.1,1.6,6,4.4,8.1,7.8.2.3,0,.8-.3,1h-.4c-.3,0-.5-.1-.7-.4-2-3.2-4.7-5.8-7.6-7.2-2.7-1.4-5.2-1.6-7-.7-.4.2-.8,0-1.1-.2h0ZM1444.8,161c-.3.1-.5.2-.8.2s-.8-.1-1.2-.3c-1.2-.6-2.2-2.1-2.2-3.4s.3-1.3.9-1.6,1.3-.3,2,.1c1.2.6,2.2,2.1,2.2,3.4s-.3,1.3-.9,1.6h0ZM1447.7,156.9c-1.3-2.1-3.1-3.8-4.9-4.7-1.7-.9-3.3-1.1-4.4-.5-.4.2-.8,0-1.1-.2-.2-.3,0-.8.3-1,1.6-.9,3.8-.7,6,.4,2.1,1.1,4.1,3,5.5,5.2.2.3,0,.8-.3,1,0,0-.2.1-.4.1-.3,0-.5-.1-.7-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1442.8,157.2c-.2-.1-.3-.1-.4-.1s0,0,0,0v.4c0,.8.7,1.8,1.4,2.2.3.1.4.1.5.1v-.4c0-.8-.7-1.8-1.4-2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1443.5,155.9c-.7-.4-1.4-.4-2-.1s-.9.9-.9,1.6c0,1.3,1,2.8,2.2,3.4.4.2.8.3,1.2.3s.6,0,.8-.2c.6-.3.9-.9.9-1.6,0-1.3-1-2.8-2.2-3.4h0ZM1444,159.8s-.2,0-.5-.1c-.7-.4-1.4-1.4-1.4-2.2s0-.4,0-.4h0s.2,0,.4.1c.7.4,1.4,1.4,1.4,2.2s0,.4,0,.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1448.8,157.1c.4-.2.5-.6.3-1-1.4-2.3-3.4-4.2-5.5-5.2-2.2-1.2-4.4-1.3-6-.4-.4.2-.5.6-.3,1,.2.3.7.4,1.1.2,1.1-.6,2.7-.5,4.4.5,1.9,1,3.6,2.6,4.9,4.7,0,.2.4.4.7.4s.3,0,.4-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1442.8,148.3c2.8,1.5,5.5,4,7.6,7.2,0,.2.4.4.7.4h.4c.4-.2.5-.6.3-1-2.2-3.4-5-6.1-8.1-7.8-3.2-1.7-6.3-1.9-8.6-.7-.4.2-.5.6-.3,1,.2.3.7.4,1.1.2,1.8-1,4.3-.8,7,.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1442.8,144.5c3.8,2,7.4,5.5,10.2,9.7,0,.2.4.4.7.4h.4c.4-.2.5-.6.3-1-2.8-4.5-6.7-8.1-10.7-10.2-4.2-2.2-8.2-2.5-11.2-.9-.4.2-.5.6-.3,1,.2.3.7.4,1.1.2,2.5-1.4,5.9-1,9.7.9h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1451.6,139c-2.4-2.5-5.2-4.6-8-6.1-5-2.6-9.8-3-13.4-1.1s-5.6,5.8-5.6,11.1c0,10.5,8.2,23.3,18.3,28.6,1.7.9,3.4,1.5,5,1.9.5.1,1,.2,1.5.3.6,0,1.2.1,1.8.1,1.8,0,3.5-.4,5-1.2,2.2-1.1,3.7-3,4.7-5.4.2-.4.3-.9.4-1.3.3-1.3.5-2.8.5-4.3,0-5.5-2.2-11.6-5.8-16.9-.3-.4-.5-.8-.8-1.2-.6-.8-1.2-1.5-1.8-2.3-.6-.7-1.2-1.4-1.9-2.1h.1ZM1455.4,171.3c-3.1,1.6-7.3,1.2-11.9-1.1-9.7-5-17.5-17.3-17.5-27.4s1.7-8.2,4.9-9.9c1.3-.7,2.7-1,4.3-1,2.3,0,4.9.7,7.6,2.1,9.7,5,17.5,17.3,17.5,27.4s-1.7,8.2-4.9,9.9h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-182 399.7 -104.1 444.7 -104.1 491.4 -182 446.5 -182 399.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-103.7 444.4 -26.3 399.7 -26.3 446.8 -103.7 491.5 -103.7 444.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-141.6,376.6l77-44.5,38.3,67.5-77.6,45.2-37.6-68.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-182,399.1l40.5-22.5,37.4,68.2-77.9-45.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-109.2,366.4l9.4,5.4v27.7l-4.9-8.9-4.4-8.2v-16h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-99.7 371.6 -90.4 366.2 -90.4 394.1 -99.7 399.5 -99.7 371.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-98.7,361l7.8,4.5c.5.3.5.7,0,1l-8.1,4.7c-.5.3-1.3.3-1.8,0l-7.8-4.5c-.5-.3-.5-.7,0-1l8.1-4.7c.5-.3,1.3-.3,1.8,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "-150.3 391.4 -139.6 397.6 -139.6 415 -150.3 408.9 -150.3 391.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "-148.2 393.1 -140 397.8 -140 412.1 -148.2 407.4 -148.2 393.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-148.1,407.5l-2.2,1.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "-150.3 391.4 -139.6 397.6 -139.6 415 -150.3 408.9 -150.3 391.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "-175.8 414 -162 421.9 -162 444.4 -175.8 436.4 -175.8 414"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "-173.1 416.1 -162.6 422.2 -162.6 440.7 -173.1 434.6 -173.1 416.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-173,434.7l-2.9,1.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "-175.8 414 -162 421.9 -162 444.4 -175.8 436.4 -175.8 414"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "-152.2 426.3 -138.5 434.2 -138.5 456.7 -152.2 448.7 -152.2 426.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "-149.5 428.4 -139 434.5 -139 453 -149.5 446.9 -149.5 428.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-149.4,447l-2.9,1.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "-152.2 426.3 -138.5 434.2 -138.5 456.7 -152.2 448.7 -152.2 426.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "-127.6 439.6 -113.9 447.6 -113.9 470 -127.6 462.1 -127.6 439.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "-124.9 441.7 -114.4 447.8 -114.4 466.3 -124.9 460.2 -124.9 441.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-124.8,460.3l-2.9,1.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "-127.6 439.6 -113.9 447.6 -113.9 470 -127.6 462.1 -127.6 439.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "-65.8 439.2 -49.8 429.9 -49.8 459.8 -65.8 469 -65.8 439.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "-65.8 439.2 -52.3 431.4 -52.3 460.5 -65.8 468.3 -65.8 439.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "-63.1 449.9 -62.1 449.3 -62.1 454.6 -63.1 455.2 -63.1 449.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-100.4,349.9c-1.2-.6-2.3-.9-3.3-.9s-1.3,0-1.8.4c-1.3.7-2.1,2.2-2.1,4.2,0,4.3,3.4,9.6,7.5,11.7,1.9,1,3.7,1.2,5.1.5,1.3-.7,2.1-2.2,2.1-4.2,0-4.3-3.4-9.6-7.5-11.7ZM-105,353.9v-.4c1.3-.7,3-.6,4.8.4,1.8.9,3.4,2.5,4.6,4.4v.4h-.2s-.2,0-.3-.2c-1.2-1.8-2.7-3.3-4.4-4.2-1.6-.8-3.1-1-4.1-.4h-.4ZM-103.9,355.6v-.4c1-.5,2.3-.4,3.7.3,1.3.7,2.6,1.9,3.5,3.3v.4h-.2s-.2,0-.3-.2c-.9-1.4-2-2.5-3.2-3.1s-2.2-.7-3-.3h-.5ZM-99.5,361.4h-.9c-.5-.3-.9-.9-.9-1.5s0-.6.4-.7.6,0,.9,0c.5.3.9.9.9,1.5s0,.6-.4.7h0ZM-98.3,359.7c-.6-.9-1.3-1.6-2.1-2-.7-.4-1.4-.5-1.9-.2h-.4v-.4c.7-.4,1.6-.3,2.6.2.9.5,1.7,1.3,2.4,2.2v.4h-.2s-.2,0-.3-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-100.4,359.8h-.2v.2c0,.3.3.8.6.9h.2v-.2c0-.3-.3-.8-.6-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-100.1,359.3c-.3-.2-.6-.2-.9,0s-.4.4-.4.7c0,.5.4,1.2.9,1.5h.9c.2,0,.4-.4.4-.7,0-.5-.4-1.2-.9-1.5h0ZM-99.9,360.9h-.2c-.3-.2-.6-.6-.6-.9s0-.2,0-.2h.2c.3.2.6.6.6.9s0,.2,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-97.8,359.8c.2,0,.2-.3,0-.4-.6-1-1.5-1.8-2.4-2.2-1-.5-1.9-.6-2.6-.2-.2,0-.2.3,0,.4,0,0,.3.2.4,0,.5-.3,1.2-.2,1.9.2.8.4,1.6,1.1,2.1,2,0,0,.2.2.3.2,0,0,.3,0,.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-100.4,356c1.2.6,2.4,1.7,3.2,3.1,0,0,.2.2.3.2h.2c.2,0,.2-.3,0-.4-.9-1.5-2.2-2.6-3.5-3.3-1.4-.7-2.7-.8-3.7-.3-.2,0-.2.3,0,.4,0,0,.3.2.4,0,.8-.4,1.9-.3,3,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-100.4,354.4c1.6.9,3.2,2.3,4.4,4.2,0,0,.2.2.3.2h.2c.2,0,.2-.3,0-.4-1.2-1.9-2.9-3.5-4.6-4.4-1.8-.9-3.5-1.1-4.8-.4-.2,0-.2.3,0,.4,0,0,.3.2.4,0,1.1-.6,2.6-.5,4.1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-96.6,352c-1-1.1-2.2-2-3.4-2.6-2.1-1.1-4.2-1.3-5.8-.5s-2.4,2.5-2.4,4.7c0,4.5,3.5,10,7.8,12.2.7.4,1.4.7,2.1.8h1.5c.8,0,1.5-.2,2.2-.5.9-.5,1.6-1.3,2-2.3,0-.2,0-.4.2-.6,0-.6.2-1.2.2-1.9,0-2.3-.9-5-2.5-7.2,0-.2-.2-.3-.4-.5-.2-.3-.5-.7-.8-1s-.5-.6-.8-.9h0v.2h.1ZM-95,365.8c-1.3.7-3.1.5-5.1-.5-4.1-2.2-7.5-7.4-7.5-11.7s.7-3.5,2.1-4.2c.5-.3,1.2-.4,1.8-.4,1,0,2.1.3,3.3.9,4.1,2.2,7.5,7.4,7.5,11.7s-.7,3.5-2.1,4.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-163.7 535.7 -75 484.5 -75 659.8 -163.7 711 -163.7 535.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-163.3,619.5l87.9-50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-146.6,542l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-146.1,542.4l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-146.6,571.7l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-146.1,572.2l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-124.3,528.4l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-123.7,528.9l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-124.3,558.2l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-123.7,558.6l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-101.5,515.4l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-101,515.8l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-101.5,545.1l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-101,545.5l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-146.6,624.9l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-146.1,625.4l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-146.6,654.6l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-146.1,655.1l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-124.3,611.4l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-123.7,611.8l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-124.3,641.1l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-123.7,641.5l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-101.5,598.3l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-101,598.7l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-101.5,628l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-101,628.4l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-252.9 484.5 -164.1 535.7 -164.1 711 -252.9 659.8 -252.9 484.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-252.5,568.8l87.9,50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-193.4,537.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-194.5 537.4 -182.6 544.3 -182.6 550.5 -194.5 543.6 -194.5 537.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-193.4,537.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-194.8,543.4l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-193.4,564.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-194.5 564.6 -182.6 571.4 -182.6 577.6 -194.5 570.8 -194.5 564.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-193.4,564.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-194.8,570.6l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-233.4,515.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-234.5 515.9 -222.6 522.7 -222.6 528.9 -234.5 522.1 -234.5 515.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-233.4,515.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-234.8,521.9l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-233.4,542.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-234.5 543 -222.6 549.8 -222.6 556 -234.5 549.2 -234.5 543"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-233.4,542.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-234.8,549l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-193.4,618.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-194.5 618.4 -182.6 625.3 -182.6 631.5 -194.5 624.6 -194.5 618.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-193.4,618.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-194.8,624.4l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-193.4,645.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-194.5 645.5 -182.6 652.4 -182.6 658.6 -194.5 651.7 -194.5 645.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-193.4,645.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-194.8,651.5l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-233.4,596.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-234.5 596.8 -222.6 603.7 -222.6 609.9 -234.5 603 -234.5 596.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-233.4,596.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-234.8,602.8l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-233.4,623.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-234.5 624 -222.6 630.8 -222.6 637 -234.5 630.2 -234.5 624"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-233.4,623.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-234.8,629.9l12.6,7.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-164 432.8 -75.1 484.1 -163.8 535.4 -252.7 484.1 -164 432.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-162.7 441.2 -90.4 482.9 -165.3 526.1 -237.5 484.4 -162.7 441.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-229.9,488.7l66.6-38.4,64.1,36.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-186.7 476.9 -163.6 490.2 -163.6 503.5 -186.7 490.2 -186.7 476.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-163.1 490.2 -140 476.9 -140 490.2 -163.1 503.5 -163.1 490.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-161.5,463.6l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.6,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-166,440.5c-2.7-1.4-5.3-2.1-7.6-2.1s-3,.3-4.3,1c-3.1,1.6-4.9,5.1-4.9,9.8,0,10.1,7.8,22.3,17.5,27.4,4.5,2.4,8.8,2.8,11.9,1.1s4.9-5.1,4.9-9.8c0-10.1-7.8-22.3-17.5-27.4h0ZM-176.7,449.8c-.2-.3,0-.8.3-1,3-1.6,7-1.3,11.2.9,4.1,2.1,7.9,5.8,10.7,10.2.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.3-2.7-4.3-6.3-7.7-10.2-9.7-3.7-1.9-7.1-2.2-9.7-.9-.4.2-.8,0-1.1-.2h.2ZM-174.1,453.8c-.2-.3,0-.8.3-1,2.3-1.3,5.4-1,8.6.7,3.1,1.6,6,4.4,8.1,7.8.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.3-2-3.2-4.7-5.8-7.6-7.2-2.7-1.4-5.2-1.7-7-.7-.4.2-.8,0-1.1-.2h0ZM-163.9,467.4c-.3,0-.5.2-.8.2s-.8,0-1.2-.3c-1.2-.6-2.2-2.1-2.2-3.4s.3-1.3.9-1.7c.6-.3,1.3-.3,2,0,1.2.6,2.2,2.1,2.2,3.4s-.3,1.3-.9,1.7h0ZM-161,463.3c-1.3-2.1-3.1-3.8-4.9-4.7-1.7-.9-3.3-1.1-4.4-.5-.4.2-.8,0-1.1-.2-.2-.3,0-.8.3-1,1.6-.9,3.8-.7,6,.4,2.1,1.1,4.1,3,5.5,5.2.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-166,463.6h-.4v.4c0,.8.7,1.8,1.4,2.2h.5v-.4c0-.8-.7-1.8-1.4-2.2h-.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-165.2,462.4c-.7-.4-1.4-.4-2,0-.6.3-.9.9-.9,1.7,0,1.3,1,2.8,2.2,3.4.4.2.8.3,1.2.3s.6,0,.8-.2c.6-.3.9-.9.9-1.7,0-1.3-1-2.8-2.2-3.4h0ZM-164.7,466.2h-.5c-.7-.4-1.4-1.4-1.4-2.2s0-.4,0-.4h.4c.7.4,1.4,1.4,1.4,2.2s0,.4,0,.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-160,463.6c.4-.2.5-.6.3-1-1.4-2.3-3.4-4.2-5.5-5.2-2.2-1.2-4.4-1.3-6-.4-.4.2-.5.6-.3,1s.7.4,1.1.2c1.1-.6,2.7-.5,4.4.5,1.9,1,3.6,2.7,4.9,4.7,0,.2.4.3.7.3h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-166,454.7c2.8,1.5,5.5,4,7.6,7.2,0,.2.4.3.7.3h.4c.4-.2.5-.6.3-1-2.2-3.4-5-6.2-8.1-7.8-3.2-1.7-6.3-1.9-8.6-.7-.4.2-.5.6-.3,1s.7.4,1.1.2c1.8-1,4.3-.8,7,.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-166,450.9c3.8,2,7.4,5.5,10.2,9.7,0,.2.4.3.7.3h.4c.4-.2.5-.6.3-1-2.8-4.5-6.7-8.1-10.7-10.2-4.2-2.2-8.2-2.5-11.2-.9-.4.2-.5.6-.3,1s.7.4,1.1.2c2.5-1.4,5.9-1,9.7.9h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-157.2,445.4c-2.4-2.5-5.2-4.6-8-6.1-5-2.6-9.8-3-13.4-1.1s-5.6,5.8-5.6,11.1c0,10.5,8.2,23.3,18.3,28.6,1.7.9,3.4,1.5,5,1.9.5,0,1,.2,1.5.3h1.8c1.8,0,3.5-.4,5-1.2,2.2-1.1,3.7-3,4.7-5.4.2-.4.3-.9.4-1.3.4-1.3.5-2.8.5-4.3,0-5.5-2.2-11.6-5.8-16.9-.3-.4-.5-.8-.8-1.2-.6-.8-1.2-1.5-1.8-2.3-.6-.7-1.2-1.4-1.9-2.1h.1ZM-153.3,477.7c-3.1,1.6-7.3,1.2-11.9-1.1-9.7-5-17.5-17.3-17.5-27.4s1.7-8.2,4.9-9.8c1.3-.7,2.7-1,4.3-1,2.3,0,4.9.7,7.6,2.1,9.7,5,17.5,17.3,17.5,27.4s-1.7,8.2-4.9,9.8h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "372.5 564.1 461.2 512.8 461.2 688.1 372.5 739.4 372.5 564.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M372.9,647.9l87.9-50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M389.6,570.3l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M390.1,570.8l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M389.6,600.1l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M390.1,600.5l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M411.9,556.8l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M412.5,557.2l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M411.9,586.5l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M412.5,586.9l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M434.7,543.7l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M435.2,544.1l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M434.7,573.4l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M435.2,573.9l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M389.6,653.2l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M390.1,653.7l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M389.6,683l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M390.1,683.4l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M411.9,639.7l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M412.5,640.2l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M411.9,669.4l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M412.5,669.9l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M434.7,626.6l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M435.2,627.1l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M434.7,656.3l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M435.2,656.8l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "283.3 512.8 372.1 564.1 372.1 739.4 283.3 688.1 283.3 512.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M283.7,597.1l87.9,50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M342.8,565.6l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "341.7 565.8 353.6 572.6 353.6 578.8 341.7 572 341.7 565.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M342.8,565.6l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M341.4,571.8l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M342.8,592.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "341.7 592.9 353.6 599.7 353.6 605.9 341.7 599.1 341.7 592.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M342.8,592.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M341.4,598.9l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.8,544.1l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "301.7 544.2 313.6 551.1 313.6 557.2 301.7 550.4 301.7 544.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M302.8,544.1l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M301.4,550.2l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.8,571.2l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "301.7 571.3 313.6 578.2 313.6 584.4 301.7 577.5 301.7 571.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M302.8,571.2l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M301.4,577.3l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M342.8,646.6l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "341.7 646.8 353.6 653.6 353.6 659.8 341.7 653 341.7 646.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M342.8,646.6l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M341.4,652.8l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M342.8,673.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "341.7 673.9 353.6 680.7 353.6 686.9 341.7 680.1 341.7 673.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M342.8,673.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M341.4,679.9l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.8,625l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "301.7 625.2 313.6 632 313.6 638.2 301.7 631.4 301.7 625.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M302.8,625l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M301.4,631.2l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.8,652.1l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "301.7 652.3 313.6 659.1 313.6 665.3 301.7 658.5 301.7 652.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M302.8,652.1l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M301.4,658.3l12.6,7.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "372.2 461.2 461.1 512.5 372.4 563.7 283.5 512.4 372.2 461.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "373.5 469.6 445.8 511.2 370.9 554.5 298.7 512.8 373.5 469.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M306.4,517l66.6-38.4,64.1,36.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "349.5 505.2 372.6 518.5 372.6 531.8 349.5 518.5 349.5 505.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "373.1 518.5 396.2 505.2 396.2 518.5 373.1 531.8 373.1 518.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M374.7,491.9l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.5,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.5,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.2,468.8c-2.7-1.4-5.3-2.1-7.6-2.1s-3,.3-4.3,1c-3.1,1.6-4.9,5.1-4.9,9.8,0,10.1,7.8,22.3,17.5,27.4,4.5,2.4,8.8,2.8,11.9,1.1s4.9-5.1,4.9-9.8c0-10.1-7.8-22.3-17.5-27.4h0ZM359.5,478.1c-.2-.3,0-.8.3-1,3-1.6,7-1.3,11.2.9,4.1,2.1,7.9,5.8,10.7,10.2.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.3-2.7-4.3-6.3-7.7-10.2-9.7-3.7-1.9-7.1-2.2-9.7-.9-.4.2-.8,0-1-.2h.1ZM362.1,482.2c-.2-.3,0-.8.3-1,2.3-1.3,5.4-1,8.6.7,3.1,1.6,6,4.4,8.1,7.8.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.3-2-3.2-4.7-5.8-7.5-7.2-2.7-1.4-5.2-1.7-7-.7-.4.2-.8,0-1-.2h-.1ZM372.3,495.7c-.3,0-.5.2-.8.2s-.8,0-1.2-.3c-1.2-.6-2.2-2.1-2.2-3.4s.3-1.3.9-1.7c.6-.3,1.3-.3,2,0,1.2.6,2.2,2.1,2.2,3.4s-.3,1.3-.9,1.7h0ZM375.2,491.6c-1.3-2.1-3.1-3.8-4.9-4.7-1.7-.9-3.3-1.1-4.4-.5-.4.2-.8,0-1-.2-.2-.3,0-.8.3-1,1.6-.9,3.8-.7,6,.4,2.1,1.1,4,3,5.5,5.2.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.3h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M370.2,491.9h-.4c-.1,0,0,0,0,0v.4c0,.8.7,1.8,1.4,2.2h.5v-.4c0-.8-.7-1.8-1.4-2.2h-.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M371,490.7c-.7-.4-1.5-.4-2,0-.6.3-.9.9-.9,1.7,0,1.3,1,2.8,2.2,3.4.4.2.8.3,1.2.3s.6,0,.8-.2c.6-.3.9-.9.9-1.7,0-1.3-1-2.8-2.2-3.4h0ZM371.5,494.5h-.5c-.7-.4-1.4-1.4-1.4-2.2s0-.4,0-.4h.4c.7.4,1.4,1.4,1.4,2.2s0,.4,0,.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M376.2,491.9c.4-.2.5-.6.3-1-1.5-2.3-3.4-4.2-5.5-5.2-2.2-1.2-4.4-1.3-6-.4-.4.2-.5.6-.3,1s.7.4,1,.2c1.1-.6,2.7-.5,4.4.5,1.9,1,3.6,2.7,4.9,4.7,0,.2.4.3.7.3h.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M370.2,483.1c2.8,1.5,5.5,4,7.5,7.2,0,.2.4.3.7.3h.4c.4-.2.5-.6.3-1-2.2-3.4-5-6.2-8.1-7.8-3.2-1.7-6.3-1.9-8.6-.7-.4.2-.5.6-.3,1s.7.4,1,.2c1.8-1,4.3-.8,7,.7h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M370.2,479.2c3.8,2,7.5,5.5,10.2,9.7,0,.2.4.3.7.3h.4c.4-.2.5-.6.3-1-2.8-4.5-6.7-8.1-10.7-10.2-4.2-2.2-8.2-2.5-11.2-.9-.4.2-.5.6-.3,1s.7.4,1,.2c2.5-1.4,6-1,9.7.9h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M379.1,473.7c-2.4-2.5-5.2-4.6-8-6.1-5-2.6-9.8-3-13.4-1.1s-5.6,5.8-5.6,11.1c0,10.5,8.2,23.3,18.3,28.6,1.7.9,3.4,1.5,5,1.9.5,0,1,.2,1.5.3h1.8c1.8,0,3.5-.4,5-1.2,2.2-1.1,3.7-3,4.7-5.4.2-.4.3-.9.4-1.3.3-1.3.5-2.8.5-4.3,0-5.5-2.2-11.6-5.8-16.9-.3-.4-.5-.8-.8-1.2-.6-.8-1.2-1.5-1.8-2.3-.6-.7-1.2-1.4-1.9-2.1h0ZM382.9,506c-3.1,1.6-7.3,1.2-11.9-1.1-9.7-5-17.5-17.3-17.5-27.4s1.7-8.2,4.9-9.8c1.3-.7,2.7-1,4.3-1,2.3,0,4.9.7,7.6,2.1,9.7,5,17.5,17.3,17.5,27.4s-1.7,8.2-4.9,9.8h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "137.8 400.4 226.6 349.2 226.6 524.5 137.8 575.7 137.8 400.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M138.3,484.2l87.9-50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M155,406.7l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M155.5,407.1l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M155,436.4l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M155.5,436.9l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M177.3,393.1l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M177.8,393.6l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M177.3,422.8l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M177.8,423.3l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M200.1,380l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M200.6,380.5l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M200.1,409.8l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M200.6,410.2l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M155,489.6l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M155.5,490.1l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M155,519.3l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M155.5,519.8l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M177.3,476l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M177.8,476.5l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M177.3,505.8l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M177.8,506.2l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M200.1,462.9l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M200.6,463.4l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M200.1,492.7l8.9-5.2c1-.6,1.8,0,1.8,1v15.6c0,1.1-.8,2.5-1.8,3.1l-8.9,5.2c-1,.6-1.8,0-1.8-1v-15.6c0-1.1.8-2.5,1.8-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M200.6,493.1l7.9-4.6c.9-.5,1.6,0,1.6,1h0c0,1-.7,2.3-1.6,2.8l-7.9,4.6c-.9.5-1.6,0-1.6-1h0c0-1,.7-2.3,1.6-2.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "48.6 349.2 137.4 400.4 137.4 575.7 48.6 524.5 48.6 349.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M49.1,433.5l87.9,50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M108.1,402l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "107.1 402.1 118.9 409 118.9 415.2 107.1 408.3 107.1 402.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M108.1,402l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M106.7,408.1l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M108.1,429.1l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "107.1 429.2 118.9 436.1 118.9 442.3 107.1 435.4 107.1 429.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M108.1,429.1l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M106.7,435.2l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68.2,380.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "67.1 380.6 79 387.4 79 393.6 67.1 386.7 67.1 380.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M68.2,380.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M66.7,386.5l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68.2,407.5l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "67.1 407.7 79 414.5 79 420.7 67.1 413.9 67.1 407.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M68.2,407.5l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M66.7,413.6l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M108.1,483l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "107.1 483.1 118.9 490 118.9 496.2 107.1 489.3 107.1 483.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M108.1,483l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M106.7,489.1l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M108.1,510.1l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "107.1 510.2 118.9 517.1 118.9 523.3 107.1 516.4 107.1 510.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M108.1,510.1l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M106.7,516.2l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68.2,461.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "67.1 461.5 79 468.4 79 474.6 67.1 467.7 67.1 461.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M68.2,461.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M66.7,467.5l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68.2,488.5l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "67.1 488.6 79 495.5 79 501.7 67.1 494.8 67.1 488.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M68.2,488.5l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M66.7,494.6l12.6,7.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "137.6 297.5 226.4 348.8 137.7 400 48.9 348.7 137.6 297.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "138.9 305.9 211.1 347.6 136.3 390.8 64 349.1 138.9 305.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M71.7,353.4l66.6-38.4,64.1,36.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "114.9 341.5 138 354.9 138 368.2 114.9 354.9 114.9 341.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "138.5 354.9 161.5 341.5 161.5 354.9 138.5 368.2 138.5 354.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M140,328.3l20.4,11.8c1,.6,1,1.5,0,2l-20.5,11.8c-1,.6-2.6.6-3.5,0l-20.4-11.8c-1-.6-1-1.5,0-2l20.5-11.8c1-.6,2.6-.6,3.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.6,305.1c-2.7-1.4-5.3-2.1-7.6-2.1s-3,.3-4.3,1c-3.1,1.6-4.9,5.1-4.9,9.8,0,10.1,7.9,22.3,17.5,27.4,4.5,2.4,8.8,2.8,11.9,1.1s4.9-5.1,4.9-9.8c0-10.1-7.9-22.3-17.5-27.4h0ZM124.9,314.5c-.2-.3,0-.8.3-1,3-1.6,7-1.3,11.2.9,4.1,2.1,7.9,5.8,10.7,10.2.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.3-2.7-4.3-6.3-7.7-10.1-9.7-3.7-1.9-7.1-2.2-9.7-.9-.4.2-.8,0-1-.2h0ZM127.5,318.5c-.2-.3,0-.8.3-1,2.3-1.3,5.4-1,8.6.7,3.1,1.6,6,4.4,8.1,7.8.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.3-2-3.2-4.7-5.8-7.5-7.2-2.7-1.4-5.2-1.7-7-.7-.4.2-.8,0-1-.2h-.1ZM137.6,332.1c-.3,0-.5.2-.9.2s-.8,0-1.2-.3c-1.2-.6-2.2-2.1-2.2-3.4s.3-1.3.9-1.7c.6-.3,1.3-.3,2,0,1.2.6,2.2,2.1,2.2,3.4s-.3,1.3-.9,1.7h.1,0ZM140.5,328c-1.3-2.1-3.1-3.8-4.9-4.7-1.7-.9-3.3-1.1-4.4-.5-.4.2-.8,0-1-.2-.2-.3-.1-.8.3-1,1.6-.9,3.8-.7,6,.4,2.1,1.1,4,3,5.5,5.2.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.3h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M135.6,328.2h-.4s-.1.2-.1.4c0,.8.7,1.8,1.4,2.2h.5s.1-.2.1-.4c0-.8-.7-1.8-1.4-2.2h-.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M136.4,327c-.7-.4-1.5-.4-2,0-.6.3-.9.9-.9,1.7,0,1.3,1,2.8,2.2,3.4.4.2.8.3,1.2.3s.6,0,.9-.2c.6-.3.9-.9.9-1.7,0-1.3-1-2.8-2.2-3.4h-.1,0ZM136.8,330.9h-.5c-.7-.4-1.4-1.4-1.4-2.2s0-.4.1-.4h.4c.7.4,1.4,1.4,1.4,2.2s0,.4-.1.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M141.6,328.2c.4-.2.5-.6.3-1-1.5-2.3-3.4-4.2-5.5-5.2-2.2-1.2-4.4-1.3-6-.4-.4.2-.5.6-.3,1s.7.4,1,.2c1.1-.6,2.7-.5,4.4.5,1.9,1,3.6,2.7,4.9,4.7.1.2.4.3.7.3h.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M135.6,319.4c2.9,1.5,5.5,4,7.5,7.2.1.2.4.3.7.3h.4c.4-.2.5-.6.3-1-2.1-3.4-5-6.2-8.1-7.8-3.2-1.7-6.3-1.9-8.6-.7-.4.2-.5.6-.3,1s.7.4,1,.2c1.8-1,4.3-.8,7,.7h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M135.6,315.6c3.8,2,7.5,5.5,10.1,9.7.1.2.4.3.7.3h.4c.4-.2.5-.6.3-1-2.8-4.5-6.6-8.1-10.7-10.2-4.2-2.2-8.2-2.5-11.2-.9-.4.2-.5.6-.3,1s.7.4,1,.2c2.5-1.4,6-1,9.7.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M144.4,310.1c-2.4-2.5-5.2-4.6-8-6.1-5-2.6-9.8-3-13.4-1.1s-5.6,5.8-5.6,11.1c0,10.5,8.2,23.3,18.3,28.6,1.7.9,3.4,1.5,5,1.9.5,0,1,.2,1.5.3h1.8c1.8,0,3.5-.4,5-1.2,2.1-1.1,3.7-3,4.6-5.4.2-.4.3-.9.4-1.3.4-1.3.5-2.8.5-4.3,0-5.5-2.2-11.6-5.8-16.9-.3-.4-.5-.8-.8-1.2-.6-.8-1.1-1.5-1.8-2.3-.6-.7-1.2-1.4-1.9-2.1h.2ZM148.2,342.4c-3.1,1.6-7.4,1.2-11.9-1.1-9.6-5-17.5-17.3-17.5-27.4s1.7-8.2,4.9-9.8c1.3-.7,2.7-1,4.3-1,2.3,0,4.9.7,7.6,2.1,9.6,5,17.5,17.3,17.5,27.4s-1.7,8.2-4.9,9.8h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1113.9 376.3 1219.5 437.2 1219.5 598.2 1113.9 537.2 1113.9 376.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1182.3,431.1l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1181.2 431.3 1193.1 438.1 1193.1 444.3 1181.2 437.5 1181.2 431.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1182.3,431.1l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1180.9,437.3l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1182.3,458.2l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1181.2 458.4 1193.1 465.2 1193.1 471.4 1181.2 464.6 1181.2 458.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1182.3,458.2l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1180.9,464.4l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1142.3,409.5l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1141.3 409.7 1153.1 416.5 1153.1 422.7 1141.3 415.9 1141.3 409.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1142.3,409.5l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1140.9,415.7l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1142.3,436.6l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1141.3 436.8 1153.1 443.6 1153.1 449.8 1141.3 443 1141.3 436.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1142.3,436.6l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1140.9,442.8l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1182.3,502.9l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1181.2 503 1193.1 509.9 1193.1 516.1 1181.2 509.2 1181.2 503"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1182.3,502.9l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1180.9,509l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1182.3,530l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1181.2 530.1 1193.1 537 1193.1 543.2 1181.2 536.3 1181.2 530.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1182.3,530l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1180.9,536.1l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1142.3,481.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1141.3 481.4 1153.1 488.3 1153.1 494.5 1141.3 487.6 1141.3 481.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1142.3,481.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1140.9,487.4l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1142.3,508.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1141.3 508.6 1153.1 515.4 1153.1 521.6 1141.3 514.7 1141.3 508.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1142.3,508.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1140.9,514.5l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1421.1,481.8v-184l-104.8,60.1v23.5l-96.9,55.3.5,161.4,201.1-116.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1256.9,433l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1255.8 435.2 1267.7 428.3 1267.7 434.5 1255.8 441.4 1255.8 435.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1256.9,433l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1255.5,441.6l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1256.9,460l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1255.8 462.2 1267.7 455.3 1267.7 461.5 1255.8 468.4 1255.8 462.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1256.9,460l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1255.5,468.6l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1231.2,447.3l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1230.1 449.5 1242 442.6 1242 448.8 1230.1 455.7 1230.1 449.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1231.2,447.3l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1229.8,455.9l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1231.2,474.3l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1230.1 476.5 1242 469.6 1242 475.8 1230.1 482.7 1230.1 476.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1231.2,474.3l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1229.8,482.9l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1256.9,504.5l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1255.8 506.6 1267.7 499.8 1267.7 505.9 1255.8 512.8 1255.8 506.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1256.9,504.5l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1255.5,513l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1256.9,531.4l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1255.8 533.6 1267.7 526.8 1267.7 532.9 1255.8 539.8 1255.8 533.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1256.9,531.4l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1255.5,540l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1231.2,518.8l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1230.1 520.9 1242 514.1 1242 520.2 1230.1 527.1 1230.1 520.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1231.2,518.8l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1229.8,527.3l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1231.2,545.8l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1230.1 547.9 1242 541.1 1242 547.2 1230.1 554.1 1230.1 547.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1231.2,545.8l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1229.8,554.3l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1304.8,405.4l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1303.8 407.5 1315.6 400.7 1315.6 406.8 1303.8 413.7 1303.8 407.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1304.8,405.4l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1303.4,413.9l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1304.8,432.3l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1303.8 434.5 1315.6 427.7 1315.6 433.8 1303.8 440.7 1303.8 434.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1304.8,432.3l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1303.4,440.9l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1279.1,419.7l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1278 421.8 1289.9 415 1289.9 421.2 1278 428 1278 421.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1279.1,419.7l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1277.7,428.2l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1279.1,446.6l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1278 448.8 1289.9 442 1289.9 448.1 1278 455 1278 448.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1279.1,446.6l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1277.7,455.2l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1304.8,476.8l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1303.8 478.9 1315.6 472.1 1315.6 478.3 1303.8 485.1 1303.8 478.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1304.8,476.8l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1303.4,485.3l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1304.8,503.8l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1303.8 505.9 1315.6 499.1 1315.6 505.2 1303.8 512.1 1303.8 505.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1304.8,503.8l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1303.4,512.3l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1279.1,491.1l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1278 493.2 1289.9 486.4 1289.9 492.6 1278 499.4 1278 493.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1279.1,491.1l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1277.7,499.6l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1279.1,518.1l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1278 520.2 1289.9 513.4 1289.9 519.6 1278 526.4 1278 520.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1279.1,518.1l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1277.7,526.6l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1352.8,377.7l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1351.7 379.8 1363.6 373 1363.6 379.2 1351.7 386 1351.7 379.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1352.8,377.7l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1351.4,386.2l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1352.8,404.7l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1351.7 406.8 1363.6 400 1363.6 406.2 1351.7 413 1351.7 406.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1352.8,404.7l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1351.4,413.2l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1327,392l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1326 394.2 1337.8 387.3 1337.8 393.5 1326 400.3 1326 394.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1327,392l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1325.6,400.5l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1327,419l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1326 421.1 1337.8 414.3 1337.8 420.5 1326 427.3 1326 421.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1327,419l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1325.6,427.5l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1352.8,449.1l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1351.7 451.3 1363.6 444.4 1363.6 450.6 1351.7 457.4 1351.7 451.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1352.8,449.1l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1351.4,457.6l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1352.8,476.1l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1351.7 478.3 1363.6 471.4 1363.6 477.6 1351.7 484.4 1351.7 478.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1352.8,476.1l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1351.4,484.6l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1327,463.4l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1326 465.6 1337.8 458.7 1337.8 464.9 1326 471.7 1326 465.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1327,463.4l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1325.6,471.9l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1327,490.4l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1326 492.6 1337.8 485.7 1337.8 491.9 1326 498.7 1326 492.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1327,490.4l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1325.6,498.9l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1400.7,350l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1399.7 352.2 1411.5 345.3 1411.5 351.5 1399.7 358.3 1399.7 352.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1400.7,350l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1399.3,358.5l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1400.7,377l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1399.7 379.2 1411.5 372.3 1411.5 378.5 1399.7 385.3 1399.7 379.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1400.7,377l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1399.3,385.5l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1375,364.3l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1373.9 366.5 1385.8 359.6 1385.8 365.8 1373.9 372.6 1373.9 366.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1375,364.3l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1373.6,372.8l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1375,391.3l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1373.9 393.5 1385.8 386.6 1385.8 392.8 1373.9 399.6 1373.9 393.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1375,391.3l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1373.6,399.8l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1400.7,421.4l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1399.7 423.6 1411.5 416.7 1411.5 422.9 1399.7 429.8 1399.7 423.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1400.7,421.4l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1399.3,430l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1400.7,448.4l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1399.7 450.6 1411.5 443.7 1411.5 449.9 1399.7 456.7 1399.7 450.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1400.7,448.4l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1399.3,456.9l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1375,435.7l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1373.9 437.9 1385.8 431.1 1385.8 437.2 1373.9 444.1 1373.9 437.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1375,435.7l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1373.6,444.3l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1375,462.7l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1373.9 464.9 1385.8 458 1385.8 464.2 1373.9 471.1 1373.9 464.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1375,462.7l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1373.6,471.3l12.6-7.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1211.1 320.2 1316.6 381.1 1219.5 437.1 1114 376.2 1211.1 320.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1316 236.8 1421 297.4 1316.3 357.9 1211.3 297.3 1316 236.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1211.3,297.7l105.1,60.2v23.1l-105.1-60.6v-22.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1173.4 362.4 1225 392.2 1225 405.6 1173.4 375.7 1173.4 362.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1225.7 392.1 1258.4 373.2 1258.4 386.5 1225.7 405.5 1225.7 392.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1208.5,343.1l48.8,28.2c1,.6,1,1.5,0,2l-30.9,17.8c-1,.6-2.6.6-3.6,0l-48.8-28.2c-1-.6-1-1.5,0-2l30.9-17.8c1-.6,2.6-.6,3.6,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1274.8 283.5 1326.5 313.3 1326.5 326.6 1274.8 296.8 1274.8 283.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1327.1 313.2 1359.9 294.3 1359.9 307.6 1327.1 326.5 1327.1 313.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1310,264.2l48.8,28.2c1,.6,1,1.5,0,2l-30.9,17.8c-1,.6-2.6.6-3.6,0l-48.8-28.2c-1-.6-1-1.5,0-2l30.9-17.8c1-.6,2.6-.6,3.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.3,332.2c-2.7-1.4-5.3-2.1-7.6-2.1s-3,.3-4.3,1c-3.1,1.6-4.9,5.1-4.9,9.8,0,10.1,7.8,22.3,17.5,27.4,4.5,2.4,8.8,2.8,11.9,1.1,3.1-1.6,4.9-5.1,4.9-9.8,0-10.1-7.8-22.3-17.5-27.4h0ZM1206.6,341.6c-.2-.3,0-.8.3-1,3-1.6,7-1.3,11.2.9,4.1,2.1,7.9,5.8,10.7,10.2.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.3-2.7-4.3-6.3-7.7-10.2-9.7-3.7-1.9-7.1-2.2-9.7-.9s-.8,0-1.1-.2h.2ZM1209.2,345.6c-.2-.3,0-.8.3-1,2.3-1.2,5.4-1,8.6.7,3.1,1.6,6,4.4,8.1,7.8.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.3-2-3.2-4.7-5.8-7.6-7.2-2.7-1.4-5.2-1.7-7-.7-.4.2-.8,0-1.1-.2h0ZM1219.3,359.2c-.3,0-.5.2-.8.2s-.8,0-1.2-.3c-1.2-.6-2.2-2.1-2.2-3.4s.3-1.3.9-1.7c.6-.3,1.3-.3,2,0,1.2.6,2.2,2.1,2.2,3.4s-.3,1.3-.9,1.7h0ZM1222.2,355.1c-1.3-2.1-3.1-3.8-4.9-4.7-1.7-.9-3.3-1-4.4-.5-.4.2-.8,0-1.1-.2-.2-.3,0-.8.3-1,1.6-.9,3.8-.7,6,.4,2.1,1.1,4.1,3,5.5,5.2.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1217.3,355.4h-.4v.4c0,.8.7,1.8,1.4,2.2h.5v-.4c0-.8-.7-1.8-1.4-2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1218,354.1c-.7-.4-1.4-.4-2,0-.6.3-.9.9-.9,1.7,0,1.3,1,2.8,2.2,3.4.4.2.8.3,1.2.3s.6,0,.8-.2c.6-.3.9-.9.9-1.7,0-1.3-1-2.8-2.2-3.4h0ZM1218.5,358h-.5c-.7-.4-1.4-1.4-1.4-2.2s0-.4,0-.4h.4c.7.4,1.4,1.4,1.4,2.2s0,.4,0,.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1223.3,355.3c.4-.2.5-.6.3-1-1.4-2.3-3.4-4.2-5.5-5.2-2.2-1.2-4.4-1.3-6-.4-.4.2-.5.6-.3,1s.7.4,1.1.2c1.1-.6,2.7-.5,4.4.5,1.9,1,3.6,2.7,4.9,4.7,0,.2.4.3.7.3h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1217.3,346.5c2.8,1.5,5.5,4,7.6,7.2,0,.2.4.3.7.3h.4c.4-.2.5-.6.3-1-2.2-3.4-5-6.2-8.1-7.8-3.2-1.7-6.3-1.9-8.6-.7-.4.2-.5.6-.3,1s.7.4,1.1.2c1.8-1,4.3-.8,7,.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1217.3,342.7c3.8,2,7.4,5.5,10.2,9.7,0,.2.4.3.7.3h.4c.4-.2.5-.6.3-1-2.8-4.5-6.7-8.1-10.7-10.2-4.2-2.2-8.2-2.5-11.2-.9-.4.2-.5.6-.3,1s.7.4,1.1.2c2.5-1.4,5.9-1,9.7.9h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1226.1,337.2c-2.4-2.5-5.2-4.6-8-6.1-5-2.6-9.8-3-13.4-1.1s-5.6,5.8-5.6,11.1c0,10.5,8.2,23.3,18.3,28.6,1.7.9,3.4,1.5,5,1.9.5,0,1,.2,1.5.3h1.8c1.8,0,3.5-.4,5-1.2,2.2-1.1,3.7-3,4.7-5.4.2-.4.3-.9.4-1.3.3-1.3.5-2.8.5-4.3,0-5.5-2.2-11.6-5.8-16.9-.3-.4-.5-.8-.8-1.2-.6-.8-1.2-1.5-1.8-2.3-.6-.7-1.2-1.4-1.9-2.1h.1ZM1229.9,369.5c-3.1,1.6-7.3,1.2-11.9-1.1-9.7-5-17.5-17.3-17.5-27.4s1.7-8.2,4.9-9.8c1.3-.7,2.7-1,4.3-1,2.3,0,4.9.7,7.6,2.1,9.7,5,17.5,17.3,17.5,27.4s-1.7,8.2-4.9,9.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.7,256.4c-2.7-1.4-5.3-2.1-7.6-2.1s-3,.3-4.3,1c-3.1,1.6-4.9,5.1-4.9,9.8,0,10.1,7.8,22.3,17.5,27.4,4.5,2.4,8.8,2.8,11.9,1.1,3.1-1.6,4.9-5.1,4.9-9.8,0-10.1-7.8-22.3-17.5-27.4h0ZM1307,265.7c-.2-.3,0-.8.3-1,3-1.6,7-1.3,11.2.9,4.1,2.1,7.9,5.8,10.7,10.2.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.3-2.7-4.3-6.3-7.7-10.2-9.7-3.7-1.9-7.1-2.2-9.7-.9s-.8,0-1.1-.2h.2ZM1309.6,269.8c-.2-.3,0-.8.3-1,2.3-1.3,5.4-1,8.6.7,3.1,1.6,6,4.4,8.1,7.8.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.3-2-3.2-4.7-5.8-7.6-7.2-2.7-1.4-5.2-1.7-7.1-.7-.4.2-.8,0-1.1-.2h.2ZM1319.8,283.3c-.3,0-.5.2-.8.2s-.8,0-1.2-.3c-1.2-.6-2.2-2.1-2.2-3.4s.3-1.3.9-1.7c.6-.3,1.3-.3,2,0,1.2.6,2.2,2.1,2.2,3.4s-.3,1.3-.9,1.7h0ZM1322.7,279.2c-1.3-2.1-3.1-3.8-4.9-4.7-1.7-.9-3.3-1.1-4.4-.5-.4.2-.8,0-1.1-.2-.2-.3,0-.8.3-1,1.6-.9,3.8-.7,6,.4,2.1,1.1,4.1,3,5.5,5.2.2.3,0,.8-.3,1h-.4c-.3,0-.5,0-.7-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1317.7,279.5h-.4v.4c0,.8.7,1.8,1.4,2.2h.5v-.4c0-.8-.7-1.8-1.4-2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1318.5,278.3c-.7-.4-1.4-.4-2,0-.6.3-.9.9-.9,1.7,0,1.3,1,2.8,2.2,3.4.4.2.8.3,1.2.3s.6,0,.8-.2c.6-.3.9-.9.9-1.7,0-1.3-1-2.8-2.2-3.4h0ZM1319,282.1h-.5c-.7-.4-1.4-1.4-1.4-2.2s0-.4,0-.4h.4c.7.4,1.4,1.4,1.4,2.2s0,.4,0,.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1323.7,279.5c.4-.2.5-.6.3-1-1.4-2.3-3.4-4.2-5.5-5.2-2.2-1.2-4.4-1.3-6-.4-.4.2-.5.6-.3,1s.7.4,1.1.2c1.1-.6,2.7-.5,4.4.5,1.9,1,3.6,2.7,4.9,4.7,0,.2.4.3.7.3h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1317.7,270.7c2.8,1.5,5.5,4,7.6,7.2,0,.2.4.3.7.3h.4c.4-.2.5-.6.3-1-2.2-3.4-5-6.2-8.1-7.8-3.2-1.7-6.3-1.9-8.6-.7-.4.2-.5.6-.3,1s.7.4,1.1.2c1.8-1,4.3-.8,7,.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1317.7,266.9c3.8,2,7.4,5.5,10.2,9.7,0,.2.4.3.7.3h.4c.4-.2.5-.6.3-1-2.8-4.5-6.7-8.1-10.7-10.2-4.2-2.2-8.2-2.5-11.2-.9-.4.2-.5.6-.3,1s.7.4,1.1.2c2.5-1.4,5.9-1,9.7.9h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1326.5,261.3c-2.4-2.5-5.2-4.6-8-6.1-5-2.6-9.8-3-13.4-1.1s-5.6,5.8-5.6,11.1c0,10.5,8.2,23.3,18.3,28.6,1.7.9,3.4,1.5,5,1.9.5,0,1,.2,1.5.3h1.8c1.8,0,3.5-.4,5-1.2,2.2-1.1,3.7-3,4.7-5.4.2-.4.3-.9.4-1.3.3-1.3.5-2.8.5-4.3,0-5.5-2.2-11.6-5.8-16.9-.3-.4-.5-.8-.8-1.2-.6-.8-1.2-1.5-1.8-2.3-.6-.7-1.2-1.4-1.9-2.1h.1ZM1330.4,293.6c-3.1,1.6-7.3,1.2-11.9-1.1-9.7-5-17.5-17.3-17.5-27.4s1.7-8.2,4.9-9.8c1.3-.7,2.7-1,4.3-1,2.3,0,4.9.7,7.6,2.1,9.7,5,17.5,17.3,17.5,27.4s-1.7,8.2-4.9,9.8h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "731.8 -6.2 828.2 49.4 828.2 287.2 731.8 231.5 731.8 -6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M799.9,61.5v66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M776.8,48.2v66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M753.8,34.9v66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M799.9,151.2v66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M776.8,137.9v66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M753.8,124.5v66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "829.2 49.3 926.6 -7 926.6 231 829.2 287.2 829.2 49.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M904.7,31.3v67.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M881.6,44.6v67.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M858.5,58v67.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M904.7,122.5v67.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M881.6,135.9v67.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M858.5,149.2v67.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "829.1 -62.9 926.1 -6.8 829 49.2 732 -6.8 829.1 -62.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "775.9 -51.4 828.9 -20.8 828.9 32 775.9 1.4 775.9 -51.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "829.6 -20.8 882.5 -51.3 882.5 1.5 829.6 32 829.6 -20.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M831.1-81.9l50.3,29.1c1,.6,1,1.5,0,2.1l-50.6,29.2c-1,.6-2.6.6-3.6,0l-50.3-29.1c-1-.6-1-1.5,0-2.1l50.6-29.2c1-.6,2.6-.6,3.6,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "795.3 -73.9 828.4 -54.8 828.4 -35.7 795.3 -54.8 795.3 -73.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "829.1 -54.8 862.3 -73.9 862.3 -54.8 829.1 -35.7 829.1 -54.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M830.6-93.4l30.8,17.8c1,.6,1,1.5,0,2.1l-30.9,17.9c-1,.6-2.6.6-3.6,0l-30.8-17.8c-1-.6-1-1.5,0-2.1l30.9-17.9c1-.6,2.6-.6,3.6,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "588.9 425.4 694.5 486.4 694.5 647.4 588.9 586.4 588.9 425.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M657.3,480.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "656.2 480.4 668.1 487.3 668.1 493.5 656.2 486.6 656.2 480.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M657.3,480.3l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M655.8,486.4l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M657.3,507.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "656.2 507.6 668.1 514.4 668.1 520.6 656.2 513.7 656.2 507.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M657.3,507.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M655.8,513.6l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M617.3,458.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "616.2 458.9 628.1 465.7 628.1 471.9 616.2 465.1 616.2 458.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M617.3,458.7l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M615.9,464.9l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M617.3,485.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "616.2 486 628.1 492.8 628.1 499 616.2 492.2 616.2 486"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M617.3,485.8l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M615.9,492l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M657.3,552l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "656.2 552.2 668.1 559 668.1 565.2 656.2 558.4 656.2 552.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M657.3,552l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M655.8,558.2l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M657.3,579.2l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "656.2 579.3 668.1 586.2 668.1 592.4 656.2 585.5 656.2 579.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M657.3,579.2l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M655.8,585.3l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M617.3,530.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "616.2 530.6 628.1 537.4 628.1 543.6 616.2 536.8 616.2 530.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M617.3,530.4l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M615.9,536.6l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M617.3,557.6l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "616.2 557.7 628.1 564.6 628.1 570.8 616.2 563.9 616.2 557.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M617.3,557.6l9.7,5.6c1,.6,1.8,1.9,1.8,3.1v16c0,1.1-.8,1.6-1.8,1l-9.7-5.6c-1-.6-1.8-1.9-1.8-3.1v-16c0-1.1.8-1.6,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M615.9,563.7l12.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M896.1,531v-184l-104.8,60.1v23.5l-96.9,55.3.5,161.4,201.1-116.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M731.9,482.2l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "730.8 484.4 742.7 477.5 742.7 483.7 730.8 490.5 730.8 484.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M731.9,482.2l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M730.5,490.7l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M731.9,509.2l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "730.8 511.4 742.7 504.5 742.7 510.7 730.8 517.5 730.8 511.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M731.9,509.2l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M730.5,517.7l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M706.1,496.5l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "705.1 498.7 716.9 491.8 716.9 498 705.1 504.8 705.1 498.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M706.1,496.5l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M704.7,505l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M706.1,523.5l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "705.1 525.7 716.9 518.8 716.9 525 705.1 531.8 705.1 525.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M706.1,523.5l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M704.7,532l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M731.9,553.6l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "730.8 555.8 742.7 548.9 742.7 555.1 730.8 562 730.8 555.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M731.9,553.6l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M730.5,562.2l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M731.9,580.6l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "730.8 582.8 742.7 575.9 742.7 582.1 730.8 588.9 730.8 582.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M731.9,580.6l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M730.5,589.2l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M706.1,567.9l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "705.1 570.1 716.9 563.2 716.9 569.4 705.1 576.3 705.1 570.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M706.1,567.9l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M704.7,576.5l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M706.1,594.9l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "705.1 597.1 716.9 590.2 716.9 596.4 705.1 603.3 705.1 597.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M706.1,594.9l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M704.7,603.5l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M779.8,454.5l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "778.8 456.7 790.6 449.8 790.6 456 778.8 462.9 778.8 456.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M779.8,454.5l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M778.4,463.1l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M779.8,481.5l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "778.8 483.7 790.6 476.8 790.6 483 778.8 489.8 778.8 483.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M779.8,481.5l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M778.4,490l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M754.1,468.8l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "753 471 764.9 464.2 764.9 470.3 753 477.2 753 471"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M754.1,468.8l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M752.7,477.4l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M754.1,495.8l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "753 498 764.9 491.1 764.9 497.3 753 504.2 753 498"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M754.1,495.8l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M752.7,504.4l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M779.8,525.9l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "778.8 528.1 790.6 521.3 790.6 527.4 778.8 534.3 778.8 528.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M779.8,525.9l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M778.4,534.5l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M779.8,552.9l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "778.8 555.1 790.6 548.2 790.6 554.4 778.8 561.3 778.8 555.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M779.8,552.9l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M778.4,561.5l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M754.1,540.3l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "753 542.4 764.9 535.6 764.9 541.7 753 548.6 753 542.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M754.1,540.3l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M752.7,548.8l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M754.1,567.2l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "753 569.4 764.9 562.6 764.9 568.7 753 575.6 753 569.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M754.1,567.2l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M752.7,575.8l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M827.8,426.9l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "826.7 429 838.5 422.2 838.5 428.3 826.7 435.2 826.7 429"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M827.8,426.9l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M826.3,435.4l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M827.8,453.8l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "826.7 456 838.5 449.2 838.5 455.3 826.7 462.2 826.7 456"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M827.8,453.8l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M826.3,462.4l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M802,441.2l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "800.9 443.3 812.8 436.5 812.8 442.6 800.9 449.5 800.9 443.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M802,441.2l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M800.6,449.7l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M802,468.1l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "800.9 470.3 812.8 463.5 812.8 469.6 800.9 476.5 800.9 470.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M802,468.1l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M800.6,476.7l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M827.8,498.3l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "826.7 500.4 838.5 493.6 838.5 499.8 826.7 506.6 826.7 500.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M827.8,498.3l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M826.3,506.8l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M827.8,525.3l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "826.7 527.4 838.5 520.6 838.5 526.7 826.7 533.6 826.7 527.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M827.8,525.3l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M826.3,533.8l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M802,512.6l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "800.9 514.7 812.8 507.9 812.8 514.1 800.9 520.9 800.9 514.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M802,512.6l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M800.6,521.1l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M802,539.6l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "800.9 541.7 812.8 534.9 812.8 541.1 800.9 547.9 800.9 541.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M802,539.6l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M800.6,548.1l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M875.7,399.2l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "874.6 401.3 886.5 394.5 886.5 400.6 874.6 407.5 874.6 401.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M875.7,399.2l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M874.3,407.7l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M875.7,426.2l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "874.6 428.3 886.5 421.5 886.5 427.6 874.6 434.5 874.6 428.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M875.7,426.2l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M874.3,434.7l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M850,413.5l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "848.9 415.6 860.8 408.8 860.8 415 848.9 421.8 848.9 415.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M850,413.5l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M848.5,422l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M850,440.5l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "848.9 442.6 860.8 435.8 860.8 441.9 848.9 448.8 848.9 442.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M850,440.5l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M848.5,449l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M875.7,470.6l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "874.6 472.8 886.5 465.9 886.5 472.1 874.6 478.9 874.6 472.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M875.7,470.6l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M874.3,479.1l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M875.7,497.6l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "874.6 499.7 886.5 492.9 886.5 499.1 874.6 505.9 874.6 499.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M875.7,497.6l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M874.3,506.1l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M850,484.9l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "848.9 487.1 860.8 480.2 860.8 486.4 848.9 493.2 848.9 487.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M850,484.9l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M848.5,493.4l12.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M850,511.9l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "848.9 514.1 860.8 507.2 860.8 513.4 848.9 520.2 848.9 514.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M850,511.9l9.7-5.6c1.3-.8,2.4-.2,2.4,1.4v16c0,1.6-1.1,3.5-2.4,4.2l-9.7,5.6c-1.3.8-2.4.2-2.4-1.4v-16c0-1.6,1.1-3.5,2.4-4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M848.5,520.4l12.6-7.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "686.1 369.3 791.6 430.2 694.5 486.3 589 425.4 686.1 369.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "791 286 895.9 346.6 791.2 407.1 686.3 346.5 791 286"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M686.3,346.8l105.1,60.2v23.1l-105.1-60.6v-22.7h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "648.4 411.6 700 441.4 700 454.7 648.4 424.9 648.4 411.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "700.6 441.3 733.4 422.4 733.4 435.7 700.6 454.6 700.6 441.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M683.5,392.2l48.8,28.2c1,.6,1,1.5,0,2l-30.9,17.8c-1,.6-2.6.6-3.5,0l-48.8-28.2c-1-.6-1-1.5,0-2l30.9-17.8c1-.6,2.6-.6,3.5,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "749.8 332.6 801.5 362.5 801.5 375.8 749.8 346 749.8 332.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "802.1 362.4 834.9 343.4 834.9 356.8 802.1 375.7 802.1 362.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M785,313.3l48.8,28.2c1,.6,1,1.5,0,2l-30.9,17.8c-1,.6-2.6.6-3.6,0l-48.8-28.2c-1-.6-1-1.5,0-2l30.9-17.8c1-.6,2.6-.6,3.6,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M746.9,666.7c0,.5-.2,1-.2,1.5v.3l-5.1,3v-5.2c0-2.5,1.6-5.4,3.7-7l3.1-2.3c1.7-1.2,3.2-3.1,4.2-5.2,5.1-10.3,11.9-18,21.1-23.3,4.8-2.7,11.4-3.8,14.8-1.9,1.4.8,2.2,2.1,2.2,4v12l-4.1,2.4h0c0-.9-.6-1.7-1.4-2-2-.7-2.4-.5-2.8-.2-2,1.3-3.7,4.1-3.9,6.5v.4h0l-23.6,13.7h0c0-2.7-1.8-3.7-4.1-2.4-.2,0-.3.2-.4.3h0c-1.7,1.2-3,3.3-3.5,5.4h0ZM783.5,632.4c.8-.8.7-2.1-.2-2.7-.7-.4-1.7-.7-2.8-.6-3.1.2-13.5,5.6-20.7,18.1-.5,1,.6,2,1.5,1.3,16.4-11.4,18.6-12.8,22.3-16.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M767.7,614.1l21.2,12.2c-3.5-2-10.2-.9-15.1,1.9-9.4,5.4-16.3,13.2-21.5,23.7-1.1,2.2-2.6,4-4.3,5.3l-3.2,2.3c-2.2,1.6-3.8,4.6-3.8,7.1v4.9l-14-8.1h0l-7.2-4.2v-4.9c0-2.5,1.6-5.5,3.8-7.1l3.2-2.3c1.7-1.2,3.3-3.1,4.3-5.3,5.2-10.5,12.2-18.3,21.5-23.7,5.2-3,12.6-3.3,15.1-1.9h0ZM759.6,636.3c.5-.6.3-1.5-.3-1.9-3.2-1.8-11.3-6.4-14.7-8.1-.5-.2-1.1-.2-1.5.2-3.5,3.4-7.3,10.1-8.7,12.7-.3.6,0,1.3.5,1.7,2.6,1.5,9.6,5.6,14.2,8.3.7.4,1.5,0,1.8-.6,2-4.2,6.6-9.9,8.7-12.3h0ZM738.5,665.9c0-.4,0-.9-.3-1.3-.2-.4-.5-.8-.8-1l-14.4-8.3c-.7-.4-1.2,0-1.2.9s0,.9.3,1.3c.2.4.5.8.8,1l14.4,8.3c.7.4,1.2,0,1.2-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.1,646.7c0,2.5-1.7,5.5-3.9,6.8-1.1.6-2.1.7-2.8.3h0c-.7-.5-1.1-1.3-1.1-2.5v-1.2h0v-.6c.6-2,2-4,3.6-5,1.1-.6,2-.7,2.7-.3h0c.7.4,1.1,1.3,1.1,2.6h.4ZM782.2,650.3c.7-.4,1.2-1.3,1.2-2.1s-.5-1.1-1.2-.7c-.7.4-1.2,1.3-1.2,2.1s.5,1.1,1.2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M782.5,642.8l2.4,1.4c-.7-.4-1.7-.3-2.7.3-1.7,1-3.1,3-3.6,5,.2-2.5,1.9-5.4,4-6.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.3,629.7c1,.6,1.1,1.9.2,2.7-3.7,3.3-5.9,4.7-22.3,16.1-.9.6-2-.4-1.5-1.3,7.2-12.4,17.6-17.8,20.7-18.1,1.1,0,2.1.2,2.8.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M783.4,648.2c0,.8-.5,1.7-1.2,2.1-.7.4-1.2,0-1.2-.7s.5-1.7,1.2-2.1c.7-.4,1.2,0,1.2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M779.4,653.7l-2.7-1.5c-.3-.2-.5-.4-.7-.7l2.4-1.4v1.2c0,1.2.4,2.1,1.1,2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M759.3,634.3c.7.4.9,1.3.3,1.9-2,2.4-6.7,8.1-8.7,12.3-.3.7-1.2,1-1.8.6-4.6-2.7-11.6-6.8-14.2-8.3-.6-.3-.8-1.1-.5-1.7,1.4-2.6,5.1-9.3,8.7-12.7.4-.4,1-.5,1.5-.2,3.3,1.7,11.4,6.3,14.7,8.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754,665.2c0,2.5-1.7,5.5-3.9,6.7-1.1.6-2.1.7-2.8.3h0c-.7-.5-1.1-1.3-1.1-2.5v-1.2l.4-.2h0c0-.5,0-1,.2-1.5.7-1.6,1.9-3,3.2-3.8,1.1-.6,2-.7,2.7-.3h0c.7.4,1.1,1.3,1.1,2.6h.2,0ZM750.1,668.9c.7-.4,1.2-1.3,1.2-2.1s-.5-1.1-1.2-.7c-.7.4-1.2,1.3-1.2,2.1s.5,1.1,1.2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M750.4,661.3l2.4,1.4c-.7-.4-1.7-.3-2.7.3-1.3.8-2.5,2.2-3.2,3.8.5-2.1,1.9-4.3,3.6-5.5q.2-.1,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M751.3,666.8c0,.8-.5,1.7-1.2,2.1-.7.4-1.2,0-1.2-.7s.5-1.7,1.2-2.1c.7-.4,1.2,0,1.2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M747.3,672.2l-2.7-1.6c-.3-.2-.5-.4-.7-.7l2.4-1.4v1.2c0,1.2.4,2.1,1.1,2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M738.1,664.5c.2.4.3.9.3,1.3,0,.9-.5,1.3-1.2.9l-14.4-8.3c-.3-.2-.6-.5-.8-1-.2-.4-.3-.9-.3-1.3,0-.9.5-1.3,1.2-.9l14.4,8.3c.3.2.6.5.8,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M706.5,639.2h0c.3-.5.5-1,.5-1.6,0-.9-.6-1.2-1.3-.8s-1.3,1.5-1.3,2.3.6,1.2,1.3.8c.3-.2.6-.5.8-.8h0ZM708.2,655.2h0l-16.5,9.5v-32.5c0-2.6,1.6-5.6,3.5-6.8l12.6-7.2c.9-.5,1.7-.5,2.3-.2h0c.8.5,1.2,1.5,1.2,2.9v32.5l-3.2,1.8h.1ZM706.5,627.6v-1.9c0-.7-.4-1-1-.7l-8,4.6c-.5.3-1,1.1-1,1.8v1.9c0,.7.4,1,1,.7l8-4.6c.5-.3,1-1.1,1-1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699,611.6l11,6.4c-.6-.3-1.4-.3-2.3.2l-12.6,7.2c-2,1.1-3.5,4.2-3.5,6.8v32.5l-11.1-6.4v-32.5c0-2.6,1.6-5.6,3.5-6.8l12.5-7.2c.9-.5,1.7-.5,2.3-.2h.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M706.5,639.2h0c-.2.3-.5.6-.8.8-.7.4-1.3,0-1.3-.8s.6-1.9,1.3-2.3c.7-.4,1.3,0,1.3.8s-.2,1.1-.5,1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M706.5,625.7v1.9c0,.7-.4,1.5-1,1.8l-4.8,2.8v-4.4l4.9-2.9c.5-.3,1,0,1,.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M700.7,632.2h0l-3.2,1.8c-.5.3-1,0-1-.7v-1.9c0-.7.4-1.5,1-1.8l3-1.8v4.4h.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M779.4,653.7c-.7-.4-1.1-1.3-1.1-2.5v-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M784.9,644.2c.7.4,1.1,1.3,1.1,2.5,0,2.5-1.7,5.5-3.9,6.8-1.1.6-2.1.7-2.8.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M778.5,649.5h0c.6-2,2-4.1,3.6-5,1.1-.6,2-.7,2.7-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M781,649.6c0-.8.5-1.7,1.2-2.1.7-.4,1.2,0,1.2.7s-.5,1.7-1.2,2.1c-.7.4-1.2,0-1.2-.7Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "784.9 644.2 782.5 642.8 782.5 642.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M776,651.4h0c.2.3.4.5.7.7l2.8,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M747.3,672.2c-.7-.4-1.1-1.3-1.1-2.5v-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M752.8,662.7c.7.4,1.1,1.3,1.1,2.5,0,2.5-1.7,5.5-3.9,6.7-1.1.6-2.1.7-2.8.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M746.9,666.8h0c.7-1.6,1.9-3,3.2-3.8,1.1-.6,2-.7,2.7-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M748.9,668.2c0-.8.5-1.7,1.2-2.1.7-.4,1.2,0,1.2.7s-.5,1.7-1.2,2.1c-.7.4-1.2,0-1.2-.7Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 752.8,
    y1: 662.7,
    x2: 750.4,
    y2: 661.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M743.9,669.9c.2.3.4.5.7.7l2.8,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M788.9,626.3c1.4.8,2.3,2.1,2.3,4v12.2l-4.3,2.5h0c0-2.7-1.9-3.8-4.2-2.5h-.2c-2.1,1.3-3.8,4.2-4,6.7v.5h0l-23.5,13.6h0c0-2.7-1.9-3.8-4.2-2.5-.2,0-.3.2-.4.3h0c-1.7,1.2-3.1,3.4-3.6,5.5,0,.5-.2,1-.2,1.5h0l-5.6,3.3v-4.9c0-2.5,1.6-5.5,3.8-7.1l3.2-2.3c1.7-1.2,3.2-3.1,4.3-5.3,5.2-10.5,12.2-18.3,21.5-23.7,4.8-2.8,11.6-3.9,15.1-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M761.3,648.5c16.4-11.4,18.6-12.8,22.3-16.1.8-.8.7-2.1-.2-2.7-.7-.4-1.7-.7-2.8-.6-3.1.2-13.5,5.6-20.7,18.1-.5,1,.6,2,1.5,1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M759.6,636.3c-2,2.4-6.7,8.1-8.7,12.3-.3.7-1.2,1-1.8.6-4.6-2.7-11.6-6.8-14.2-8.3-.6-.3-.8-1.1-.5-1.7,1.4-2.6,5.1-9.3,8.7-12.7.4-.4,1-.5,1.5-.2,3.3,1.7,11.4,6.3,14.7,8.1.7.4.9,1.3.3,1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M722.9,658.5l14.4,8.3c.7.4,1.2,0,1.2-.9s0-.9-.3-1.3c-.2-.4-.5-.8-.8-1l-14.4-8.3c-.7-.4-1.2,0-1.2.9s0,.9.3,1.3c.2.4.5.8.8,1h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 727.1,
    y1: 663.4,
    x2: 741.1,
    y2: 671.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M788.9,626.3l-21.2-12.2c-2.5-1.5-9.9-1.1-15.1,1.9-9.3,5.4-16.3,13.2-21.5,23.7-1.1,2.2-2.6,4.1-4.3,5.3l-3.2,2.3c-2.2,1.5-3.8,4.6-3.8,7.1v4.9l7.2,4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M708.2,655.2l-16.5,9.5v-32.5c0-2.6,1.6-5.6,3.5-6.8l12.6-7.2c.9-.5,1.7-.5,2.3-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M710.1,618c.8.4,1.2,1.4,1.2,2.9v32.5l-3.2,1.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "700.1 639.5 697.3 646.6 701.2 644.4 698.2 651.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M700.6,627.8l5-2.9c.5-.3,1,0,1,.7v1.9c0,.7-.4,1.5-1,1.8l-8,4.6c-.5.3-1,0-1-.7v-1.9c0-.7.4-1.5,1-1.8l3-1.8h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 700.7,
    y1: 632.2,
    x2: 700.7,
    y2: 628
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M691.7,664.8l-11.1-6.4v-32.5c0-2.6,1.6-5.6,3.5-6.8l12.5-7.2c.9-.5,1.7-.5,2.3-.2l11.1,6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M706.5,639.2c-.2.3-.5.6-.8.8-.7.4-1.3,0-1.3-.8s.6-1.9,1.3-2.3c.7-.4,1.3,0,1.3.8s-.2,1.1-.5,1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M706.5,639.2c1.8,2.7.9,9.8,1.7,16.1h0v.5c.6,3.8,1.9,7.2,5,9,3.2,1.9,8.9,1,13.8-1.3h0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 706.5,
    y1: 639.2,
    x2: 706.5,
    y2: 639.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M705.7,638.4c.3.2.6.4.8.8"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M-16.6,79.2l2.4,1.4c-.7-.4-1.6-.3-2.7.3-1.7,1-3.1,3-3.6,5,.2-2.5,1.9-5.4,4-6.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M-19.8,90.1l-2.7-1.5c-.3-.2-.5-.4-.7-.7l2.4-1.4c0,.4-.1.8-.1,1.2,0,1.2.4,2.1,1.1,2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M-48.7,97.7l2.4,1.4c-.7-.4-1.7-.3-2.7.3-1.3.8-2.5,2.2-3.2,3.8.5-2.1,1.9-4.3,3.6-5.5q.2-.1,0,0c-.5.3,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M-51.9,108.6l-2.7-1.6c-.3-.2-.5-.4-.7-.7l2.4-1.4v1.2c0,1.2.4,2.1,1.1,2.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-19.8,90.1c-.7-.4-1.1-1.3-1.1-2.5s0-.8.1-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-14.2,80.6c.7.4,1.1,1.3,1.1,2.5,0,2.5-1.7,5.5-3.9,6.8-1.1.6-2,.7-2.8.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-20.6,85.9h0c.6-2,2-4.1,3.6-5,1-.6,2-.7,2.7-.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "-14.2 80.6 -16.6 79.2 -16.6 79.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-23.2,87.8h0c.2.3.4.5.7.7l2.7,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-51.9,108.6c-.7-.4-1.1-1.3-1.1-2.5v-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-46.3,99.1c.7.4,1.1,1.3,1.1,2.5,0,2.5-1.7,5.5-3.9,6.7-1.1.6-2.1.7-2.8.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-52.3,103.2h0c.7-1.6,1.9-3,3.2-3.8,1.1-.6,2-.7,2.7-.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: -46.3,
    y1: 99.1,
    x2: -48.7,
    y2: 97.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-55.3,106.4c.2.3.4.5.7.7l2.8,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-10.2,62.8c1.4.8,2.3,2.1,2.3,4v12.2l-4.3,2.5h0c0-2.7-1.9-3.8-4.2-2.5h-.2c-2.1,1.3-3.8,4.2-4,6.7v.5h0l-23.5,13.6h0c0-2.7-1.9-3.8-4.2-2.5,0,0-.3.2-.4.3h0c-1.7,1.2-3.1,3.4-3.6,5.5,0,.5-.2,1-.2,1.5h0l-5.6,3.3v-4.9c0-2.5,1.6-5.5,3.8-7.1l3.2-2.3c1.7-1.2,3.2-3.1,4.3-5.3,5.2-10.5,12.2-18.3,21.5-23.7,4.8-2.8,11.6-3.9,15.1-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-76.3,94.9l14.4,8.3c.7.4,1.2,0,1.2-.9s0-.9-.4-1.3c-.2-.4-.5-.8-.9-1l-14.4-8.3c-.7-.4-1.2,0-1.2.9s0,.9.4,1.3c.2.4.5.8.9,1h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: -72.1,
    y1: 99.9,
    x2: -58.1,
    y2: 108
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M57.1,491.7l-37.2-19.4-9.2,24.4,37.2,19.4,9.2-24.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8,569.1c1.4.7,3.6.6,4.8,0,.4-.2.6-.4.6-.6v-19.1c-.9.3-1.9.5-3,.5s-2.1-.2-3-.5v19.1s.2.4.6.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M52.4,486.6l-16.6-8.7-1.8-.9-14.1-7.3c-.3-.2-.7-.2-1.1,0-.4,0-.6.4-.8.7l-10,26.6c-.2.5,0,1.1.6,1.3l10.7,5.6,2.5,1.3,11.9,6.2v-.7c0-.6.6-1.1,1.3-1.1s1.3.5,1.3,1.1v2l11.8,6.1c.2,0,.4.2.6.2h.4c.4,0,.6-.4.8-.7l10-26.6c.2-.5,0-1.1-.6-1.3l-4.4-2.3-2.5-1.3h0v-.2ZM10.8,496.8l9.2-24.4,37.2,19.4-9.2,24.4-37.2-19.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M36.3,510.7c0-.6-.6-1.1-1.3-1.1s-1.3.5-1.3,1.1v32.7h2.5v-32.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M33.7,543.4c-.8,0-1.6.3-2.2.7-1.2.6-1.9,1.5-1.9,2.6,0-.6.6-1.1,1.3-1.1s1.3.5,1.3,1.1c0,0,.2-.4.6-.6.3,0,.6-.3,1-.3s.8,0,1.3-.2h1.2c.5,0,.9.2,1.2.4.4.2.6.5.6.6s-.2.4-.6.6c-1.3.7-3.5.7-4.8,0-.4-.2-.6-.5-.6-.6v2.8c.9.3,1.9.5,3,.5s2.1-.2,3-.5v-2.8c0-.6.6-1.1,1.3-1.1s1.1.4,1.2.9c0-.9-.8-1.8-1.9-2.3-.7-.4-1.6-.6-2.5-.7h-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M39.4,545.5c-.7,0-1.3.5-1.3,1.1v21.9c0-.6.6-1.1,1.3-1.1s1.3.5,1.3,1.1v-22.1c0-.5-.6-.9-1.2-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M39.4,567.4c-.7,0-1.3.5-1.3,1.1s-.2.4-.6.6c-1.2.6-3.4.8-4.8,0-.4-.2-.6-.5-.6-.6,0,.6-.6,1.1-1.3,1.1s-1.3-.5-1.3-1.1c0,1,.7,1.9,1.9,2.6,1.1.6,2.4.8,3.6.8s2.8-.3,3.7-.8c1.2-.6,1.8-1.5,1.8-2.5s-.6-1.1-1.3-1.1h.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M30.9,569.7c.7,0,1.3-.5,1.3-1.1v-21.9c0-.6-.6-1.1-1.3-1.1s-1.3.5-1.3,1.1v21.9c0,.6.6,1.1,1.3,1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M17.2,311.3l-37.2-19.4-9.2,24.4,37.2,19.4,9.2-24.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.2,388.7c1.4.7,3.6.6,4.8,0,.4-.2.6-.4.6-.6v-19.1c-.9.3-1.9.5-3,.5s-2.1-.2-3-.5v19.1s.2.4.6.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M12.4,306.2l-16.6-8.7-1.8-.9-14.1-7.3c-.3-.2-.7-.2-1.1,0s-.6.4-.8.7l-10,26.6c-.2.5,0,1.1.6,1.3l10.7,5.6,2.5,1.3,11.9,6.2v-.7c0-.6.6-1.1,1.3-1.1s1.3.5,1.3,1.1v2l11.8,6.1c.2,0,.4.2.6.2h.4c.4,0,.6-.4.8-.7l10-26.6c.2-.5,0-1.1-.6-1.3l-4.4-2.3-2.5-1.3h0v-.2h0ZM-29.2,316.4l9.2-24.4,37.2,19.4-9.2,24.4-37.2-19.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-3.7,330.3c0-.6-.6-1.1-1.3-1.1s-1.3.5-1.3,1.1v32.7h2.5v-32.7h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-6.2,363c-.8,0-1.6.3-2.2.7-1.2.6-1.9,1.5-1.9,2.6,0-.6.6-1.1,1.3-1.1s1.3.5,1.3,1.1c0,0,.2-.4.6-.6.3,0,.6-.3,1-.3s.8,0,1.3-.2h1.2c.5,0,.9.2,1.2.4.4.2.6.5.6.6s-.2.4-.6.6c-1.3.7-3.5.7-4.8,0-.4-.2-.6-.5-.6-.6v2.8c.9.3,1.9.5,3,.5s2.1-.2,3-.5v-2.8c0-.6.6-1.1,1.3-1.1s1.1.4,1.2.9c0-.9-.8-1.8-1.9-2.3-.7-.4-1.6-.6-2.5-.7h-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-.6,365.1c-.7,0-1.3.5-1.3,1.1v21.9c0-.6.6-1.1,1.3-1.1s1.3.5,1.3,1.1v-22.1c-.1-.5-.6-.9-1.2-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-.6,387c-.7,0-1.3.5-1.3,1.1s-.2.4-.6.6c-1.2.6-3.4.8-4.8,0-.4-.2-.6-.5-.6-.6,0,.6-.6,1.1-1.3,1.1s-1.3-.5-1.3-1.1c0,1,.7,1.9,1.9,2.6,1.1.6,2.4.8,3.6.8s2.8-.3,3.7-.8c1.2-.6,1.8-1.5,1.8-2.5s-.6-1.1-1.3-1.1h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-9.1,389.3c.7,0,1.3-.5,1.3-1.1v-21.9c0-.6-.6-1.1-1.3-1.1s-1.3.5-1.3,1.1v21.9c0,.6.6,1.1,1.3,1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M982.8,106.3l-37.2-19.4-9.2,24.4,37.2,19.4,9.2-24.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.4,183.7c1.4.7,3.6.6,4.8,0,.4-.2.6-.4.6-.6v-19.1c-.9.3-1.9.5-3,.5s-2.1-.2-3-.5v19.1c0,.1.2.4.6.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M978,101.2l-16.7-8.7-1.8-.9-14.1-7.3c-.3-.2-.7-.2-1.1,0-.3,0-.6.4-.8.7l-10,26.6c-.2.5,0,1.1.6,1.4l10.7,5.6,2.5,1.3,11.9,6.2v-.7c0-.6.6-1.1,1.3-1.1s1.3.5,1.3,1.1v2l11.8,6.1c.2.1.4.1.6.1h.4c.4-.1.6-.4.8-.7l10-26.6c.2-.5,0-1.1-.6-1.4l-4.4-2.3-2.5-1.3h0ZM936.4,111.3l9.2-24.4,37.2,19.4-9.2,24.4-37.2-19.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M961.9,125.3c0-.6-.6-1.1-1.3-1.1s-1.3.5-1.3,1.1v32.7c.4,0,.8-.1,1.2-.1h1.3v-32.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M959.4,158c-.8.1-1.6.4-2.2.7-1.2.6-1.9,1.5-1.9,2.6,0-.6.6-1.1,1.3-1.1s1.3.5,1.3,1.1c0-.1.2-.4.6-.6.3-.1.6-.3,1-.3s.8-.1,1.3-.1h0c.4,0,.8,0,1.1.1.5,0,.9.2,1.2.4.4.2.6.5.6.6s-.2.4-.6.6c-1.3.7-3.5.7-4.8,0-.4-.2-.6-.5-.6-.6v2.8c.9.3,1.9.5,3,.5s2.1-.2,3-.5v-2.8c0-.6.6-1.1,1.3-1.1s1.1.4,1.2.9c0-.9-.8-1.8-1.9-2.3-.7-.4-1.6-.6-2.5-.7h-1.3c-.4,0-.8,0-1.2.1h0v-.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M965,160.1c-.7,0-1.3.5-1.3,1.1v21.9c0-.6.6-1.1,1.3-1.1s1.3.5,1.3,1.1v-22.1c0-.5-.6-.9-1.2-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M965,182c-.7,0-1.3.5-1.3,1.1s-.2.4-.6.6c-1.2.6-3.4.8-4.8,0-.4-.2-.6-.5-.6-.6,0,.6-.6,1.1-1.3,1.1s-1.3-.5-1.3-1.1c0,1,.7,1.9,1.9,2.6,1.1.6,2.4.8,3.6.8s2.8-.3,3.7-.8c1.2-.6,1.8-1.5,1.8-2.5s-.6-1.1-1.3-1.1h.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M956.5,184.3c.7,0,1.3-.5,1.3-1.1v-21.9c0-.6-.6-1.1-1.3-1.1s-1.3.5-1.3,1.1v21.9c0,.6.6,1.1,1.3,1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1028.9,534.8l-37.2-19.4-9.2,24.4,37.2,19.4,9.2-24.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.5,612.2c1.4.7,3.6.6,4.8,0,.4-.2.6-.4.6-.6v-19.1c-.9.3-1.9.5-3,.5s-2.1-.2-3-.5v19.1s.2.4.6.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1024.2,529.6l-16.7-8.7-1.8-.9-14.1-7.3c-.3-.2-.7-.2-1.1,0-.3,0-.6.4-.8.7l-10,26.6c-.2.5,0,1.1.6,1.3l10.7,5.6,2.5,1.3,11.9,6.2v-.7c0-.6.6-1.1,1.3-1.1s1.3.5,1.3,1.1v2l11.8,6.1c.2,0,.4.2.6.2h.4c.4,0,.6-.4.8-.7l10-26.6c.2-.5,0-1.1-.6-1.3l-4.4-2.3-2.5-1.3h0v-.2h0ZM982.5,539.8l9.2-24.4,37.2,19.4-9.2,24.4-37.2-19.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1008,553.7c0-.6-.6-1.1-1.3-1.1s-1.3.5-1.3,1.1v32.7h2.5v-32.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1005.5,586.5c-.8,0-1.6.3-2.2.7-1.2.6-1.9,1.5-1.9,2.6,0-.6.6-1.1,1.3-1.1s1.3.5,1.3,1.1c0,0,.2-.4.6-.6.3,0,.6-.3,1-.3s.8,0,1.3-.2h1.2c.5,0,.9.2,1.2.4.4.2.6.5.6.6s-.2.4-.6.6c-1.3.7-3.5.7-4.8,0-.4-.2-.6-.5-.6-.6v2.8c.9.3,1.9.5,3,.5s2.1-.2,3-.5v-2.8c0-.6.6-1.1,1.3-1.1s1.1.4,1.2.9c0-.9-.8-1.8-1.9-2.3-.7-.4-1.6-.6-2.5-.7h-2.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1011.1,588.6c-.7,0-1.3.5-1.3,1.1v21.9c0-.6.6-1.1,1.3-1.1s1.3.5,1.3,1.1v-22.1c0-.5-.6-.9-1.2-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1002.6,612.8c.7,0,1.3-.5,1.3-1.1v-21.9c0-.6-.6-1.1-1.3-1.1s-1.3.5-1.3,1.1v21.9c0,.6.6,1.1,1.3,1.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1011.1,610.5c-.7,0-1.3.5-1.3,1.1s-.2.4-.6.6c-1.2.6-3.4.8-4.8,0-.4-.2-.6-.5-.6-.6,0,.6-.6,1.1-1.3,1.1s-1.3-.5-1.3-1.1c0,1,.7,1.9,1.9,2.6,1.1.6,2.4.8,3.6.8s2.8-.3,3.7-.8c1.2-.6,1.8-1.5,1.8-2.5s-.6-1.1-1.3-1.1h.2,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-18.2,590.8c6.1-3.2,8.5-7.6,6.3-11.8l-4.7-9.9v-.2h0l-19.4-41-24.2,51.1c-2.2,4.3,0,8.7,6.3,11.9,4.4,2.3,10.4,3.7,16.7,3.8h1.2c6.8,0,13.2-1.4,18-3.9h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-43.5,537.5l-12.9,27.3-1.2,2.6-5,10.6c-2.8,5.3,0,11,7.3,14.8,4.5,2.4,10.4,3.8,16.7,4.1v-1.1c0-.6.6-1.1,1.3-1.1s1.3.5,1.3,1.1v1.2c7.3,0,14.1-1.5,19.3-4.2,7.3-3.8,10.1-9.5,7.3-14.8l-4.7-9.9h0v-.3h0l-1.2-2.6-13.1-27.6-1.1-2.4-5.1-10.7c-.2-.4-.7-.7-1.2-.7s-1,.3-1.2.7l-5.1,10.7-1.1,2.4h-.3,0ZM-37.4,594.7c-6.3-.2-12.3-1.5-16.7-3.8-6.1-3.2-8.5-7.6-6.3-11.9l24.2-51.1,19.4,40.9h0v.3l4.7,9.9c2.2,4.2-.1,8.7-6.3,11.8-4.8,2.5-11.2,3.9-18,3.9s-.8,0-1.2,0h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-37.5,611.7c.7,0,1.3-.5,1.3-1.1v-14.8c0-.6-.6-1.1-1.3-1.1s-1.3.5-1.3,1.1v14.8c0,.6.6,1.1,1.3,1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M955.6,296.6c6.2-3.2,8.5-7.6,6.3-11.8l-4.7-9.9v-.2h0l-19.4-41-24.2,51.1c-2.2,4.3,0,8.7,6.2,11.9,4.4,2.3,10.4,3.7,16.7,3.8h1.2c6.8,0,13.2-1.4,18-3.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M930.3,243.4l-12.9,27.3-1.2,2.6-5,10.6c-2.8,5.3,0,11,7.3,14.8,4.5,2.4,10.4,3.8,16.7,4.1v-1.1c0-.6.6-1.1,1.3-1.1s1.3.5,1.3,1.1v1.2c7.3,0,14.1-1.5,19.2-4.2,7.3-3.8,10.1-9.5,7.3-14.8l-4.7-9.9h0v-.3h0l-1.2-2.6-13.1-27.6-1.1-2.4-5.1-10.7c-.2-.4-.7-.7-1.2-.7s-1,.3-1.2.7l-5.1,10.6-1.1,2.4h-.2ZM936.4,300.5c-6.3-.2-12.3-1.5-16.7-3.8-6.1-3.2-8.5-7.6-6.3-11.9l24.2-51.1,19.4,40.9h0v.3l4.8,9.9c2.2,4.2,0,8.7-6.3,11.8-4.8,2.5-11.2,3.9-18,3.9s-.8,0-1.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M936.3,317.6c.7,0,1.3-.5,1.3-1.1v-14.8c0-.6-.6-1.1-1.3-1.1s-1.3.5-1.3,1.1v14.8c0,.6.6,1.1,1.3,1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1136,299.7c6.1-3.2,8.5-7.6,6.3-11.8l-4.7-9.9v-.2h0l-19.4-41-24.2,51.1c-2.2,4.3,0,8.7,6.3,11.9,4.4,2.3,10.4,3.7,16.7,3.8h1.2c6.8,0,13.2-1.4,18-3.9h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1110.7,246.4l-12.9,27.3-1.2,2.6-5,10.6c-2.8,5.3,0,11,7.3,14.8,4.5,2.4,10.4,3.8,16.7,4.1v-1.1c0-.6.6-1.1,1.3-1.1s1.3.5,1.3,1.1v1.2c7.3,0,14.1-1.5,19.2-4.2,7.3-3.8,10.1-9.5,7.3-14.8l-4.7-9.9h0v-.3h0l-1.2-2.6-13.1-27.6-1.1-2.4-5.1-10.7c-.2-.4-.7-.7-1.2-.7s-1,.3-1.2.7l-5.1,10.6-1.1,2.4h-.2ZM1116.8,303.6c-6.3-.2-12.3-1.5-16.7-3.8-6.1-3.2-8.5-7.6-6.3-11.9l24.2-51.1,19.4,40.9h0v.3l4.7,9.9c2.2,4.2,0,8.7-6.3,11.8-4.8,2.5-11.2,3.9-18,3.9s-.8,0-1.2,0h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1116.7,320.6c.7,0,1.3-.5,1.3-1.1v-14.8c0-.6-.6-1.1-1.3-1.1s-1.3.5-1.3,1.1v14.8c0,.6.6,1.1,1.3,1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1049.9,389.9c6.1-3.2,8.5-7.6,6.3-11.8l-4.7-9.9v-.2h0l-19.4-41-24.2,51.1c-2.2,4.3,0,8.7,6.3,11.9,4.4,2.3,10.4,3.7,16.7,3.8h1.2c6.8,0,13.2-1.4,18-3.9h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1024.6,336.6l-12.9,27.3-1.2,2.6-5,10.6c-2.8,5.3,0,11,7.3,14.8,4.5,2.4,10.4,3.8,16.7,4.1v-1.1c0-.6.6-1.1,1.3-1.1s1.3.5,1.3,1.1v1.2c7.3,0,14.1-1.5,19.2-4.2,7.3-3.8,10.1-9.5,7.3-14.8l-4.7-9.9h0v-.3h0l-1.2-2.6-13.1-27.6-1.1-2.4-5.1-10.7c-.2-.4-.7-.7-1.2-.7s-1,.3-1.2.7l-5.1,10.7-1.1,2.4h-.2ZM1030.7,393.8c-6.3-.2-12.3-1.5-16.7-3.8-6.1-3.2-8.5-7.6-6.3-11.9l24.2-51.1,19.4,40.9h0v.3l4.7,9.9c2.2,4.2,0,8.7-6.3,11.8-4.8,2.5-11.2,3.9-18,3.9s-.8,0-1.2,0h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1030.6,410.8c.7,0,1.3-.5,1.3-1.1v-14.8c0-.6-.6-1.1-1.3-1.1s-1.3.5-1.3,1.1v14.8c0,.6.6,1.1,1.3,1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.7,256.7c6.1-3.2,8.5-7.6,6.3-11.8l-4.7-9.9v-.2h0c0-.1-19.4-41-19.4-41l-24.2,51.1c-2.2,4.3,0,8.7,6.2,11.9,4.5,2.3,10.4,3.7,16.7,3.8h1.2c6.8,0,13.2-1.4,18-3.9h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M74.4,203.4l-13,27.3-1.2,2.6-5,10.6c-2.8,5.3,0,11,7.3,14.8,4.5,2.4,10.4,3.8,16.7,4.1v-1.1c0-.6.6-1.1,1.3-1.1s1.3.5,1.3,1.1v1.2c7.3,0,14.1-1.5,19.2-4.2,7.3-3.8,10.1-9.5,7.3-14.8l-4.7-9.9h0v-.3h0l-1.2-2.6-13.1-27.6-1.1-2.4-5.1-10.7c-.2-.4-.7-.7-1.2-.7s-1,.3-1.2.7l-5,10.6-1.1,2.4h-.2ZM80.5,260.5c-6.3-.2-12.3-1.5-16.7-3.8-6.1-3.2-8.5-7.6-6.3-11.9l24.2-51.1,19.4,40.9h0v.3l4.7,9.9c2.2,4.2,0,8.7-6.3,11.8-4.8,2.5-11.2,3.9-18,3.9s-.8,0-1.2,0h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M80.4,277.6c.7,0,1.3-.5,1.3-1.1v-14.8c0-.6-.6-1.1-1.3-1.1s-1.3.5-1.3,1.1v14.8c0,.6.6,1.1,1.3,1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M900.2,671.8c6.1-3.2,8.5-7.6,6.3-11.8l-4.7-9.9v-.2h0l-19.4-41-24.2,51.1c-2.2,4.3,0,8.7,6.2,11.9,4.4,2.3,10.4,3.7,16.7,3.8h1.2c6.8,0,13.2-1.4,18-3.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M874.9,618.5l-12.9,27.3-1.2,2.6-5,10.6c-2.8,5.3,0,11,7.3,14.8,4.5,2.4,10.4,3.8,16.7,4.1v-1.1c0-.6.6-1.1,1.3-1.1s1.3.5,1.3,1.1v1.2c7.3,0,14.1-1.5,19.2-4.2,7.3-3.8,10.1-9.5,7.3-14.8l-4.7-9.9h0v-.3h0l-1.2-2.6-13.1-27.6-1.1-2.4-5.1-10.7c-.2-.4-.7-.7-1.2-.7s-1,.3-1.2.7l-5.1,10.7-1.1,2.4h-.2ZM881,675.7c-6.3-.2-12.3-1.5-16.7-3.8-6.1-3.2-8.5-7.6-6.3-11.9l24.2-51.1,19.4,40.9h0v.3l4.8,9.9c2.2,4.2,0,8.7-6.3,11.8-4.8,2.5-11.2,3.9-18,3.9s-.8,0-1.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M881,692.7c.7,0,1.3-.5,1.3-1.1v-14.8c0-.6-.6-1.1-1.3-1.1s-1.3.5-1.3,1.1v14.8c0,.6.6,1.1,1.3,1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1030.7,268.5l-2.1-4.5h0l-8.1-17.1-10.3,21.7c-.8,1.6,0,3.3,2.5,4.6,1.9,1,4.5,1.6,7.2,1.7h0c3.1,0,6.1-.5,8.2-1.7,2.4-1.3,3.4-3,2.6-4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1023.3,247.3l-1.8-3.7c-.2-.4-.6-.7-1.1-.7s-.9.3-1.1.7l-5.6,11.8-1.9,4-3.9,8.2c-1.4,2.6,0,5.5,3.5,7.3,2,1,4.5,1.7,7.2,1.9v-1c0-.6.5-1.1,1.2-1.1s1.2.5,1.2,1.1v1.1c3.1,0,6.1-.8,8.3-1.9,3.5-1.8,4.9-4.7,3.5-7.3l-2.1-4.5h0l-6.4-13.5-1-2.2h0v-.2h0ZM1019.9,274.7h0c-2.8,0-5.3-.7-7.2-1.7-2.4-1.3-3.4-3-2.5-4.6l10.3-21.7,8.1,17.1h0l2.1,4.5c.8,1.6,0,3.3-2.6,4.6-2.2,1.1-5.1,1.7-8.2,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1019.8,274.7c-.7,0-1.2.5-1.2,1.1v6.6c0,.6.5,1.1,1.2,1.1s1.2-.5,1.2-1.1v-6.6c0-.6-.5-1.1-1.2-1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1104.5,344.4l-2.1-4.5h0l-8.1-17.1-10.3,21.7c-.8,1.6,0,3.3,2.5,4.6,1.9,1,4.5,1.6,7.2,1.7h0c3.1,0,6.1-.5,8.2-1.7,2.4-1.3,3.4-3,2.6-4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1097.1,323.2l-1.8-3.7c-.2-.4-.6-.7-1.1-.7s-.9.3-1.1.7l-5.6,11.8-1.9,4-3.9,8.2c-1.4,2.6,0,5.5,3.5,7.3,2,1,4.5,1.7,7.2,1.9v-1c0-.6.5-1.1,1.2-1.1s1.2.5,1.2,1.1v1.1c3.1,0,6.1-.8,8.3-1.9,3.5-1.8,4.9-4.7,3.5-7.3l-2.1-4.5h0l-6.4-13.5-1-2.2h0v-.2h0ZM1093.7,350.6h0c-2.8,0-5.3-.7-7.2-1.7-2.4-1.3-3.4-3-2.5-4.6l10.3-21.7,8.1,17.1h0l2.1,4.5c.8,1.6,0,3.3-2.6,4.6-2.2,1.1-5.1,1.7-8.2,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1093.6,350.6c-.7,0-1.2.5-1.2,1.1v6.6c0,.6.5,1.1,1.2,1.1s1.2-.5,1.2-1.1v-6.6c0-.6-.5-1.1-1.2-1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M261.9,552.4l-2.1-4.5h0l-8.1-17.1-10.3,21.7c-.8,1.6,0,3.3,2.5,4.6,1.9,1,4.5,1.6,7.2,1.7h0c3.1,0,6.1-.5,8.2-1.7,2.5-1.3,3.4-3,2.6-4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M254.5,531.3l-1.8-3.7c-.2-.4-.6-.7-1.1-.7s-.9.3-1.1.7l-5.6,11.8-1.9,4-3.9,8.2c-1.4,2.6,0,5.5,3.5,7.3,2,1,4.5,1.7,7.2,1.9v-1c0-.6.5-1.1,1.2-1.1s1.2.5,1.2,1.1v1.1c3.1,0,6.1-.8,8.3-1.9,3.5-1.8,4.9-4.7,3.5-7.3l-2.1-4.5h0l-6.4-13.5-1-2.2h0v-.2h0ZM251.1,558.7h0c-2.8,0-5.3-.7-7.2-1.7-2.4-1.3-3.4-3-2.5-4.6l10.3-21.7,8.1,17.1h0l2.1,4.5c.8,1.6,0,3.3-2.6,4.6-2.2,1.1-5.1,1.7-8.2,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M251,558.7c-.7,0-1.2.5-1.2,1.1v6.6c0,.6.5,1.1,1.2,1.1s1.2-.5,1.2-1.1v-6.6c0-.6-.5-1.1-1.2-1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M268.1,615l-2.1-4.5h0l-8.1-17.1-10.3,21.7c-.8,1.6,0,3.3,2.5,4.6,1.9,1,4.5,1.6,7.2,1.7h0c3.1,0,6.1-.5,8.2-1.7,2.5-1.3,3.4-3,2.6-4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M260.6,593.8l-1.8-3.7c-.2-.4-.6-.7-1.1-.7s-.9.3-1.1.7l-5.6,11.8-1.9,4-3.9,8.2c-1.4,2.6,0,5.5,3.5,7.3,2,1,4.5,1.7,7.2,1.9v-1c0-.6.5-1.1,1.2-1.1s1.2.5,1.2,1.1v1.1c3.1,0,6.1-.8,8.3-1.9,3.5-1.8,4.9-4.7,3.5-7.3l-2.1-4.5h0l-6.4-13.5-1-2.2h0v-.2h0ZM257.3,621.2h0c-2.8,0-5.3-.7-7.2-1.7-2.4-1.3-3.4-3-2.5-4.6l10.3-21.7,8.1,17.1h0l2.1,4.5c.8,1.6,0,3.3-2.6,4.6-2.2,1.1-5.1,1.7-8.2,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M257.2,621.2c-.7,0-1.2.5-1.2,1.1v6.6c0,.6.5,1.1,1.2,1.1s1.2-.5,1.2-1.1v-6.6c0-.6-.5-1.1-1.2-1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M40.5,396.6l-2.1-4.5h0l-8.1-17.1-10.3,21.7c-.9,1.6.1,3.3,2.5,4.6,1.9,1,4.5,1.6,7.2,1.7h0c3.1,0,6.1-.5,8.2-1.7,2.5-1.3,3.4-3,2.6-4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M33.1,375.5l-1.8-3.7c-.2-.4-.6-.7-1.1-.7s-.9.3-1.1.7l-5.6,11.8-1.9,4-3.9,8.2c-1.4,2.6,0,5.5,3.5,7.3,2,1,4.5,1.7,7.2,1.9v-1c0-.6.5-1.1,1.2-1.1s1.2.5,1.2,1.1v1.1c3.1,0,6.1-.8,8.3-1.9,3.5-1.8,4.9-4.7,3.5-7.3l-2.1-4.5h0v-.2l-6.4-13.5-1-2.2h0ZM29.7,402.9h0c-2.8,0-5.3-.7-7.2-1.7-2.4-1.3-3.4-3-2.5-4.6l10.3-21.7,8.1,17.1h0v.2l2.1,4.5c.8,1.6,0,3.3-2.6,4.6-2.2,1.1-5.1,1.7-8.2,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M29.6,402.9c-.7,0-1.2.5-1.2,1.1v6.6c0,.6.5,1.1,1.2,1.1s1.2-.5,1.2-1.1v-6.6c0-.6-.5-1.1-1.2-1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M-30.2,201.9l-2.1-4.5h0l-8.1-17.1-10.3,21.7c-.9,1.6,0,3.4,2.5,4.6,1.9,1,4.5,1.6,7.2,1.6h0c3.1,0,6.1-.5,8.2-1.6,2.4-1.3,3.4-3,2.6-4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-37.7,180.7l-1.8-3.7c-.2-.4-.6-.7-1.1-.7s-.9.3-1.1.7l-5.6,11.8-1.9,4-3.9,8.2c-1.4,2.6,0,5.5,3.5,7.4,2,1,4.5,1.7,7.2,1.9v-1c0-.6.5-1.1,1.2-1.1s1.2.5,1.2,1.1v1.1c3.1,0,6.1-.8,8.3-1.9,3.5-1.8,4.9-4.7,3.5-7.3l-2.1-4.5h0c0-.1-6.4-13.6-6.4-13.6l-1-2.2h0s0-.2,0-.2ZM-41,208.1h0c-2.8,0-5.3-.7-7.2-1.7-2.4-1.3-3.4-3-2.5-4.6l10.3-21.7,8.1,17.1h0c0,.1,2.1,4.6,2.1,4.6.8,1.6-.1,3.3-2.6,4.6-2.2,1.1-5.1,1.7-8.2,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-41.1,208.1c-.7,0-1.2.5-1.2,1.1v6.6c0,.6.5,1.1,1.2,1.1s1.2-.5,1.2-1.1v-6.6c0-.6-.5-1.1-1.2-1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M6.7,227.5l-2.1-4.5h0l-8.1-17.1-10.3,21.7c-.9,1.6.1,3.4,2.5,4.6,1.9,1,4.5,1.6,7.2,1.6h0c3.1,0,6.1-.5,8.2-1.6,2.5-1.3,3.4-3,2.6-4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-.8,206.3l-1.8-3.7c-.2-.4-.6-.7-1.1-.7s-.9.3-1.1.7l-5.6,11.8-1.9,4-3.9,8.2c-1.4,2.6,0,5.5,3.5,7.4,2,1,4.5,1.7,7.2,1.9v-1c0-.6.5-1.1,1.2-1.1s1.2.5,1.2,1.1v1.1C0,236,3,235.2,5.2,234.1c3.5-1.8,4.9-4.7,3.5-7.3l-2.1-4.5h0L.2,208.8l-1-2.2h0v-.3ZM-4.1,233.7h0c-2.8,0-5.3-.7-7.2-1.7-2.4-1.3-3.4-3-2.5-4.6l10.3-21.7,8.1,17.1h0l2.1,4.5c.8,1.6,0,3.3-2.6,4.6-2.2,1.1-5.1,1.7-8.2,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-4.2,233.7c-.7,0-1.2.5-1.2,1.1v6.6c0,.6.5,1.1,1.2,1.1s1.2-.5,1.2-1.1v-6.6c0-.6-.5-1.1-1.2-1.1h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1139.4,568.8l-2.1-4.5h0l-8.1-17.1-10.3,21.7c-.8,1.6,0,3.3,2.5,4.6,1.9,1,4.5,1.6,7.2,1.7h0c3.1,0,6.1-.5,8.2-1.7,2.4-1.3,3.4-3,2.6-4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1131.9,547.7l-1.8-3.7c-.2-.4-.6-.7-1.1-.7s-.9.3-1.1.7l-5.6,11.8-1.9,4-3.9,8.2c-1.4,2.6,0,5.5,3.5,7.3,2,1,4.5,1.7,7.2,1.9v-1c0-.6.5-1.1,1.2-1.1s1.2.5,1.2,1.1v1.1c3.1,0,6.1-.8,8.3-1.9,3.5-1.8,4.9-4.7,3.5-7.3l-2.1-4.5h0l-6.4-13.5-1-2.2h0v-.2h0ZM1128.6,575.1h0c-2.8,0-5.3-.7-7.2-1.7-2.4-1.3-3.4-3-2.5-4.6l10.3-21.7,8.1,17.1h0l2.1,4.5c.8,1.6,0,3.3-2.6,4.6s-5.1,1.7-8.2,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1128.5,575.1c-.7,0-1.2.5-1.2,1.1v6.6c0,.6.5,1.1,1.2,1.1s1.2-.5,1.2-1.1v-6.6c0-.6-.5-1.1-1.2-1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M992.8,335.1l-2.1-4.5h0l-8.1-17.1-10.3,21.7c-.8,1.6,0,3.3,2.5,4.6,1.9,1,4.5,1.6,7.2,1.7h0c3.1,0,6.1-.5,8.2-1.7,2.4-1.3,3.4-3,2.6-4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M985.3,314l-1.8-3.7c-.2-.4-.6-.7-1.1-.7s-.9.3-1.1.7l-5.6,11.8-1.9,4-3.9,8.2c-1.4,2.6,0,5.5,3.5,7.3,2,1,4.5,1.7,7.2,1.9v-1c0-.6.5-1.1,1.2-1.1s1.2.5,1.2,1.1v1.1c3.1,0,6.1-.8,8.3-1.9,3.5-1.8,4.9-4.7,3.5-7.3l-2.1-4.5h0l-6.4-13.5-1-2.2h0v-.2h0ZM982,341.4h0c-2.8,0-5.3-.7-7.2-1.7-2.4-1.3-3.4-3-2.5-4.6l10.3-21.7,8.1,17.1h0l2.1,4.5c.8,1.6,0,3.3-2.6,4.6-2.2,1.1-5.1,1.7-8.2,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M981.9,341.4c-.7,0-1.2.5-1.2,1.1v6.6c0,.6.5,1.1,1.2,1.1s1.2-.5,1.2-1.1v-6.6c0-.6-.5-1.1-1.2-1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1177.3,590.4l-2.1-4.5h0l-8.1-17.1-10.3,21.7c-.8,1.6,0,3.3,2.5,4.6,1.9,1,4.5,1.6,7.2,1.7h0c3.1,0,6.1-.5,8.2-1.7,2.4-1.3,3.4-3,2.6-4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1169.8,569.2l-1.8-3.7c-.2-.4-.6-.7-1.1-.7s-.9.3-1.1.7l-5.6,11.8-1.9,4-3.9,8.2c-1.4,2.6,0,5.5,3.5,7.3,2,1,4.5,1.7,7.2,1.9v-1c0-.6.5-1.1,1.2-1.1s1.2.5,1.2,1.1v1.1c3.1,0,6.1-.8,8.3-1.9,3.5-1.8,4.9-4.7,3.5-7.3l-2.1-4.5h0l-6.4-13.5-1-2.2h0v-.2h0ZM1166.5,596.6h0c-2.8,0-5.3-.7-7.2-1.7-2.4-1.3-3.4-3-2.5-4.6l10.3-21.7,8.1,17.1h0l2.1,4.5c.8,1.6,0,3.3-2.6,4.6s-5.1,1.7-8.2,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1166.4,596.6c-.7,0-1.2.5-1.2,1.1v6.6c0,.6.5,1.1,1.2,1.1s1.2-.5,1.2-1.1v-6.6c0-.6-.5-1.1-1.2-1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1017.4-83.8l-2.1-4.5h0l-8.1-17.1-10.3,21.7c-.8,1.6,0,3.4,2.5,4.6,1.9,1,4.5,1.6,7.2,1.7h0c3.1,0,6.1-.5,8.2-1.7,2.4-1.3,3.4-3,2.6-4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1010-105l-1.8-3.7c-.2-.4-.6-.7-1.1-.7s-.9.3-1.1.7l-5.6,11.8-1.9,3.9-3.9,8.2c-1.4,2.6,0,5.5,3.5,7.4,2,1,4.5,1.7,7.2,1.9v-1c0-.6.5-1.1,1.2-1.1s1.2.5,1.2,1.1v1.1c3.1,0,6.1-.8,8.3-1.9,3.5-1.8,4.9-4.7,3.5-7.3l-2.1-4.4h0l-6.4-13.5-1-2.2h0v-.3h0ZM1006.7-77.6h0c-2.8,0-5.3-.7-7.2-1.7-2.4-1.3-3.4-3-2.5-4.6l10.3-21.7,8.1,17.1h0l2.1,4.5c.8,1.6,0,3.3-2.6,4.6-2.2,1.1-5.1,1.7-8.2,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1006.6-77.6c-.7,0-1.2.5-1.2,1.1v6.6c0,.6.5,1.1,1.2,1.1s1.2-.5,1.2-1.1v-6.6c0-.6-.5-1.1-1.2-1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1055.1,242.8c-1.6-.3-3.1-.7-4.7-1.2-4-1.8-7.7-4.4-10.4-7.5,1.6,5.9,5.9,10.9,12.1,13.8,2.9,1.3,6.1,2.1,9.3,2.2v-3.9c-2.3-.8-4.5-1.9-6.4-3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.4,241.6c1.6.5,3.1,1,4.7,1.2-1.8-1.3-3.3-2.9-4.8-4.8-.3-.5-.2-1.1.3-1.4s1.2-.2,1.6.3c2.2,2.9,4.6,4.9,7.5,6.4h1.7v-10.1c0-.6.5-1,1.1-1s1.2.5,1.2,1v3.6c3-.3,5.7-1.2,7.8-2.6.5-.4,1.2-.3,1.6.2s.3,1.1-.2,1.5c-2.5,1.7-5.7,2.8-9.2,3.1v4.1c5.7-.9,10.8-3.8,14.7-8.5,3.1-4.2,4.9-8.7,5.6-13.3-3.5-7.6-11.8-13-21.5-13s-23.3,9.4-23.3,21,.2,3.4.7,5c2.7,3.2,6.4,5.7,10.4,7.5h0v-.2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1081.7,213.7c-4.7-4.7-11.5-7.6-19-7.6s-13.7,2.7-18.4,7c-.6.6-1.2,1.2-1.7,1.8-3.4,3.9-5.4,8.9-5.4,14.2,0,8.8,5.4,16.6,14,20.6,3.2,1.5,6.7,2.3,10.4,2.4v-2.1c-3.3,0-6.4-.9-9.3-2.2-6.2-2.8-10.5-7.9-12.1-13.8-.4-1.6-.7-3.3-.7-5,0-11.6,10.4-21,23.3-21s18,5.4,21.5,13c1.1,2.5,1.8,5.2,1.8,8,0,8-4.9,15.1-12.8,18.7-2.9,1.3-6.1,2.1-9.3,2.2v2.1c3.6,0,7.1-1,10.4-2.4,8.7-4,14-11.8,14-20.6s-1.8-9.7-4.9-13.5c-.5-.6-1.1-1.3-1.7-1.9h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1063.8,250.1v-11.3h-1.1c-.6,0-1.1-.4-1.1-1s.5-1.1,1.1-1.1h1.2v-3.6c0-.6-.5-1-1.2-1s-1.1.5-1.1,1v10.9c.5.2,1,.4,1.5.5.6.2.9.8.7,1.3-.2.4-.6.7-1.1.7s-.2,0-.4,0c-.3,0-.5-.2-.8-.2v22.6c0,.6.5,1,1.1,1s1.2-.5,1.2-1v-18.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1052.3,236.9c-.3-.5-1.1-.6-1.6-.3s-.7,1-.3,1.4c1.4,1.9,3,3.5,4.8,4.8,1.9,1.4,4,2.5,6.4,3.3.3,0,.5.2.8.2h.4c.5,0,.9-.3,1.1-.7.2-.5,0-1.1-.7-1.3-.5-.2-1-.3-1.5-.5-.6-.2-1.2-.5-1.7-.7-2.9-1.4-5.4-3.5-7.5-6.4h0l-.2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1073.2,234.3c-.4-.5-1.1-.5-1.6-.2-2.1,1.5-4.8,2.4-7.8,2.6h-1.2c-.6,0-1.1.5-1.1,1.1s.5,1,1.1,1h1.1c3.6-.3,6.7-1.3,9.2-3.1.5-.4.6-1,.2-1.5h.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1064.4,559.6c-1.6-.3-3.1-.7-4.7-1.2-4-1.8-7.7-4.3-10.4-7.5,1.6,5.9,5.9,10.9,12.1,13.8,2.9,1.3,6.1,2.1,9.3,2.2v-3.9c-2.3-.8-4.5-1.9-6.4-3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1059.7,558.4c1.6.5,3.1,1,4.7,1.2-1.8-1.3-3.3-2.9-4.8-4.8-.3-.5-.2-1.1.3-1.4s1.2-.2,1.6.3c2.2,2.9,4.6,4.9,7.5,6.4h1.7v-10.1c0-.6.5-1,1.1-1s1.2.5,1.2,1v3.6c3-.3,5.7-1.2,7.8-2.6.5-.3,1.2-.3,1.6.2s.3,1.1-.2,1.5c-2.5,1.7-5.7,2.8-9.2,3.1v4.1c5.7-.9,10.8-3.8,14.7-8.5,3.1-4.2,4.9-8.7,5.6-13.3-3.5-7.6-11.8-13-21.5-13s-23.3,9.4-23.3,21,.2,3.4.7,5c2.7,3.2,6.4,5.8,10.4,7.5h0v-.2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1090.9,530.4c-4.7-4.7-11.5-7.7-19-7.7s-13.7,2.7-18.4,7c-.6.6-1.2,1.2-1.7,1.8-3.4,3.9-5.4,8.9-5.4,14.2,0,8.8,5.4,16.6,14,20.6,3.2,1.5,6.7,2.3,10.4,2.4v-2.1c-3.3,0-6.4-.9-9.3-2.2-6.2-2.8-10.5-7.9-12.1-13.8-.4-1.6-.7-3.3-.7-5,0-11.6,10.4-21,23.3-21s18,5.4,21.5,13c1.1,2.5,1.8,5.2,1.8,8,0,8-4.9,15.1-12.8,18.7-2.9,1.3-6.1,2.1-9.3,2.2v2.1c3.6,0,7.1-1,10.4-2.4,8.7-4,14-11.8,14-20.6s-1.8-9.7-4.9-13.5c-.5-.7-1.1-1.3-1.7-1.9h0v.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1073,566.8v-11.3h-1.1c-.6,0-1.1-.4-1.1-1s.5-1.1,1.1-1.1h1.2v-3.6c0-.6-.5-1-1.2-1s-1.1.5-1.1,1v10.9c.5.2,1,.4,1.5.5.6.2.9.8.7,1.3-.2.4-.6.7-1.1.7s-.2,0-.4,0c-.3,0-.5-.2-.8-.2v22.6c0,.6.5,1,1.1,1s1.2-.5,1.2-1v-18.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1061.5,553.6c-.3-.5-1.1-.6-1.6-.3s-.7,1-.3,1.4c1.4,1.9,3,3.5,4.8,4.8,1.9,1.4,4,2.5,6.4,3.3.3,0,.5.2.8.2h.4c.5,0,.9-.3,1.1-.7.2-.5,0-1.1-.7-1.3-.5-.2-1-.3-1.5-.5-.6-.2-1.2-.5-1.7-.7-2.9-1.4-5.4-3.5-7.5-6.4h0l-.2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1082.5,551c-.4-.5-1.1-.5-1.6-.2-2.1,1.5-4.8,2.3-7.8,2.6h-1.2c-.6,0-1.1.5-1.1,1.1s.5,1,1.1,1h1.1c3.6-.3,6.7-1.3,9.2-3.1.5-.3.6-1,.2-1.5h.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M763,716.4c-1.6-.3-3.1-.7-4.7-1.2-4-1.8-7.7-4.3-10.4-7.5,1.6,5.9,5.9,10.9,12.1,13.8,2.9,1.3,6.1,2.1,9.3,2.2v-3.9c-2.3-.8-4.5-1.9-6.4-3.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M758.3,715.2c1.6.5,3.1,1,4.7,1.2-1.8-1.3-3.3-2.9-4.8-4.8-.3-.5-.2-1.1.3-1.4s1.2-.2,1.6.3c2.2,2.9,4.6,4.9,7.5,6.4h1.7v-10.1c0-.6.5-1,1.1-1s1.1.5,1.1,1v3.6c3-.3,5.7-1.2,7.8-2.6.5-.3,1.2-.3,1.6.2s.3,1.1-.2,1.5c-2.5,1.7-5.7,2.8-9.2,3.1v12.4c5.6-.9,15-4.9,18.9-9.5,3.1-4.2,5.6-14,1.4-20.5-4.6-7-11.8-13-21.5-13s-23.3,9.4-23.3,21,.2,3.4.7,5c2.7,3.2,6.4,5.8,10.4,7.5h0l.2-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M789.5,687.3c-4.7-4.7-11.5-7.7-19-7.7s-13.7,2.7-18.4,7c-.6.6-1.2,1.2-1.7,1.8-3.4,3.9-5.5,8.9-5.5,14.2,0,8.8,5.4,16.6,14,20.6,3.2,1.5,6.7,2.3,10.4,2.4v-2.1c-3.3,0-6.4-.9-9.3-2.2-6.2-2.8-10.5-7.9-12.1-13.8-.4-1.6-.7-3.3-.7-5,0-11.6,10.4-21,23.3-21s18,5.4,21.5,13c1.1,2.5,1.8,5.2,1.8,8,0,8-4.9,15.1-12.8,18.7-2.9,1.3-6,2.1-9.3,2.2v2.1c3.6,0,7.1-1,10.4-2.4,8.7-4,14-11.8,14-20.6s-1.8-9.7-4.9-13.5c-.5-.7-1.1-1.3-1.7-1.9h0v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M771.7,723.6v-11.3h-1.1c-.6,0-1.1-.4-1.1-1s.5-1.1,1.1-1.1h1.2v-3.6c0-.6-.5-1-1.1-1s-1.1.5-1.1,1v10.9c.5.2,1,.4,1.5.5.6.2.9.8.7,1.3-.2.4-.6.7-1.1.7s-.2,0-.4,0c-.3,0-.5-.2-.8-.2v22.6c0,.6.5,1,1.1,1s1.1-.5,1.1-1v-18.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M760.1,710.4c-.3-.5-1.1-.6-1.6-.3s-.7,1-.3,1.4c1.4,1.9,3,3.5,4.8,4.8,1.9,1.4,4,2.5,6.4,3.3.3,0,.5.2.8.2h.4c.5,0,.9-.3,1.1-.7.2-.5,0-1.1-.7-1.3-.5-.2-1-.3-1.5-.5-.6-.2-1.2-.5-1.7-.7-2.9-1.4-5.4-3.5-7.5-6.4h0l-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M781.1,707.8c-.4-.5-1.1-.5-1.6-.2-2.1,1.5-4.8,2.3-7.8,2.6h-1.2c-.6,0-1.1.5-1.1,1.1s.5,1,1.1,1h1.1c3.6-.3,6.7-1.3,9.2-3.1.5-.3.6-1,.2-1.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M501.4,664.2c-1.6-.3-3.1-.7-4.7-1.2-4-1.8-7.7-4.3-10.4-7.5,1.6,5.9,5.9,10.9,12.1,13.8,2.9,1.3,6.1,2.1,9.3,2.2v-3.9c-2.3-.8-4.5-1.9-6.4-3.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M496.7,663c1.6.5,3.1,1,4.7,1.2-1.8-1.3-3.3-2.9-4.8-4.8-.3-.5-.2-1.1.3-1.4s1.2-.2,1.6.3c2.2,2.9,4.6,4.9,7.5,6.4h1.7v-10.1c0-.6.5-1,1.1-1s1.1.5,1.1,1v3.6c3-.3,5.7-1.2,7.8-2.6.5-.3,1.2-.3,1.6.2.4.5.3,1.1-.2,1.5-2.5,1.7-5.7,2.8-9.2,3.1v12.4c5.6-.9,15-4.9,18.9-9.5,3.1-4.2,5.6-14,1.4-20.5-4.6-7-11.8-13-21.5-13s-23.3,9.4-23.3,21,.2,3.4.7,5c2.7,3.2,6.4,5.8,10.4,7.5h0l.2-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M527.9,635c-4.7-4.7-11.5-7.7-19-7.7s-13.7,2.7-18.4,7c-.6.6-1.2,1.2-1.7,1.8-3.4,3.9-5.5,8.9-5.5,14.2,0,8.8,5.4,16.6,14,20.6,3.2,1.5,6.7,2.3,10.4,2.4v-2.1c-3.3,0-6.4-.9-9.3-2.2-6.2-2.8-10.5-7.9-12.1-13.8-.4-1.6-.7-3.3-.7-5,0-11.6,10.4-21,23.3-21s18,5.4,21.5,13c1.1,2.5,1.8,5.2,1.8,8,0,8-4.9,15.1-12.8,18.7-2.9,1.3-6,2.1-9.3,2.2v2.1c3.6,0,7.1-1,10.4-2.4,8.7-4,14-11.8,14-20.6s-1.8-9.7-4.9-13.5c-.5-.7-1.1-1.3-1.7-1.9h0v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M510.1,671.4v-11.3h-1.1c-.6,0-1.1-.4-1.1-1s.5-1.1,1.1-1.1h1.2v-3.6c0-.6-.5-1-1.1-1s-1.1.5-1.1,1v10.9c.5.2,1,.4,1.5.5.6.2.9.8.7,1.3-.2.4-.6.7-1.1.7s-.2,0-.4,0c-.3,0-.5-.2-.8-.2v22.6c0,.6.5,1,1.1,1s1.1-.5,1.1-1v-18.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M498.5,658.2c-.3-.5-1.1-.6-1.6-.3s-.7,1-.3,1.4c1.4,1.9,3,3.5,4.8,4.8,1.9,1.4,4,2.5,6.4,3.3.3,0,.5.2.8.2h.4c.5,0,.9-.3,1.1-.7.2-.5,0-1.1-.7-1.3-.5-.2-1-.3-1.5-.5-.6-.2-1.2-.5-1.7-.7-2.9-1.4-5.4-3.5-7.5-6.4h0l-.2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M519.5,655.6c-.4-.5-1.1-.5-1.6-.2-2.1,1.5-4.8,2.3-7.8,2.6h-1.2c-.6,0-1.1.5-1.1,1.1s.5,1,1.1,1h1.1c3.5-.3,6.7-1.3,9.2-3.1.5-.3.6-1,.2-1.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M998.8,48.1c-1.6-.3-3.1-.7-4.7-1.2-4-1.8-7.7-4.4-10.4-7.5,1.6,5.9,5.9,10.9,12.1,13.8,2.9,1.3,6.1,2.1,9.3,2.2v-3.9c-2.3-.8-4.5-1.9-6.4-3.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.1,46.9c1.6.5,3.1,1,4.7,1.2-1.8-1.3-3.3-2.9-4.8-4.8-.3-.5-.2-1.1.3-1.4s1.2-.2,1.6.3c2.2,2.9,4.6,4.9,7.5,6.4h1.7v-10.1c0-.6.5-1,1.1-1s1.2.5,1.2,1v3.6c3-.3,5.7-1.2,7.8-2.6.5-.4,1.2-.3,1.6.2s.3,1.1-.2,1.5c-2.5,1.7-5.7,2.8-9.2,3.1v12.4c5.7-.9,15.1-4.9,18.9-9.5,3.1-4.2,5.6-14,1.4-20.5-4.6-7-11.8-13-21.5-13s-23.3,9.4-23.3,21,.2,3.4.7,5c2.7,3.2,6.4,5.8,10.4,7.5h0v-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1025.3,18.9c-4.7-4.7-11.5-7.6-19-7.6s-13.7,2.7-18.4,7c-.6.6-1.2,1.2-1.7,1.8-3.4,3.9-5.4,8.9-5.4,14.2,0,8.8,5.4,16.6,14,20.6,3.2,1.5,6.7,2.3,10.4,2.4v-2.1c-3.3,0-6.4-.9-9.3-2.2-6.2-2.8-10.5-7.9-12.1-13.8-.4-1.6-.7-3.3-.7-5,0-11.6,10.4-21,23.3-21s18,5.4,21.5,13c1.1,2.5,1.8,5.2,1.8,8,0,8-4.9,15.1-12.8,18.7-2.9,1.3-6.1,2.1-9.3,2.2v2.1c3.6,0,7.1-1,10.4-2.4,8.7-4,14-11.8,14-20.6s-1.8-9.7-4.9-13.5c-.5-.6-1.1-1.3-1.7-1.9h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1007.4,55.3v-11.3h-1.1c-.6,0-1.1-.4-1.1-1s.5-1.1,1.1-1.1h1.2v-3.6c0-.6-.5-1-1.2-1s-1.1.5-1.1,1v10.9c.5.2,1,.4,1.5.5.6.2.9.8.7,1.3-.2.4-.6.7-1.1.7s-.2,0-.4,0c-.3,0-.5-.2-.8-.2v22.6c0,.6.5,1,1.1,1s1.2-.5,1.2-1v-18.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M995.9,42.1c-.3-.5-1.1-.6-1.6-.3s-.7,1-.3,1.4c1.4,1.9,3,3.5,4.8,4.8,1.9,1.4,4,2.5,6.4,3.3.3,0,.5.2.8.2h.4c.5,0,.9-.3,1.1-.7.2-.5,0-1.1-.7-1.3-.5,0-1-.3-1.5-.5-.6-.2-1.2-.5-1.7-.7-2.9-1.4-5.4-3.5-7.5-6.4h0l-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1016.9,39.5c-.4-.5-1.1-.5-1.6-.2-2.1,1.5-4.8,2.4-7.8,2.6h-1.2c-.6,0-1.1.5-1.1,1.1s.5,1,1.1,1h1.1c3.6-.3,6.7-1.3,9.2-3.1.5-.4.6-1,.2-1.5h0Z"
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st23",
    y: 9.5,
    width: 1418.5,
    height: 502.5,
    rx: 24.4,
    ry: 24.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoHomeD);
export default __webpack_public_path__ + "static/media/Fondo_HomeD.5f55a211b370c2d5e45fa1570cc8034a.svg";
export { ForwardRef as ReactComponent };